































































































































































































































































































































































































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import { getEnv } from '@/runtime-config';
import SideToolbar from '@/components/SideToolbar.vue';
import {ITableHeaders, TableHeaders} from '@/interfaces/components-data';
import DatePicker from 'vue2-datepicker';
import {ISupersetFields} from '@/interfaces/common'
import {
    CalcIndividualConfig,
    CodeOKRB,
    Coefficents,
    ConfigMap,
    FindFiltersParams,
    IndividualConfig,
    Promotions,
    Sales,
    SelectBox,
    SelectMarket,
    StrategyOfPriceOpt,
    TaskInfoCalc,
} from '@/interfaces/global-data';
import {
    BaseFilter,
    BaseFilterRoundingRules,
    CalcFilters,
    CalcIndividualConfigMap,
    CategoryStrategies,
    CompetitorsPriceFilter,
    competitorsPriceMethodsSb,
    CompetitorsPriceStrategies,
    competitorsPriceStrategiesSb,
    FileType,
    GetTaskInfo,
    IndividualConfigCmd,
    InternalCodeAndProductRange,
    KviStrategies,
    kviStrategiesSet,
    NewProductPriceStrategy,
    PercentileTypes,
    ProductSegmentIdAndName,
    RegularCompetitorsPricesView,
    RoundingRulesFilter,
    Segment,
    Sku,
    SkuFilter,
    SmallEventFilterTree,
    SortingField,
    TaskAndFile,
    TaskData,
    TaskInfoFilterType,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {parseRisonForSP} from '@/utils/parseRisonForSP'
import {BFormFile, BTabs, BvModalEvent} from 'bootstrap-vue';
import _, {isNull} from 'lodash';
import moment from 'moment';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {compareNumber} from "@/utils/arrayUtils";
import {CompetitorsPriceRow} from "@/interfaces/competitors-price-row";
import CollapseCard from "@/components/UI/CollapseCard.vue"
import {BTable} from "bootstrap-vue/src/components/table";
import Card from '@/components/UI/Card.vue';
import Modal from '@/components/UI/Modal.vue';
import {IidAndName} from "@/pages/ModuleItems/data";
import {IModuleItemResponseDto, TModuleType} from "@/pages/ModuleItems/data";


@Component({
    components: {
        ResultView,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        LocalData,
        HintsContainer,
        DatePicker,
        CollapseCard,
        Card,
        Modal,
        CSelect
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD.MM.YYYY');
            }
        },
        formatRulesDate: (v: any) => {
            if (v) {
                return moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss');
            }
        },
        formatCompetitorsDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('YYYY-MM-DD');
            }
        },
    },
    methods: {
        changeRowColorInDetailReport(item) {
            if (item !== null) {
                if (item.kvi === 'ДА') {
                    return 'table-primary';
                }
                if (item.resultType === 'COMPETITOR') {
                    return 'table-danger';
                }
            }
        },
        formatNumber(number) {
            if (String(number)[0] === '-') {
                return String(number).substring(0, 4);
            } else {
                return String(number).substring(0, 3);
            }
        },
        replaceCommaFormatter(value) {
            return value.replace(',', '.')
        },
        replaceDecimalFormatter(value) {
            if (value == null) {
                return null
            } else {
                return parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
            }
        },
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '').substring(0, 2);
            }
        },
        replaceTxtToNumberForRoundingRules(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})
export default class CompetitorsPricesList extends Mixins(LocalData, Toast, Http) {
    @Prop() readonly moduleType!: TModuleType;
    @Prop({required: true}) readonly itemFromList: IModuleItemResponseDto = {} as IModuleItemResponseDto;

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    @Watch('itemFromList', {deep: true})
    onItemFromListChanged(itemFromList: string, oldValue: string) {
        // @ts-ignore

        if (itemFromList.id !== null && itemFromList.id !== -1 && itemFromList.id !== oldValue.id) {
            // this.$calc = {
            //     ...this.$calc,
            //     categoryOfProduct: this.itemFromList.productCategory.id,
            //     clusterSelected: this.itemFromList.cluster ? null : this.itemFromList.cluster.id,
            //     formatSelected: this.itemFromList.format.id,
            //     groupOfProduct: this.itemFromList.productGroup.id,
            //     subcategories: !this.itemFromList.subcategory || this.itemFromList.subcategory.id == null || this.itemFromList.subcategory.id <= 0 ? null : [this.itemFromList.subcategory.id],
            //     tradingId: 68,
            //     categoryOfProduct: this.itemFromList.productCategory.id,
            //     regionSelected: [this.itemFromList.region.id],
            // }

            this.listCompetitors({currentPage: 1, pageSize: 50}, () => {});

            this.initTaskModuleItem();
        }
    }

    private comptetitorsTabData: any = {};

    /*get saveStateForRoundingRules(): boolean {
        return !((this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct > 0)
                || (this.$roundingRules.categoryOfProduct != null && this.$roundingRules.categoryOfProduct > 0))
    }*/

    panelSkuModal: boolean = false;

    get saveStateForRoundingRules(): boolean {
        return (this.$roundingRules.selectMarket.id == null)
    }

    get paramsSum(): boolean {
        const u = this.$calc.uvwParams.u;
        const v = this.$calc.uvwParams.v;
        const w = this.$calc.uvwParams.w;
        if (u.toString().length === 0 || v.toString().length === 0 || w.toString().length === 0) {
            return false;
        }
        const sum = (+v + +u + +w);
        return sum === 100;
    }

    get paramsSumXYZ(): boolean {
        const x = this.$calc.xyzParams.x;
        const y = this.$calc.xyzParams.y;
        const z = this.$calc.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get paramsSumXYZForSetupMaster(): boolean {
        const x = this.$setupMasterCalc.xyzParams.x;
        const y = this.$setupMasterCalc.xyzParams.y;
        const z = this.$setupMasterCalc.xyzParams.z;
        if (x.toString().length === 0 || y.toString().length === 0 || z.toString().length === 0) {
            return false;
        }
        const sum = (x + y + z);
        return sum === 100;
    }

    get calculationDepthValidate(): boolean {
        return this.$calc.calculationDepth * 7 >= this.$calc.calculationDay;
    }

    get setupMasterCalculationDepthValidate(): boolean {
        return this.$setupMasterCalc.calculationDepth * 7 >= this.$setupMasterCalc.calculationDay;
    }

    get calculationDayValidate(): boolean {
        return this.$calc.calculationDay > 0;
    }

    get setupMasterCalculationDayValidate(): boolean {
        return this.$setupMasterCalc.calculationDay > 0;
    }

    get priceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$calc.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    get setupMasterPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.$setupMasterCalc.priceIncreaseLimit;
        return priceIncreaseLimit.toString() !== '' && priceIncreaseLimit >= 0;
    }

    get priceDecreaseLimitValidate(): boolean {
        const priceDecreaseLimit = this.$calc.priceDecreaseLimit;
        return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    get setupMasterPriceDecreaseLimitValidate(): boolean {
        const priceDecreaseLimit = this.$setupMasterCalc.priceDecreaseLimit;
        return priceDecreaseLimit != null && priceDecreaseLimit.toString() !== '' && priceDecreaseLimit >= 0;
    }

    get kviPriceDecreaseLimitValidate(): boolean {
        const kviPriceDecreaseLimit = this.$calc.kviPriceDecreaseLimit;
        return kviPriceDecreaseLimit != null && kviPriceDecreaseLimit.toString() !== '' && kviPriceDecreaseLimit >= 0;
    }

    get setupMasterKviPriceDecreaseLimitValidate(): boolean {
        const kviPriceDecreaseLimit = this.$setupMasterCalc.kviPriceDecreaseLimit;
        return kviPriceDecreaseLimit != null && kviPriceDecreaseLimit.toString() !== '' && kviPriceDecreaseLimit >= 0;
    }

    get compPriceDecreaseLimitValidate(): boolean {
        const compPriceDecreaseLimit = this.$calc.compPriceDecreaseLimit;
        return compPriceDecreaseLimit != null && compPriceDecreaseLimit.toString() !== '' && compPriceDecreaseLimit >= 0;
    }

    get setupMasterCompPriceDecreaseLimitValidate(): boolean {
        const compPriceDecreaseLimit = this.$setupMasterCalc.compPriceDecreaseLimit;
        return compPriceDecreaseLimit != null && compPriceDecreaseLimit.toString() !== '' && compPriceDecreaseLimit >= 0;
    }

    get competitorsPricesValidate(): boolean {
        const competitorsP = this.$calc.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get setupMasterCompetitorsPricesValidate(): boolean {
        const competitorsP = this.$setupMasterCalc.competitorsPrices.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

        return numberPattern.test(competitorsP);
    }

    get percentageOfRecommendsKviValidate(): boolean {
        const kviRecommends = this.$calc.percentageOfRecommendsKviCount.toString();
        const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);
        return numberPattern.test(kviRecommends);
    }

    get marginalPriceDifferenceValidate(): boolean {
        if (this.$calc.marginalPriceDifference != null) {
            return this.$calc.marginalPriceDifference >= 0 && this.$calc.marginalPriceDifference <= 100;
        }
        return false;
    }

    get newProductLifespanInDaysValidate(): boolean {
        if (this.$calc.newProductLifespanInDays != null) {
            return this.$calc.newProductLifespanInDays >= 0 && this.$calc.newProductLifespanInDays <= 100;
        }
        return false;
    }

    get marginalProfitabilityValidate(): boolean {
        const marginalProfitability = this.$calc.marginalProfitability;
        if (marginalProfitability < 0) {
            this.marginalSkuErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalSkuErrorText = ''
        }
        return marginalProfitability < 100;
    }

    get competitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$calc.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '' && competitorsMinimumProfit >= -50 && competitorsMinimumProfit <= 500;
    }

    get setupMasterCompetitorsMinProfitValidate(): boolean {
        const competitorsMinimumProfit = this.$setupMasterCalc.competitorsMinimumProfit;
        return competitorsMinimumProfit.toString() !== '' && competitorsMinimumProfit >= -50 && competitorsMinimumProfit <= 500;
    }

    get priceGapValidate(): boolean {
        const priceGap = this.$calc.priceGap;
        return priceGap.toString() !== '' && priceGap >= 0;
    }

    get priceGapCtmPcValidate(): boolean {
        const priceGapCtm = this.$calc.priceGapCtmPc;
        return priceGapCtm !== null && priceGapCtm.toString() !== '' && priceGapCtm >= 0 && priceGapCtm <= 100;
    }

    get minProfitKVIValidate(): boolean {
        const minProfitKvi = this.$calc.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get setupMasterMinProfitKVIValidate(): boolean {
        const minProfitKvi = this.$setupMasterCalc.minProfitKVI;
        return minProfitKvi.toString() !== '' && minProfitKvi >= -50 && minProfitKvi <= 500;
    }

    get marginalProfitValidate(): boolean {
        const marginalProfit = this.$calc.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalErrorText = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get setupMasterMarginalProfitValidate(): boolean {
        const marginalProfit = this.$setupMasterCalc.marginalProfit;
        if (marginalProfit < 0) {
            this.marginalErrorTextForSetupMaster = this.$t('shared.parametersTab.negativeMarginWarning') as string
        } else {
            this.marginalErrorTextForSetupMaster = ''
        }
        return marginalProfit.toString() !== '' && marginalProfit < 100;
    }

    get marginalProfitDeclinePcValidate(): boolean {
        const declineProfitabilityPc = this.$calc.declineProfitabilityPc;
        return declineProfitabilityPc != null && declineProfitabilityPc < 100;
    }

    get globalIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalIndividualMarginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
            } else {
                this.globalIndividualMarginalErrorText = ''
            }
            this.globalIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalNewProductIndividualMarginalProfitValidate(): boolean {
        const marginalProfit = this.globalIndividualNewProductMarginalProfitability;
        if (marginalProfit !== null) {
            if (marginalProfit < 0) {
                this.globalNewProductIndividualMarginalErrorText = this.$t('shared.parametersTab.negativeMarginWarning') as string
            } else {
                this.globalNewProductIndividualMarginalErrorText = ''
            }
            this.globalNewProductIndividualMarginalBlockButton = marginalProfit > 100;
            return marginalProfit < 100;
        }
        return true;
    }

    get globalIndividualPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.globalIndividualPeriodPriceIncreaseLimit;
        if (periodPriceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPeriodPriceIncreaseLimitBlockButton = periodPriceIncreaseLimit < 0;
            return periodPriceIncreaseLimit >= 0;
        }
    }

    get globalIndividualPriceIncreaseLimitValidate(): boolean {
        const priceIncreaseLimit = this.globalIndividualPriceIncreaseLimit;
        if (priceIncreaseLimit == null) {
            return true;
        } else {
            this.globalIndividualPriceIncreaseLimitBlockButton = priceIncreaseLimit < 0 || priceIncreaseLimit > 100;
            return priceIncreaseLimit >= 0 && priceIncreaseLimit < 100;
        }
    }

    get decreaseSalesCountValidate(): boolean {
        const decreaseSalesCount = this.$calc.decreaseSalesCount;
        return decreaseSalesCount != null && decreaseSalesCount >= 0 && decreaseSalesCount < 100;
    }

    get setupMasterDecreaseSalesCountValidate(): boolean {
        const decreaseSalesCount = this.$setupMasterCalc.decreaseSalesCount;
        return decreaseSalesCount != null && decreaseSalesCount >= 0 && decreaseSalesCount < 100;
    }

    get priceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$calc.priceChangeLimit;
        return priceChangeLimit.toString() !== '' && priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get setupMasterPriceChangeLimitValidate(): boolean {
        const priceChangeLimit = this.$setupMasterCalc.priceChangeLimit;
        return priceChangeLimit.toString() !== '' && priceChangeLimit >= 0 && priceChangeLimit < 100;
    }

    get countPriceSegmentsValidate(): boolean {
        const countSegments = this.countPriceSegments;
        return countSegments.toString() !== '' && countSegments > 0;
    }

    get setupMasterCountPriceSegmentsValidate(): boolean {
        const countSegments = this.countPriceSegmentsForSetupMaster;
        return countSegments.toString() !== '' && countSegments > 0;
    }

    get periodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$calc.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get setupMasterPeriodPriceIncreaseLimitValidate(): boolean {
        const periodPriceIncreaseLimit = this.$setupMasterCalc.periodPriceIncreaseLimit;
        return periodPriceIncreaseLimit.toString() !== '' && periodPriceIncreaseLimit >= 0;
    }

    get inputInterval(): boolean {
        const lowerI = this.$calc.intervalOfUltimateElasticity.lower.toString();
        const upperI = this.$calc.intervalOfUltimateElasticity.upper.toString();
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get inputIntervalP(): boolean {
        if (this.isDisabledPriceBorder) {
            return true;
        }
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return false;
        }
        const lowerI = this.$calc.priceCorridor.min.toString();
        const upperI = this.$calc.priceCorridor.max.toString();
        if (this.$calc.priceCorridor.min >= this.$calc.priceCorridor.max || this.$calc.priceCorridor.min >= this.$calc.priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get setupMasterInputIntervalP(): boolean {
        if (this.isDisabledPriceBorderForSetupMaster) {
            return true;
        }
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null) {
            return false;
        }
        const lowerI = this.$setupMasterCalc.priceCorridor.min.toString();
        const upperI = this.$setupMasterCalc.priceCorridor.max.toString();
        if (this.$setupMasterCalc.priceCorridor.min >= this.$setupMasterCalc.priceCorridor.max || this.$setupMasterCalc.priceCorridor.min >= this.$setupMasterCalc.priceCorridor.max) {
            return false;
        }
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        if (lowerI.length === 0 || upperI.length === 0 || !numberPattern.test(upperI) || !numberPattern.test(lowerI)) {
            return false;
        }
        return (parseFloat(lowerI) < parseFloat(upperI));
    }

    get correlationCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const correlation = this.$calc.correlation.toString();
        if (correlation.length === 0 || !numberPattern.test(correlation)) {
            if (this.$calc.selectMarket != null) {
            }
            return false;
        }
        const cor = parseFloat(correlation);
        return 1 >= cor && cor >= -1;

    }

    get highElasticityCheck(): boolean {
        const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
        const highElasticity = this.$calc.highElasticity.toString();
        this.$log.debug(highElasticity.length > 0, numberPattern.test(highElasticity));
        return numberPattern.test(highElasticity);
    }

    get calcButt(): boolean {
        return this.calcButtonState();
    }

    get isDisabledPriceBorder(): boolean {
        return !this.$calc.changePriceCorridor;
    }

    get isDisabledPriceBorderForSetupMaster(): boolean {
        return !this.$setupMasterCalc.changePriceCorridor;
    }

    get isCategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$calc.categoryOfProduct != null && this.$calc.categoryOfProduct!! > 0;
    }

    get isSubcategorySelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$calc.subcategories != null && this.$calc.subcategories.length!! > 0;
    }

    get isCategorySelectedForSetupMaster(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$setupMasterCalc.categoryOfProduct != null && this.$setupMasterCalc.categoryOfProduct!! > 0;
    }


    get isSubCategorySelectedForSetupMaster(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$setupMasterCalc.subcategories != null && this.$setupMasterCalc.subcategories.length!! > 0;
    }

    get isCategorySelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.categoryOfProduct != null && this.$roundingRules.categoryOfProduct!! > 0;
    }

    get isSubCategorySelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.subcategories != null && this.$roundingRules.subcategories.length!! > 0;
    }

    get isGroupSelected(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$calc.groupOfProduct != null && this.$calc.groupOfProduct!! > 0;
    }

    get isGroupSelectedForRoundingRules(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$roundingRules.groupOfProduct != null && this.$roundingRules.groupOfProduct!! > 0;
    }

    get isGroupSelectedForSetupMaster(): boolean {
        // tslint:disable-next-line: no-non-null-assertion
        return this.$setupMasterCalc.groupOfProduct != null && this.$setupMasterCalc.groupOfProduct!! > 0;
    }

    get competitorPriceControlParameterPcValidate(): boolean {
        return this.$calc.competitorPriceControlParameterPc.toString() !== ''
            && this.$calc.competitorPriceControlParameterPc > 0 && this.$calc.competitorPriceControlParameterPc <= 100;
    }

    get competitorPriceControlParameterPcValidateForSetupMaster(): boolean {
        return this.$setupMasterCalc.competitorPriceControlParameterPc.toString() !== ''
            && this.$setupMasterCalc.competitorPriceControlParameterPc > 0 && this.$setupMasterCalc.competitorPriceControlParameterPc <= 100;
    }

    get enableDepthToPurchasePrice(): boolean {
        return (this.$calc.purchasePriceSuppliers || this.$calc.purchasePriceSuppliersWithRemains)
            || (this.$calc.countByAvgPurchasePrice && this.$calc.useArrivalDate)
            || (!this.$calc.countByAvgPurchasePrice && !this.$calc.countAtMaxPurchasePrice);
    }

    get enableDepthToPurchasePriceForSetupMaster(): boolean {
        return (this.$setupMasterCalc.countByAvgPurchasePrice && this.$setupMasterCalc.useArrivalDate) || (!this.$setupMasterCalc.countByAvgPurchasePrice && !this.$setupMasterCalc.countAtMaxPurchasePrice);
    }

    get backBasketPartValidate(): boolean {
        if (this.$calc.backBasketPart != null) {
            return this.$calc.backBasketPart >= 0 && this.$calc.backBasketPart <= 100;
        }
        return false;
    }

    get setupMasterGroupOrCategoryIsEmpty(): boolean {
        return !((this.$setupMasterCalc.groupOfProduct != null && this.$setupMasterCalc.groupOfProduct > 0)
            && (this.$setupMasterCalc.categoryOfProduct != null && this.$setupMasterCalc.categoryOfProduct > 0))
    }

    get setupMasterBaseAndStrategiesParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate
        return !state;
    }

    get setupMasterPriceSegmentsParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate
        return !state;
    }

    get setupMasterPriceKviParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
        return !state;
    }

    get setupMasterPriceCompetitorsParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
            && this.competitorPriceControlParameterPcValidateForSetupMaster && this.setupMasterCompetitorsMinProfitValidate && this.setupMasterCompPriceDecreaseLimitValidate
        return !state;
    }

    get setupMasterDepthParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
            && this.competitorPriceControlParameterPcValidateForSetupMaster && this.setupMasterCompetitorsMinProfitValidate
            && this.setupMasterCompPriceDecreaseLimitValidate && this.setupMasterCalculationDepthValidate
            && this.setupMasterCalculationDayValidate
        return !state;
    }

    get setupMasterSystemParametersValidate(): boolean {
        const state = !this.setupMasterGroupOrCategoryIsEmpty && this.setupMasterMarginalProfitValidate && this.setupMasterPriceDecreaseLimitValidate
            && this.setupMasterPriceIncreaseLimitValidate && this.setupMasterPriceChangeLimitValidate
            && this.setupMasterPeriodPriceIncreaseLimitValidate && this.paramsSumXYZForSetupMaster
            && this.setupMasterCountPriceSegmentsValidate && this.setupMasterCompetitorsPricesValidate
            && this.setupMasterMinProfitKVIValidate && this.setupMasterKviPriceDecreaseLimitValidate
            && this.competitorPriceControlParameterPcValidateForSetupMaster && this.setupMasterCompetitorsMinProfitValidate
            && this.setupMasterCompPriceDecreaseLimitValidate && this.setupMasterCalculationDepthValidate
            && this.setupMasterCalculationDayValidate && this.setupMasterInputIntervalP
        return !state;
    }

    currentMainTab: string = "mainParameters"
    setupMasterStep: number = 0;
    file: File | null = null;
    setupMasterGroupName: string = this.$t('shared.selectBox.all') as string;
    setupMasterCategoryName: string = this.$t('shared.selectBox.all') as string;
    setupMasterSubcategoryNames: string = this.$t('shared.selectBox.all') as string;
    setupMasterFormatName: string = this.$t('shared.selectBox.all') as string;
    setupMasterRegionNames: string = this.$t('shared.selectBox.all') as string;
    setupMasterClusterName: string = this.$t('shared.selectBox.all') as string;
    hasKvi: boolean = false;
    hasCompetitors: boolean = false;
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    defaultSelectProductLine = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectProductLine: string = this.defaultSelectProductLine.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    selectedKviFilter = this.defaultFilterValue.value;
    selectKVI: number = this.defaultFilterValue.value;
    selectKVIForNewProducts: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;
    kviOptions: Array<SelectBox<number>> = [
        this.defaultFilterValue,
        {value: 1, label: 'KVI'},
        {value: 0, label: this.$t('shared.selectBox.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.selectBox.all') as string},
        {value: 0, label: this.$t('shared.selectBox.gk') as string},
        {value: 1, label: this.$t('shared.selectBox.cvk') as string},
    ];

    defaultCtmFilterValue = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectedCtmFilter = this.defaultCtmFilterValue.value;
    selectCTM: string = this.defaultCtmFilterValue.value;
    selectCTMForNewProducts: string = this.defaultCtmFilterValue.value
    ctmOptions: Array<SelectBox<string>> = [
        this.defaultCtmFilterValue,
        {value: '1', label: 'CTM'},
        {value: '0', label: this.$t('shared.selectBox.notCtm') as string},
    ];

    selectSegmentPrice: Segment[] = [];
    selectSegmentPriceForNewProducts: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    selectNewProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    newProductSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    segmentPriceOptionsForNewProducts: Array<SelectBox<Segment>> = [];

    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectKeyCharacteristicThree: string[] = [];
    selectKeyCharacteristicFour: string[] = [];
    selectKeyCharacteristicFive: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];

    selectKeyCharacteristicOneForNewProduct: string[] = [];
    selectKeyCharacteristicTwoForNewProduct: string[] = [];
    selectKeyCharacteristicThreeForNewProduct: string[] = [];
    selectKeyCharacteristicFourForNewProduct: string[] = [];
    selectKeyCharacteristicFiveForNewProduct: string[] = [];
    selectRecipeAttributesForNewProduct: string[] = [];
    selectTreatmentAttributesForNewProduct: number[] = [];

    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    keyCharacteristicThreeOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFourOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFiveOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    keyCharacteristicOneForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicThreeForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFourForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicFiveForNewProductOptions: Array<SelectBox<string>> = [];
    recipeAttributesForNewProductOptions: Array<SelectBox<string>> = [];
    treatmentAttributesForNewProductOptions: Array<SelectBox<number>> = [];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    taskInfoForSetupMaster: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    taskInfoForRoundingRules: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    isSaveStateAvailable: boolean = false
    codeOKRBPageSize: number = 50;
    codeOKRBPageNumber: number = 1;
    OKRBCodes: any = [];
    modalTitle = this.$t('shared.labels.addOkrbCode') as string;
    showDeleteCodeOKRBModal: boolean = false;
    codeOKRBForDelete: string = '000.000';
    refreshCodeOKRBTableId = -1;
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    defaultStringSelectBox: Array<SelectBox<string>> = [{value: 'Все', label: this.$t('shared.selectBox.all') as string}];
    errors = [];
    tableKey = 1;
    rulesTableKey = 1;
    rulesPerPage = 20;
    rulesCurrentPage = 1;
    rulesListId = -1;
    rulesTotalRows = 0;
    competitorTableKey = 1;
    skuList: Sku[] = [];
    skuListWithAllProducts: Sku[] = [];
    newProductsList: Sku[] = [];
    newProductsListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    searchable: boolean = true;
    ProductsListCurrentTab: string = 'productList';
    tableDataSkuList: any = []
    tableDataNewProductsList: any = []
    tableDataCtmList: any = []

    codeOKRBToSave: CodeOKRB = {
        codeOKRB: '000.000',
        name: this.$t('shared.competitorsPricesList.codeName') as string,
        scenario: this.$t('shared.competitorsPricesList.byWeightedAverage') as string,
        tradingId: 1,
    };

    rulesTableFields: TableHeaders[] | ITableHeaders[] = [
        {dataIndex: 'fileDownload', title: this.$t('shared.labels.actions') as string, scopedSlots: {customRender: 'fileDownload'}},
        {dataIndex: 'errors', title: this.$t('shared.labels.errors') as string, scopedSlots: {customRender: 'errors'}},
        {
            dataIndex: 'uploadDate',
            title: this.$t('shared.labels.modifiedDate') as string,
            scopedSlots: {filterDropdown: 'uploadDateFilter', filterIcon: 'uploadDateFilterIcon'},
            customRender: (v: number) => moment(moment.utc(v)).local().format('DD/MM/YYYY HH:mm:ss'),
            ellipsis: true
        },
        {
            dataIndex: 'user',
            title: this.$t('shared.labels.user') as string,
            scopedSlots: {filterDropdown: 'userFilter', filterIcon: 'userFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('shared.filters.storeFormatChannel') as string,
            scopedSlots: {filterDropdown: 'storeFormatFilter', filterIcon: 'storeFormatFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'storeRegions',
            title: this.$t('shared.filters.storeRegion') as string,
            scopedSlots: {filterDropdown: 'storeRegionsFilter', filterIcon: 'storeRegionsFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('shared.filters.storeCluster') as string,
            scopedSlots: {filterDropdown: 'storeClusterFilter', filterIcon: 'storeClusterFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('results.tableHeaders.productGroup') as string,
            scopedSlots: {filterDropdown: 'groupsOfProductFilter', filterIcon: 'groupsOfProductFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'categories',
            title: this.$t('results.tableHeaders.productCategory') as string,
            scopedSlots: {filterDropdown: 'categoriesFilter', filterIcon: 'categoriesFilterIcon'},
            ellipsis: true
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('shared.parametersTab.subcategory') as string,
            scopedSlots: {filterDropdown: 'subcategoriesFilter', filterIcon: 'subcategoriesFilterIcon'},
            ellipsis: true
        },
    ];

    rulesTableItems: any[] = [];
    pagination: any = {
        pageSize: 50,
    };

    competitorsPagination: any = {
        pageSize: 50,
        current: 1,
    };

    codeOKRB() {
        const tableFields: ITableHeaders[] = [
            {dataIndex: 'actions', title: this.$t('shared.labels.actions') as string, width: 100, scopedSlots: {customRender: 'actions'}},
            {dataIndex: 'codeOKRB', title: this.$t('shared.competitorsPricesList.okrbCode') as string, width: 100, scopedSlots: {customRender: 'codeOKRB'}},
            {dataIndex: 'name', title: this.$t('shared.competitorsPricesList.okrbCodeName') as string, width: 100, scopedSlots: {customRender: 'codeOKRB'}},
            {
                dataIndex: 'scenario',
                title: this.$t('shared.competitorsPricesList.priceCalcScenario') as string,
                width: 100,
                scopedSlots: {customRender: 'codeOKRB'}
            },
        ]

        return tableFields
    }

    getTableFields() {
        const tableFields: ITableHeaders[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('results.tableHeaders.internalCode') as string,
                width: 100,
                scopedSlots: {
                    customRender: 'internalCode'
                },
                fixed: 'left'
            },
            {
                dataIndex: 'batchNumber',
                title: this.$t('shared.competitorsPricesList.batchNumber') as string,
                width: 80,
                scopedSlots: {
                    customRender: 'batchNumber'
                }
            },
            {
                dataIndex: 'productSegmentName',
                title: this.$t('results.tableHeaders.productSegment') as string,
                scopedSlots: {
                    filterDropdown: 'productSegmentNameFilter',
                    filterIcon: "productSegmentNameFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'skuName',
                scopedSlots: {title: "skuNameHeader"},
                ellipsis: true,
                width: 300,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsOne',
                title: this.$t('results.tableHeaders.kht1') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsOne',
                    filterDropdown: 'keyCharacteristicOfTheProductIsOneFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsOneFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsTwo',
                title: this.$t('results.tableHeaders.kht2') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsTwo',
                    filterDropdown: 'keyCharacteristicOfTheProductIsTwoFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsTwoFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsThree',
                title: this.$t('shared.competitorsPricesList.kht3') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsThree',
                    filterDropdown: 'keyCharacteristicOfTheProductIsThreeFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsThreeFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsFour',
                title: this.$t('shared.competitorsPricesList.kht4') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsFour',
                    filterDropdown: 'keyCharacteristicOfTheProductIsFourFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsFourFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'keyCharacteristicOfTheProductIsFive',
                title: this.$t('shared.competitorsPricesList.kht5') as string,
                scopedSlots: {
                    customRender: 'keyCharacteristicOfTheProductIsFive',
                    filterDropdown: 'keyCharacteristicOfTheProductIsFiveFilter',
                    filterIcon: "keyCharacteristicOfTheProductIsFiveFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'recipeAttribute',
                title: this.$t('results.tableHeaders.prc') as string,
                scopedSlots: {
                    customRender: 'recipeAttribute',
                    filterDropdown: 'recipeAttributeFilter',
                    filterIcon: "recipeAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'treatmentAttribute',
                title: this.$t('results.tableHeaders.pkl') as string,
                scopedSlots: {
                    customRender: 'treatmentAttribute',
                    filterDropdown: 'treatmentAttributeFilter',
                    filterIcon: "treatmentAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'kvi',
                title: 'KVI',
                scopedSlots: {
                    customRender: 'kvi',
                    filterDropdown: 'kviFilter',
                    filterIcon: "kviFilterIcon"
                },
                filterMultiple: false,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'tagsKvi',
                title: '',
                scopedSlots: {
                    customRender: 'tagsKvi',
                    filterDropdown: 'tagsKviFilter',
                    filterIcon: "tagsKviFilterIcon"
                },
                filterMultiple: false,
                ellipsis: true,
                width: 50
            },
            {
                dataIndex: 'ctm',
                title: 'CTM',
                width: 50,
                scopedSlots: {
                    customRender: 'ctm',
                    filterDropdown: 'ctmFilter',
                    filterIcon: "ctmFilterIcon"
                },
                filterMultiple: false,
                ellipsis: true,
            },
            {
                dataIndex: 'minMaxRetailPrice',
                title: this.$t('results.tableHeaders.minMaxRc') as string,
                customRender: (value: any, data: any) => `${(data.minRetailPrice) ? this.numberFormatter(data.minRetailPrice) : '-'}/${(data.maxRetailPrice) ? this.numberFormatter(data.maxRetailPrice) : '-'}`,
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productRange',
                title: this.$t('results.tableHeaders.line') as string,
                scopedSlots: {
                    customRender: 'productRange',
                    filterDropdown: 'productRangeFilter',
                    filterIcon: "productRangeFilterIcon"
                },
                width: 300,
                filterMultiple: false,
            },
            {
                dataIndex: 'lastPrice',
                scopedSlots: {title: "lastPriceHeader"},
                customRender: (value: any) => value ? this.numberFormatter(value) : '-',
                ellipsis: true,
                width: 130
            },
            {
                dataIndex: 'priceSegment',
                title: this.$t('results.tableHeaders.priceSegment') as string,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'priceSegmentFilter',
                    filterIcon: "priceSegmentFilterIcon"
                },
                customRender: (value: any, data: any) =>
                    `${(data.priceSegmentMin) ? this.numberFormatter(data.priceSegmentMin) : ''} - ${(data.priceSegmentMax) ? this.numberFormatter(data.priceSegmentMax) : ''}`,
                ellipsis: true,
            },
            {
                dataIndex: 'lastPriceMarginPc',
                title: this.$t('results.tableHeaders.marginLastPrice') as string,
                width: 80,
                scopedSlots: {customRender: 'lastPriceMarginPc'},
                ellipsis: true,
            },
            {
                dataIndex: 'actualProfitability',
                scopedSlots: {title: "actualProfitabilityHeader"},
                width: 120,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
            },
            {
                dataIndex: 'purchasePriceAvgM',
                title: this.$t('results.tableHeaders.avgPurchasePrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80
            },
            {
                dataIndex: 'coefficentList',
                title: this.$t('results.tableHeaders.priceOptStrategy') as string,
                width: 80,
                scopedSlots: {customRender: 'coefficentList'},
            },
            {
                dataIndex: 'priceIncreaseLimit',
                title: this.$t('results.tableHeaders.increaseLimit') as string,
                width: 80,
                scopedSlots: {customRender: 'priceIncreaseLimit'},
                ellipsis: true
            },
            {
                dataIndex: 'periodPriceIncreaseLimit',
                title: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string,
                scopedSlots: {customRender: 'periodPriceIncreaseLimit'},
                ellipsis: true,
                width: 80
            },
            {dataIndex: 'period', title: this.$t('results.tableHeaders.period') as string, scopedSlots: {customRender: 'period'}, width: 80},
            {
                dataIndex: 'marginalProfit',
                title: this.$t('results.tableHeaders.minMarginSku') as string,
                width: 80,
                scopedSlots: {customRender: 'marginalProfit'},
            },
            {
                dataIndex: 'kviStrategy',
                title: this.$t('results.tableHeaders.kviStrategy') as string,
                width: 80,
                scopedSlots: {customRender: 'kviStrategy'},
                ellipsis: true,
            },
            {
                dataIndex: 'percentageOfCompetitorsPrice',
                title: this.$t('results.tableHeaders.correction') as string,
                scopedSlots: {customRender: 'percentageOfCompetitorsPrice'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'basePrice',
                title: this.$t('shared.competitorsPricesList.producerPriceNoVat') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'vatPercentage',
                title: this.$t('shared.competitorsPricesList.vatPercent') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'markupPercentage',
                title: this.$t('shared.competitorsPricesList.maxMarkup') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'limitRetailPrice',
                title: this.$t('shared.competitorsPricesList.maxRetailPrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'marketingPaymentsPercentage',
                title: this.$t('shared.competitorsPricesList.marketingPayments') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsAmount',
                title: this.$t('shared.competitorsPricesList.logisticsCostNoVat') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsPercentage',
                title: this.$t('shared.competitorsPricesList.logisticsCostPercent') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productVolume',
                title: this.$t('results.tableHeaders.productVolume') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('results.tableHeaders.measurementUnit') as string,
                ellipsis: false,
                width: 30,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('results.tableHeaders.productVerticalLine') as string,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 50,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('results.tableHeaders.vlStrategyStr') as string,
                ellipsis: false,
                width: 70,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('results.tableHeaders.vlGapPc') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 70,
            },
        ];

        return tableFields;
    }

    getNewProductsTableFields() {
        const newProductsTableFields: TableHeaders[] | ITableHeaders[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('results.tableHeaders.internalCode') as string,
                width: 100,
                scopedSlots: {
                    customRender: 'internalCode',
                },
                fixed: "left",
            },
            {
                dataIndex: 'batchNumber',
                title: this.$t('shared.competitorsPricesList.batchNumber') as string,
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productSegmentName', title: this.$t('results.tableHeaders.productSegment') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'productSegmentNameFilter',
                    filterIcon: "productSegmentNameFilterIcon",
                },
                // newProductSegmentIdAndNameOptions
                // selectNewProductSegmentIdAndName
            },
            {
                dataIndex: 'skuName',
                scopedSlots: {
                    title: "skuNameHeader",
                },
                ellipsis: true,
                width: 300,
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsOne',
                title: this.$t('results.tableHeaders.kht1') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsOneFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsOneFilterIcon"
                },
                // keyCharacteristicOneForNewProductOptions
                // selectKeyCharacteristicOneForNewProduct
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsTwo',
                title: this.$t('results.tableHeaders.kht2') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsTwoFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsTwoFilterIcon"
                },
                // keyCharacteristicTwoForNewProductOptions
                // selectKeyCharacteristicTwoForNewProduct
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsThree',
                title: this.$t('shared.competitorsPricesList.kht3') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsThreeFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsThreeFilterIcon"
                },
                // keyCharacteristicThreeForNewProductOptions
                // selectKeyCharacteristicThreeForNewProduct

            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFour',
                title: this.$t('shared.competitorsPricesList.kht4') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFourFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFourFilterIcon"
                },
                // keyCharacteristicFourForNewProductOptions
                // selectKeyCharacteristicFourForNewProduct
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFive',
                title: this.$t('shared.competitorsPricesList.kht5') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFiveFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFiveFilterIcon"
                },
                // keyCharacteristicFiveForNewProductOptions
                //selectKeyCharacteristicFiveForNewProduct

            },
            {
                dataIndex: 'recipeAttribute',
                title: this.$t('results.tableHeaders.prc') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'recipeAttributeFilter',
                    filterIcon: "recipeAttributeFilterIcon"
                },
                // recipeAttributesForNewProductOptions

            },
            {
                dataIndex: 'treatmentAttribute',
                title: this.$t('results.tableHeaders.pkl') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'treatmentAttributeFilter',
                    filterIcon: "treatmentAttributeFilterIcon"
                },

            },
            {
                dataIndex: 'kvi',
                title: 'KVI',
                width: 70,
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'kvi',
                    filterDropdown: 'kviFilter',
                    filterIcon: "kviFilterIcon"
                },

            },
            {
                dataIndex: 'ctm',
                title: 'CTM',
                ellipsis: true,
                filterMultiple: false,
                width: 50,
                scopedSlots: {
                    filterDropdown: 'ctmFilter',
                    filterIcon: "ctmFilterIcon"
                },
                // selectCTMForNewProducts
            },
            {
                dataIndex: 'minMaxRetailPrice',
                title: this.$t('results.tableHeaders.minMaxRc') as string,
                ellipsis: true,
                width: 80,
                customRender: (value: any, data: any) => `${(data.minRetailPrice) ? this.numberFormatter(data.minRetailPrice) : '-'}/${(data.maxRetailPrice) ? this.numberFormatter(data.maxRetailPrice) : '-'}`,
            },
            {
                dataIndex: 'productRange',
                title: this.$t('results.tableHeaders.line') as string,
                width: 200,
            },
            {
                dataIndex: 'lastPrice',
                ellipsis: true,
                width: 130,
                scopedSlots: {
                    title: "lastPriceHeader"
                },
                customRender: (value: any) => value ? this.numberFormatter(value) : '-',
            },
            {
                dataIndex: 'priceSegment',
                title: this.$t('results.tableHeaders.priceSegment') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'priceSegmentFilter',
                    filterIcon: "priceSegmentFilterIcon"
                },
                customRender: (value: any, data: any) =>
                    `${(data.priceSegmentMin) ? this.numberFormatter(data.priceSegmentMin) : ''} - ${(data.priceSegmentMax) ? this.numberFormatter(data.priceSegmentMax) : ''}`,

            },
            {
                dataIndex: 'actualProfitability',
                scopedSlots: {title: "actualProfitabilityHeader"},
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'purchasePriceAvgM',
                title: this.$t('results.tableHeaders.avgPurchasePrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'coefficentList',
                title: this.$t('results.tableHeaders.priceOptStrategy') as string,
                scopedSlots: {customRender: 'coefficentList'},
                width: 80,
            },
            {
                dataIndex: 'marginalProfit',
                title: this.$t('results.tableHeaders.minMarginSku') as string,
                scopedSlots: {customRender: 'marginalProfit'},
                width: 80,
            },
            {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: {customRender: 'kviStrategy'}, width: 80,},
            {
                dataIndex: 'percentageOfCompetitorsPrice',
                title: this.$t('results.tableHeaders.correction') as string,
                scopedSlots: {customRender: 'percentageOfCompetitorsPrice'},
                width: 80,
            },
            {
                dataIndex: 'newProductPriceStrategy',
                title: this.$t('results.tableHeaders.newProductPriceStrategy') as string,
                scopedSlots: {customRender: 'newProductPriceStrategy'},
                width: 80,
            },
            {
                dataIndex: 'newProductLifespanInDays',
                title: this.$t('shared.competitorsPricesList.newProductLifeDays') as string,
                scopedSlots: {customRender: 'newProductLifespanInDays'},
                width: 80,
            },
            {
                dataIndex: 'priceGap',
                title: this.$t('results.tableHeaders.priceGap') as string,
                scopedSlots: {customRender: 'priceGap'},
                width: 80,
            },
            {
                dataIndex: 'productVolume',
                title: this.$t('results.tableHeaders.productVolume') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('results.tableHeaders.measurementUnit') as string,
                ellipsis: false,
                width: 30,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('results.tableHeaders.productVerticalLine') as string,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 50,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('results.tableHeaders.vlStrategyStr') as string,
                ellipsis: false,
                width: 70,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('results.tableHeaders.vlGapPc') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 70,
            },
        ];

        return newProductsTableFields
    }

    getTableSkuFields() {
        const tableSkuFields: TableHeaders[] | ITableHeaders[] = [
            {
                dataIndex: 'internalCode',
                title: this.$t('results.tableHeaders.internalCode') as string,
                scopedSlots: {
                    customRender: 'internalCode',
                },
                fixed: 'left',
                width: 100,
            },
            {
                dataIndex: 'batchNumber',
                title: this.$t('shared.competitorsPricesList.batchNumber') as string,
                scopedSlots: {
                    customRender: 'batchNumber',
                },
                width: 80,
                ellipsis: true,
            },
            {
                dataIndex: 'productSegmentName',
                title: this.$t('results.tableHeaders.productSegment') as string,
                ellipsis: true,
                width: 80,
                scopedSlots: {
                    filterDropdown: 'productSegmentNameFilter',
                    filterIcon: "productSegmentNameFilterIcon",
                },
                // selectProductSegmentIdAndName
                // updateProductSegmentIdAndName
                // productSegmentIdAndNameOptions
            },
            {
                dataIndex: 'skuName',
                ellipsis: true,
                width: 300,
                scopedSlots: {
                    title: "skuNameHeader",
                },
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsOne',
                title: this.$t('results.tableHeaders.kht1') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsOne',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsOneFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsOneFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicOne
                // updateKeyCharacteristicOne
                // keyCharacteristicOneOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsTwo',
                title: this.$t('results.tableHeaders.kht2') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsTwo',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsTwoFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsTwoFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicTwo
                // updateKeyCharacteristicTwo
                // keyCharacteristicTwoOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsThree',
                title: this.$t('shared.competitorsPricesList.kht3') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsThree',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsThreeFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsThreeFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicThree
                // updateKeyCharacteristicThree
                // keyCharacteristicThreeOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFour',
                title: this.$t('shared.competitorsPricesList.kht4') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsFour',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFourFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFourFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicFour
                // updateKeyCharacteristicFour
                // keyCharacteristicFourOptions
            },
            {
                dataIndex: 'dataIndexCharacteristicOfTheProductIsFive',
                title: this.$t('shared.competitorsPricesList.kht5') as string,
                scopedSlots: {
                    customRender: 'dataIndexCharacteristicOfTheProductIsFive',
                    filterDropdown: 'dataIndexCharacteristicOfTheProductIsFiveFilter',
                    filterIcon: "dataIndexCharacteristicOfTheProductIsFiveFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectKeyCharacteristicFive
                // updateKeyCharacteristicFive
                // keyCharacteristicFiveOptions
            },
            {
                dataIndex: 'priceGapSTM',
                title: this.$t('shared.competitorsPricesList.ctmPriceGap') as string,
                scopedSlots: {
                    customRender: 'ctmPriceGap',
                },
                ellipsis: true,
                width: 100,
            },
            {
                dataIndex: 'ctmBrandPurposeValue',
                title: this.$t('shared.competitorsPricesList.brandTarget') as string,
                scopedSlots: {
                    customRender: 'ctmBrandPurposeValue',
                },
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'ctmBrandPurpose',
                title: this.$t('shared.competitorsPricesList.autoBrandTarget') as string,
                scopedSlots: {
                    customRender: 'ctmBrandPurpose',
                },
                ellipsis: true,
                width: 100,
            },
            {
                dataIndex: 'recipeAttribute',
                title: this.$t('results.tableHeaders.prc') as string,
                scopedSlots: {
                    customRender: 'recipeAttribute',
                    filterDropdown: 'recipeAttributeFilter',
                    filterIcon: "recipeAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectRecipeAttributes
                // updateRecipeAttributes
                // recipeAttributesOptions
            },
            {
                dataIndex: 'treatmentAttribute',
                title: this.$t('results.tableHeaders.pkl') as string,
                scopedSlots: {
                    customRender: 'treatmentAttribute',
                    filterDropdown: 'treatmentAttributeFilter',
                    filterIcon: "treatmentAttributeFilterIcon"
                },
                ellipsis: true,
                width: 80,
                // selectTreatmentAttributes
                // updateTreatmentAttributes
                // treatmentAttributesOptions
            },
            {
                dataIndex: 'kvi',
                title: 'KVI',
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'kvi',
                    filterDropdown: 'kviFilter',
                    filterIcon: "kviFilterIcon",
                },
                ellipsis: true,
                width: 70,
                // selectKVI
                // kviOptions
            },
            {
                dataIndex: 'tagsKvi',
                title: '',
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'tagsKvi',
                    filterDropdown: 'tagsKviFilter',
                    filterIcon: "tagsKviFilterIcon"
                },
                ellipsis: true,
                width: 50,

                // selectKVIRecommends
                // kviRecommendsOptions
            },
            {
                dataIndex: 'minMaxRetailPrice',
                title: this.$t('results.tableHeaders.minMaxRc') as string,
                width: 80,
                customRender: (value: any, data: any) => `${(data.minRetailPrice) ? this.numberFormatter(data.minRetailPrice) : '-'}/${(data.maxRetailPrice) ? this.numberFormatter(data.maxRetailPrice) : '-'}`,
                ellipsis: true,
            },
            {
                dataIndex: 'productRange',
                title: this.$t('results.tableHeaders.line') as string,
                filterMultiple: false,
                scopedSlots: {
                    customRender: 'productRange',
                    filterDropdown: 'productRangeFilter',
                    filterIcon: "productRangeFilterIcon"
                },
                width: 200,

                // selectProductLine
                // productLineOptionsForFilter
            },
            {
                dataIndex: 'lastPrice',
                scopedSlots: {
                    title: "lastPriceHeader",
                },
                ellipsis: true,
                width: 130,
                customRender: (value: any) => value ? this.numberFormatter(value) : '-'
            },
            {
                dataIndex: 'priceSegment',
                title: this.$t('results.tableHeaders.priceSegment') as string,
                width: 80,
                scopedSlots: {
                    title: "lastPriceHeader",
                    filterDropdown: 'priceSegmentFilter',
                    filterIcon: "priceSegmentFilterIcon"
                },
                customRender: (value: any, data: any) =>
                    `${(data.priceSegmentMin) ? this.numberFormatter(data.priceSegmentMin) : ''} - ${(data.priceSegmentMax) ? this.numberFormatter(data.priceSegmentMax) : ''}`,
                ellipsis: true,
                // segmentPriceOptions
            },
            {
                dataIndex: 'lastPriceMarginPc',
                title: this.$t('results.tableHeaders.marginLastPrice') as string,
                scopedSlots: {customRender: 'lastPriceMarginPc'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'actualProfitability',
                scopedSlots: {title: "actualProfitabilityHeader"},
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'purchasePriceAvgM',
                title: this.$t('results.tableHeaders.avgPurchasePrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'coefficentList',
                title: this.$t('results.tableHeaders.priceOptStrategy') as string,
                scopedSlots: {customRender: 'coefficentList'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'priceIncreaseLimit',
                title: this.$t('results.tableHeaders.increaseLimit') as string,
                scopedSlots: {customRender: 'priceIncreaseLimit'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'periodPriceIncreaseLimit',
                title: this.$t('results.tableHeaders.periodPriceIncreaseLimit') as string,
                scopedSlots: {customRender: 'periodPriceIncreaseLimit'},
                ellipsis: true,
                width: 80,
            },
            {dataIndex: 'period', title: this.$t('results.tableHeaders.period') as string, scopedSlots: {customRender: 'period'},
                width: 80,},
            {
                dataIndex: 'marginalProfit',
                title: this.$t('results.tableHeaders.minMarginSku') as string,
                scopedSlots: {customRender: 'marginalProfit'},
                ellipsis: true,
                width: 80,
            },
            {dataIndex: 'kviStrategy', title: this.$t('results.tableHeaders.kviStrategy') as string, scopedSlots: {customRender: 'kviStrategy'}, ellipsis: true,
                width: 80,},
            {
                dataIndex: 'percentageOfCompetitorsPrice',
                title: this.$t('results.tableHeaders.correction') as string,
                scopedSlots: {customRender: 'percentageOfCompetitorsPrice'},
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'basePrice',
                title: this.$t('shared.competitorsPricesList.producerPriceNoVat') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'vatPercentage',
                title: this.$t('shared.competitorsPricesList.vatPercent') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'markupPercentage',
                title: this.$t('shared.competitorsPricesList.maxMarkup') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'limitRetailPrice',
                title: this.$t('shared.competitorsPricesList.maxRetailPrice') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'marketingPaymentsPercentage',
                title: this.$t('shared.competitorsPricesList.marketingPayments') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsAmount',
                title: this.$t('shared.competitorsPricesList.logisticsCostNoVat') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'logisticCostsPercentage',
                title: this.$t('shared.competitorsPricesList.logisticsCostPercent') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: true,
                width: 80,
            },
            {
                dataIndex: 'productVolume',
                title: this.$t('results.tableHeaders.productVolume') as string,
                customRender: (value: any) => this.numberFormatter(value),
                ellipsis: false,
                width: 40,
            },
            {
                dataIndex: 'measurementUnit',
                title: this.$t('results.tableHeaders.measurementUnit') as string,
                ellipsis: false,
                width: 30,
            },
            {
                dataIndex: 'productVerticalLine',
                title: this.$t('results.tableHeaders.productVerticalLine') as string,
                ellipsis: true,
                width: 70,
            },
            {
                dataIndex: 'isVerticalLineBase',
                title: this.$t('results.tableHeaders.isVerticalLineBase') as string,
                customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
                ellipsis: false,
                width: 50,
            },
            {
                dataIndex: 'vlStrategyStr',
                title: this.$t('results.tableHeaders.vlStrategyStr') as string,
                ellipsis: false,
                width: 70,
            },
            {
                dataIndex: 'vlGapPc',
                title: this.$t('results.tableHeaders.vlGapPc') as string,
                customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
                ellipsis: false,
                width: 70,
            },
        ];

        return tableSkuFields
    }

    numberFormatter = (v: any): string => FormatNumber.format(v);

    competitorsTableFields: ITableHeaders[] = [
        {dataIndex: 'selected', title: '✓', scopedSlots: {customRender: 'selected'}, width: 50},
        {dataIndex: 'internalCode', title: this.$t('results.tableHeaders.internalCode') as string, sorter: true, ellipsis: true, width: 150},
        {dataIndex: 'storeFormat', title: this.$t('shared.filters.format') as string, sorter: true, ellipsis: true, width: 150},
        {
            dataIndex: 'storeRegion',
            sorter: true,
            title: this.$t('shared.filters.region') as string,
            scopedSlots: {filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'skuName',
            sorter: true,
            title: this.$t('results.tableHeaders.skuName') as string,
            scopedSlots: {filterDropdown: 'skuNameFilter', filterIcon: "skuNameFilterIcon"},
            ellipsis: true,
            width: 170
        },
        {
            dataIndex: 'competitorName',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.competitor') as string,
            scopedSlots: {filterDropdown: 'competitorsNameFilter', filterIcon: "competitorsNameFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'competitorCode',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.competitorCode') as string,
            scopedSlots: {filterDropdown: 'competitorsCodeFilter', filterIcon: "competitorsCodeFilterIcon"},
            ellipsis: true,
            width: 170
        },
        {
            dataIndex: 'competitorPriority',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.competitorPriority') as string,
            scopedSlots: {filterDropdown: 'competitorsPriorityFilter', filterIcon: "competitorsPriorityFilterIcon"},
            ellipsis: true,
            width: 230
        },
        {
            dataIndex: 'lastPrice',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.ourPrice') as string,
            scopedSlots: {filterDropdown: 'lastPriceFilter', filterIcon: "lastPriceFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'promoPrice',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.promoCompetitorPrice') as string,
            scopedSlots: {filterDropdown: 'promoPriceFilter', filterIcon: "promoPriceFilterIcon"},
            ellipsis: true,
            width: 250
        },
        {
            dataIndex: 'competitorPrice',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.competitorPriceFull') as string,
            customRender: this.numberFormatter,
            scopedSlots: {filterDropdown: 'competitorsPriceFilter', filterIcon: "competitorsPriceFilterIcon"},
            ellipsis: true,
            width: 200
        },
        {
            dataIndex: 'delta',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.deviationFull') as string,
            customRender: (value: number) => `${value.toFixed(2)}%`,
            scopedSlots: {filterDropdown: 'deltaFilter', filterIcon: "deltaFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'kvi',
            sorter: true,
            title: 'KVI',
            customRender: (value: number) => value ? '{{ $t("shared.labels.yes") }}' : '{{ $t("shared.labels.no") }}',
            scopedSlots: {filterDropdown: 'kviFilter', filterIcon: "kviFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'ctm',
            sorter: true,
            title: this.$t('shared.competitorsPricesList.ctm') as string,
            scopedSlots: {filterDropdown: 'ctmFilter', filterIcon: "ctmFilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'dataIndexCharacteristicOfTheProductIsOne',
            sorter: true,
            title: this.$t('results.tableHeaders.kht1') as string,
            scopedSlots: {filterDropdown: 'kht1Filter', filterIcon: "kht1FilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'dataIndexCharacteristicOfTheProductIsTwo',
            sorter: true,
            title: this.$t('results.tableHeaders.kht2') as string,
            scopedSlots: {filterDropdown: 'kht2Filter', filterIcon: "kht2FilterIcon"},
            ellipsis: true,
            width: 150
        },
        {
            dataIndex: 'competitorDate',
            sorter: true,
            title: this.$t('competitorsPricesList.tableHeaders.monitoringDate') as string,
            customRender: (value: any) => moment(new Date(+value)).format('DD.MM.YYYY'),
            scopedSlots: {filterDropdown: 'monitoringDateFilter', filterIcon: "monitoringDateFilterIcon"},
            ellipsis: true,
            width: 200
        },
    ];

    steps = [
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.productCategories') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.formatsAndClusters') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.activeParams') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.strategyAndLimits') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.priceSegments') as string},
        {title: 'KVI'},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.competition') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.costAndForecastParams') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.otherParams') as string},
        {title: this.$t('shared.competitorsPricesList.setupMasterSteps.finishSetup') as string},
    ];

    settingsMasterIsOpen: Boolean = false;

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    tradingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    selectedCompetitorsCtmFilter: SelectBox<string> = this.defaultCtmFilterValue;

    selectedCompetitorsKviFilter: SelectBox<number> = this.defaultFilterValue;

    selectedMonitoringDateFilter: string[] = [];
    monitoringDateFilterOptions: Array<SelectBox<string>> = [];

    selectedDeltaFilter: string[] = [];
    deltaFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsPriceFilter: string[] = [];
    competitorsPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedLastPriceFilter: string[] = [];
    lastPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedPromoPriceFilter: string[] = [];
    promoPriceFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsPriorityFilter: string[] = [];
    competitorsPriorityFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsNameFilter: string[] = [];
    competitorsNameFilterOptions: Array<SelectBox<string>> = [];

    selectedCompetitorsCodeFilter: string[] = [];
    competitorsCodeFilterOptions: Array<SelectBox<string>> = [];

    selectedSkuNameFilter: string[] = [];
    skuNameFilterOptions: Array<SelectBox<string>> = [];

    selectKeyCharacteristicOneForCompetitors: string[] = [];
    keyCharacteristicOneForCompetitorsOptions: Array<SelectBox<string>> = [];

    selectKeyCharacteristicTwoForCompetitors: string[] = [];
    keyCharacteristicTwoForCompetitorsOptions: Array<SelectBox<string>> = [];

    competitors: CompetitorsPriceRow[] = [];
    viewCompetitors: CompetitorsPriceRow[] = [];
    skuListLimit: number = 50;
    newProductsListLimit: number = 20;
    skuFilter: string = '';
    newProductsFilter: string = '';
    debounceMinRetailPrice!: () => void;
    serverConfigTimeout: number | null = null;
    loadingConfigs = false;
    loadingConfigsForSetupMaster = false;
    marginalErrorText = '';
    marginalErrorTextForSetupMaster = '';
    globalIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalBlockButton = false;
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;
    marginalSkuErrorText = '';

    taskData: TaskAndFile | null = null;
    skuListPerPage: number = 20;
    newProductListPerPage: number = 20;
    skuListCurrentPage: number = 1;
    newProductsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    skuCtmListTotalRows: number = 0;
    newProductsListTotalRows: number = 0;
    calcSkuLastPricesButtonDisabled: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    firstDate: number = 0;
    setupMasterFirstDate: number = 0;
    lastDate: number = 0;
    setupMasterLastDate: number = 0;
    showBookmarks: boolean = true;
    showMainFilters: boolean = true;
    needLoadSkuList = false;
    needLoadNewProductList: boolean = false;
    needLoadCtmProductList: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isActualProfitabilityCalculatedForSetupMaster: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculatedForSetupMaster: boolean = false;
    isDataRangeCalculated: boolean = false;
    isDataRangeCalculatedForSetupMaster: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    isPriceCorridorCalculatedForSetupMaster: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isFetchNewProductsListDownload: boolean = false;
    isFetchCtmProductsListDownload: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    newProductsLastPage: number = 0;
    paramsRulesKey: number = 1;
    tabs: BTabs | null = null;
    loadProgress: boolean = false;
    progressCounter: number = 0;
    rulesDateRange: string[] = [];
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = {value: 'All', label: this.$t('shared.selectBox.all') as string}.value;
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;

    sortingField: SortingField | null = null
    sortByInternalCode: number = -1;
    sortByStoreFormat: number = -1;
    sortByStoreRegion: number = -1;
    sortBySkuName: number = -1;
    sortByCompetitorName: number = -1;
    sortByCompetitorPriority: number = -1;
    sortByLastPrice: number = -1;
    sortByPromoPrice: number = -1;
    sortByCompetitorPrice: number = -1;
    sortByDelta: number = -1;
    sortByKvi: number = -1;
    sortByCtm: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsOne: number = -1;
    sortByDataIndexCharacteristicOfTheProductIsTwo: number = -1;
    sortByCompetitorDate: number = -1;

    GROUP = 'GROUP';
    CATEGORY = 'CATEGORY';
    SUB_CATEGORY = 'SUB_CATEGORY';
    FORMAT = 'FORMAT';
    REGION = 'REGION';
    PRODUCT_SEGMENT = 'PRODUCT_SEGMENT';
    CLASTER = 'CLASTER';
    COMPANY = 'COMPANY';

    private globalIndividualPriceStrategy: SelectBox<Coefficents> | null = null;
    private globalIndividualPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriodPriceIncreaseLimit: number | null = null;
    private globalIndividualPeriod: SelectBox<number> | null = null;
    private globalIndividualMarginalProfitability: number | null = null;
    private globalIndividualKviStrategy: SelectBox<KviStrategies> | null = null;

    private globalIndividualPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductStrategyOpt: SelectBox<Coefficents> | null = null;
    private globalIndividualNewProductMarginalProfitability: number | null = null;
    private globalIndividualNewProductKviStrategy: SelectBox<KviStrategies> | null = null;
    private globalIndividualNewProductPercentageOfCompetitorsPrice: string | null = null;
    private globalIndividualNewProductPriceStrategy: SelectBox<NewProductPriceStrategy> | null = null;
    private globalIndividualNewProductLifespanInDays: number | null = null;

    private globalIndividualNewProductPriceGap: number | null = null;
    private useBrutForcingParams: boolean = false;
    private saveAfterOptimize: boolean = false;
    private saveAfterOptimizeForSetupMaster: boolean = false;

    private optimizationDiff: number = 0.0;
    private optimizationDiffForSetupMaster: number = 0.0;
    private refreshSkuListId = -1;
    private refreshNewProductsListId = -1;
    private refreshCompetitorsListId = -1;
    private showDataRange: boolean = false;
    private showDataRangeForSetupMaster: boolean = false;
    private showSku: boolean = false;

    private skuListWithCalculating: boolean = false;
    private newProductsWithCalculating: boolean = true;
    private competitorsWithCalculating: boolean = true;
    private sortBySKU: number = -1;
    private sortingNewProductsBySKU: number = -1;
    private sortCompetitorsBySKU: number = -1;
    private dropDownOpen = false;
    private dropDownOpenForSetupMaster = false;
    private dropDownOpenForRoundingRules = false;
// tslint:disable-next-line: ban-types
    private onDropdownClosed: Function | null = null;
// tslint:disable-next-line: ban-types
    private onDropdownClosedForSetupMaster: Function | null = null;
    // tslint:disable-next-line: ban-types
    private onDropdownClosedForRoundingRules: Function | null = null;
    private actualProfitability: number | null = null;
    private setupMasterActualProfitability: number | null = null;
    private regularPricesProfitability: number | null = null;
    private regularPricesProfitabilityForSetupMaster: number | null = null;
    private isFiltersChanged = 1;
    private lastPage = 0;
    private findAutomaticallyPriceSegments = false;
    private findAutomaticallyPriceSegmentsForSetupMaster = false;
    private countPriceSegments = 1;
    private countPriceSegmentsForSetupMaster = 1;
    private productCodesForAddKvi: string[] = []
    private productCodesForDeleteKvi: string[] = []
    private productCodesForAddCtmPurpose: string[] = []
    private productCodesForDeleteCtmPurpose: string[] = []
    private needCalculateSkuLastPricesOnly: boolean = false;
    private needCalculateSkuActualProfitabilityOnly: boolean = false;
    private needLoadFiltersForTable: boolean = true;
    private refreshRulesListId = -1;
    private httpExecutor: HttpExecutor = new HttpExecutor();
    private viz: any | null = null;
    private rulesLimit: number = 20;
    private disableAllPurchaseOptionsIfActivePurchasePriceSuppliers: boolean = false;
    private disableAllPurchaseOptionsIfActivePurchasePriceSuppliersForRemains: boolean = false;
    private activePurchasePriceSuppliers: boolean = true;
    private activePurchasePriceSuppliersWithRemains: boolean = true;

    private supersetFilterIds = {
        GROUP: getEnv('SUPERSET_FILTER_GROUP_ID'),
        CATEGORY: getEnv('SUPERSET_FILTER_CATEGORY_ID'),
        CLASTER: getEnv('SUPERSET_FILTER_CLASTER_ID'),
        COMPANY: getEnv('SUPERSET_FILTER_COMPANY_ID'),
        SUB_CATEGORY: getEnv('SUPERSET_FILTER_SUB_CATEGORY_ID'),
        FORMAT: getEnv('SUPERSET_FILTER_FORMAT_ID'),
        REGION: getEnv('SUPERSET_FILTER_REGION_ID'),
    }

    iconMode(array: any[]) {
        return !array || !array.length;
    }

    setItemsSuperset(event: number[] | number | string | null, key: string) {

        const supersetFileds: ISupersetFields = {
            GROUP: {
                label: this.$t('shared.labels.group') as string,
                id: this.supersetFilterIds.GROUP,
                targets: 'group_name',
            },
            CATEGORY: {
                label: this.$t('shared.labels.category') as string,
                id: this.supersetFilterIds.CATEGORY,
                targets: 'category',
            },
            SUB_CATEGORY: {
                label: this.$t('shared.parametersTab.subcategory') as string,
                id: this.supersetFilterIds.SUB_CATEGORY,
                targets: 'subcategory',
            },
            FORMAT: {
                label: this.$t('shared.filters.format') as string,
                id: this.supersetFilterIds.FORMAT,
                targets: 'format',
            },
            REGION: {
                label: this.$t('shared.labels.region') as string,
                id: this.supersetFilterIds.REGION,
                targets: 'region',
            },
            CLASTER: {
                label: this.$t('shared.labels.cluster') as string,
                id: this.supersetFilterIds.CLASTER,
                targets: 'cluster',
            },
            COMPANY: {
                label: this.$t('shared.labels.company') as string,
                id: this.supersetFilterIds.COMPANY,
                targets: 'company',
            },
        };

        const getlabel = (event: number[] | number | string | null) => {
            if (typeof event !== 'string') {
                const commonArrayWithValues = Object.values(this.taskInfo).flat();
                if (Array.isArray(event)) {
                    const getLabelsArray = event.map((val) => {
                        const findCurrentObj = commonArrayWithValues.find((i) => i.value === val);
                        return findCurrentObj ? findCurrentObj.label : null;
                    })

                    if (getLabelsArray[0] === this.$t('shared.selectBox.all') as string) {
                        const allLabels = this.taskInfo.subcategories.map((sub) => sub.label).slice(1);
                        return allLabels;
                    }

                    return getLabelsArray[0] ? getLabelsArray : null;
                }

                const getCurrentObj = commonArrayWithValues.find((i) => i.value === event);

                return getCurrentObj.label;
            }
            return event;
        };


        const selectedFiltersRison: string | null = localStorage.getItem('FILTERS_SUPERSET');
        const label = event !== null && getlabel(event);
        const parseToObject = selectedFiltersRison === null ? {} : JSON.parse(selectedFiltersRison);

        parseToObject[key] = label ? parseRisonForSP(supersetFileds[key], label) : '';

        localStorage.setItem('FILTERS_SUPERSET', JSON.stringify(parseToObject));

        const joinFiltersRison: string = `(${Object.values(parseToObject)
            .filter((i) => i)
            .join(',')})`;
        localStorage.setItem('FILTER_FOR_SUPERSET', joinFiltersRison);
    }

    handleScroll(): boolean {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const scrollBottom = documentHeight - (scrollTop + windowHeight);
        console.log('Достигнут ! ', scrollBottom);

        if (scrollBottom === 0) {
            console.log('Достигнут конец страницы!');
            // Выполняйте здесь нужные действия
        }
        return true
    }

    rulesButtonDisable(): boolean {
        return this.file == null;
    }

    refreshRoundingRulesListBySelectedFilters() {
        // this.rulesTableKey = Math.random()
        this.refreshRoundingRulesList()
    }

    refreshRoundingRulesList() {
        const pager = {...this.pagination};
        pager.current = 1;
        this.pagination = pager;
        this.fetchRulesList({currentPage: this.pagination.current}, () => {
        })
    }

    isOKRBCodesEnabled() {
        return localStorage.getItem('isOKRBCodesEnabled') === 'true'
    }

    showSaveModal(codeOKRB = null) {
        if (codeOKRB !== null && typeof codeOKRB !== 'object') {
            this.loadCodeOKRB(String(codeOKRB));
            (this.$refs.saveCodeOKRBModal as any).show();
        } else {
            (this.$refs.saveCodeOKRBModal as any).show();
        }
    }

    hideSaveModal() {
        (this.$refs.saveCodeOKRBModal as any).hide();
    }

    beforeDeleteFileDialogCodeOKRB(codeOKRB: string) {
        this.showDeleteCodeOKRBModal = true;
        this.codeOKRBForDelete = codeOKRB;
    }

    showDeleteCodeOKRBDialog(codeOKRB: string) {
        this.deleteCodeOKRB(codeOKRB);
    }

    deleteCodeOKRB(codeOKRB: string) {
        this.$http.delete('/api/code-okrb', {params: {codeOKRB}})
            .then(() => {
                this.refreshDetailTable()
            })
            .catch((err) => {
                this.showError(this.$t('shared.competitorsPricesList.errorDeleteOkrb') as string);
            });
    }

    loadCodesOKRB() {
        this.httpGetOKRBCodes(this.$calc.selectMarket.id)
            .then((r) => {
                    this.OKRBCodes = r.data;
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.competitorsPricesList.errorLoadOkrb') as string);
            });
    }

    loadCodeOKRB(codeOKRB: string) {
        this.httpGetOKRBCode(codeOKRB)
            .then((r) => {
                    this.codeOKRBToSave = r.data;
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.competitorsPricesList.errorLoadOkrb') as string);
            });
    }

    saveCodeOKRB(event: BvModalEvent) {
        event.preventDefault();
        this.codeOKRBToSave.tradingId = this.$calc.selectMarket.id
        this.httpUpsertOKRBCode(this.codeOKRBToSave)
            .then(() => {
                this.hideSaveModal();
                this.refreshDetailTable()
            })
            .catch((e) => {
                this.showError(this.$t('shared.competitorsPricesList.errorLoadOkrb') as string);
            });
    }

    saveCodeOKRBScenario(event: any) {
        this.codeOKRBToSave.scenario = event.label
    }

    startSaveStateAvailableCheck() {
        // const isSaveStateAvailable = localStorage.getItem('isSaveStateAvailable') === 'true';
        // setInterval(() => {
        //     this.saveState();
        // }, 500);
        //
        // this.saveState();
    }

    saveState(): boolean {
        return !((this.$calc.groupOfProduct != null && this.$calc.groupOfProduct > 0)
                || (this.$calc.categoryOfProduct != null && this.$calc.categoryOfProduct > 0))
    }

    uploadFile(event: Event) {
        event.preventDefault();
        if (!this.file) {
            this.showInfo(this.$t('shared.roundingPrices.selectFileRequired') as string);
            return;
        }
        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = this.file.size;
        uploadFile.append('file', new Blob([this.file]), this.file.name);
        const self = this;
        const onUploadProgress = (e: any) => {
            const s = e.loaded / size;
            self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
        };

        // tslint:disable-next-line: no-non-null-assertion
        this.httpUploadFile(this.$calc.selectMarket.id, FileType.OKRBCODES, uploadFile, onUploadProgress)
            .then(() => {
                (this.$refs.fileinput as BFormFile).reset();
                this.file = null;
                this.refreshDetailTable()
                this.$nextTick(() => {
                    this.loadProgress = false;
                    this.progressCounter = 0;
                });
            })
            .catch((e) => {
                this.showError(this.$t('shared.competitorsPricesList.errorUploadFile') as string);
                this.loadProgress = false;
                this.progressCounter = 0;
                this.file = null;
                (this.$refs.fileinput as BFormFile).reset();
            });
    }

    beforeDeleteFileDialog(fileId: number) {
        this.fileIdForDelete = fileId;
        this.showDeleteFileModal = true;
    }

    showDeleteFileDialog(ruleId: number) {
        this.httpDeleteRoundingRulesFile(ruleId);
        this.refreshRoundingRulesList();
    }

    clearRoundingRulesFilters() {
        this.rulesDateRange = []
        this.selectUserFio = {value: 'All', label: this.$t('shared.selectBox.all') as string}.value;
        this.usersFioList = []
        this.selectCategoryFilter = this.defaultFilterValue.value;
        this.categoryFilterOptions = []
        this.selectGroupFilter = this.defaultFilterValue.value;
        this.groupFilterOptions = []
        this.selectSubcategoryFilter = this.defaultFilterValue.value;
        this.subcategoryFilterOptions = []
        this.selectFormatFilter = this.defaultFilterValue.value;
        this.formatFilterOptions = []
        this.selectRegionFilter = this.defaultFilterValue.value;
        this.regionFilterOptions = []
        this.selectClusterFilter = this.defaultFilterValue.value;
        this.clusterFilterOptions = []
        this.needLoadFiltersForTable = true;
        this.refreshRoundingRulesList()
    }

    fetchRulesList(ctx: any, callback: (items: any[]) => void) {
        const offset = (ctx.currentPage - 1) * this.pagination.pageSize;
        const filter = this.getRoundingListFilter();
        const tradingId = this.$roundingRules.selectMarket.id;
        this.httpLoadRoundingRules(filter, this.pagination.pageSize, offset)
            .then((res) => {
                    if (this.needLoadFiltersForTable) {
                        this.httpLoadRoundingRulesFilters(tradingId, 'BASE')
                            .then((r) => {
                                const result = r.data

                                const categories = result.categories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.categoryFilterOptions = categories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const groups = result.groupsOfProduct.filter((i) => {
                                    return i.name !== '';
                                });
                                this.groupFilterOptions = groups.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const subcategories = result.subcategories.filter((i) => {
                                    return i.name !== '';
                                });
                                this.subcategoryFilterOptions = subcategories.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const storeFormat = result.storeFormat.filter((i) => {
                                    return i.name !== '';
                                });
                                this.formatFilterOptions = storeFormat.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const regions = result.storeRegionValues.filter((i) => {
                                    return i.name !== '';
                                });
                                this.regionFilterOptions = regions.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                const clusters = result.storeCluster.filter((i) => {
                                    return i.name !== '';
                                });
                                this.clusterFilterOptions = clusters.map((i) => {
                                    return {value: i.id, label: i.name};
                                });
                                this.tradingsFilterOptions.unshift(this.defaultFilterValue);
                                this.categoryFilterOptions.unshift(this.defaultFilterValue);
                                this.groupFilterOptions.unshift(this.defaultFilterValue);
                                this.subcategoryFilterOptions.unshift(this.defaultFilterValue);
                                this.formatFilterOptions.unshift(this.defaultFilterValue);
                                this.regionFilterOptions.unshift(this.defaultFilterValue);
                                this.clusterFilterOptions.unshift(this.defaultFilterValue);

                                this.httpGetRoundingRulesUsersFio(tradingId)
                                    .then((response) => {
                                        this.usersFioList = response.data.map((i) => {
                                            return {value: i, label: i}
                                        });
                                        this.usersFioList.unshift({value: 'All', label: this.$t('shared.selectBox.all') as string});
                                    })
                                    .catch((e) => {
                                        this.showError(this.$t('shared.roundingPrices.errorLoadUsers') as string);
                                    });

                                this.needLoadFiltersForTable = false;
                            })
                    }
                    const pagination = {...this.pagination};
                    pagination.total = res.data.totalElements;
                    this.pagination = pagination;
                    this.rulesTotalRows = res.data.totalElements;
                    this.rulesTableItems = res.data.content;
                    callback(res.data.content);
                },
            )
            .catch((e) => {
                callback([]);
            });
    }

    downloadRoundingRulesFile(fileId: number) {
        this.$http.get('/api/file/download-rules-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Rules.xlsx');
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                this.showError(this.$t('shared.roundingPrices.errorDownloadRules') as string);
            });
    }

    downloadRoundingErrorFile(fileId: number) {
        this.$http.get('/api/file/download-rules-error-file', {
            method: 'GET',
            responseType: 'blob',
            params: {
                ruleId: fileId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Errors');
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                this.showError(this.$t('shared.competitorsPricesList.errorDownloadErrors') as string);
            });
    }

    uploadRoundingFile(event: Event) {
        if (!this.file) {
            this.showInfo(this.$t('shared.roundingPrices.selectFileRequired') as string);
            return;
        }

        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = this.file.size;
        uploadFile.append('file', new Blob([this.file]), this.file.name);
        const self = this;
        const onUploadProgress = (e: any) => {
            const s = e.loaded / size;
            self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
        };
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForRoundingRulesSeasonsRegions();
        const filters: BaseFilterRoundingRules = {
            category: this.$roundingRules.categoryOfProduct,
            productSegments: LocalData.filterNumberArrays(this.$roundingRules.productSegments),
            storeCluster: this.$roundingRules.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: this.$roundingRules.formatSelected,
            tradingId: this.$roundingRules.selectMarket.id,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            filterType: 'BASE',
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        };

        uploadFile.append('filters', new Blob([JSON.stringify(filters)], {type: 'application/json'}));
        this.httpUploadRoundingRule(uploadFile, onUploadProgress)
            .then((r) => {
                // this.showInfo(r.data);
                (this.$refs.fileinput as BFormFile).reset();
                this.file = null;
                // (this.$refs.rulesTable as any).refresh();
                this.$nextTick(() => {
                    this.loadProgress = false;
                    this.progressCounter = 0;
                });
            })
            .catch((e) => {
                (this.$refs.fileinput as BFormFile).reset();
                const dataWithoutStatus = e.response.data.replace(/[0-9]/g, '');
                this.showError(this.$t('shared.roundingPrices.errorUploadFile') as string + ' ' + dataWithoutStatus);
                this.loadProgress = false;
                this.progressCounter = 0;
                this.file = null;
            });
        this.refreshRoundingRulesList()
    }

    mounted() {
        // @ts-ignore
        this.listCompetitors({currentPage: 1, pageSize: 50}, () => {});

        this.initTaskModuleItem();
    }

    onRulesTableChange(pagination: any) {
        const pager = {...this.pagination};
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchRulesList({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {
        });
    }

    onCompetitorsTableChange(pagination: any, filters: any, sorter: any) {

        Object.keys(filters).forEach((item) => {
            let key = item;

            if (key === 'subCategoryName') key = 'subcategoryName'
            if (key === 'productSegmentName') key = 'segmentName'
            if (key === 'segment') key = 'segmentPrice'
            if (key === 'kvi') key = 'KVI'
            if (key === 'ctm') key = 'CTM'

            key = key.charAt(0).toUpperCase() + key.slice(1);
            // @ts-ignore
            if (this[`select${key}ForDetailTable`]) this[`select${key}ForDetailTable`] = filters[item];
            // @ts-ignore
            else this[`select${key}sForDetailTable`] = filters[item]
        })
        this.onHeadClicked(sorter.field).then(() => this.listCompetitors({currentPage: 1, pageSize: 50}, () => {}));
    }

    onHeadClicked(key: string) {
        this.sortingField = null;
        const fieldDef = this.competitorsTableFields.find((value, index) => value.dataIndex === key);
        switch (key) {
            case 'internalCode': {
                if (fieldDef !== undefined) {
                    this.sortByInternalCodeInCompetitorsTable(key)
                }
                break;
            }
            case 'storeFormat': {
                if (fieldDef !== undefined) {
                    this.sortByStoreFormatInCompetitorsTable(key)
                }
                break;
            }
            case 'storeRegion': {
                if (fieldDef !== undefined) {
                    this.sortByStoreRegionInCompetitorsTable(key)
                }
                break;
            }
            case 'skuName': {
                if (fieldDef !== undefined) {
                    this.sortBySkuNameInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorName': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorNameInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorPriority': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorPriorityInCompetitorsTable(key)
                }
                break;
            }
            case 'lastPrice': {
                if (fieldDef !== undefined) {
                    this.sortByLastPriceInCompetitorsTable(key)
                }
                break;
            }
            case 'promoPrice': {
                if (fieldDef !== undefined) {
                    this.sortByPromoPriceInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorPrice': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorPriceInCompetitorsTable(key)
                }
                break;
            }
            case 'delta': {
                if (fieldDef !== undefined) {
                    this.sortByDeltaInCompetitorsTable(key)
                }
                break;
            }
            case 'kvi': {
                if (fieldDef !== undefined) {
                    this.sortByKviInCompetitorsTable(key)
                }
                break;
            }
            case 'ctm': {
                if (fieldDef !== undefined) {
                    this.sortByCtmInCompetitorsTable(key)
                }
                break;
            }
            case 'dataIndexCharacteristicOfTheProductIsOne': {
                if (fieldDef !== undefined) {
                    this.sortByDataIndexCharacteristicOfTheProductIsOneInCompetitorsTable(key)
                }
                break;
            }
            case 'dataIndexCharacteristicOfTheProductIsTwo': {
                if (fieldDef !== undefined) {
                    this.sortByDataIndexCharacteristicOfTheProductIsTwoInCompetitorsTable(key)
                }
                break;
            }
            case 'competitorDate': {
                if (fieldDef !== undefined) {
                    this.sortByCompetitorDateInCompetitorsTable(key)
                }
                break;
            }
        }

        return Promise.resolve();
    }

    resetAllSortingFields() {
        this.sortByInternalCode = -1
        this.sortByStoreFormat = -1;
        this.sortByStoreRegion = -1;
        this.sortBySkuName = -1;
        this.sortByCompetitorName = -1;
        this.sortByCompetitorPriority = -1;
        this.sortByLastPrice = -1;
        this.sortByPromoPrice = -1;
        this.sortByCompetitorPrice = -1;
        this.sortByDelta = -1;
        this.sortByKvi = -1;
        this.sortByDataIndexCharacteristicOfTheProductIsOne = -1;
        this.sortByDataIndexCharacteristicOfTheProductIsTwo = -1;
        this.sortByCompetitorDate = -1;
    }

    sortByInternalCodeInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByInternalCode
        this.resetAllSortingFields()
        const fieldValue = this.sortByInternalCode = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByStoreFormatInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByStoreFormat
        this.resetAllSortingFields()
        const fieldValue = this.sortByStoreFormat = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByStoreRegionInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByStoreRegion
        this.resetAllSortingFields()
        const fieldValue = this.sortByStoreRegion = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortBySkuNameInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortBySkuName
        this.resetAllSortingFields()
        const fieldValue = this.sortBySkuName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorNameInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorName
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorName = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorPriorityInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorPriority
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorPriority = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByLastPriceInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByLastPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByLastPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByPromoPriceInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByPromoPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByPromoPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorPriceInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorPrice
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorPrice = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDeltaInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByDelta
        this.resetAllSortingFields()
        const fieldValue = this.sortByDelta = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByKviInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByKvi
        this.resetAllSortingFields()
        const fieldValue = this.sortByKvi = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCtmInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCtm
        this.resetAllSortingFields()
        const fieldValue = this.sortByCtm = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDataIndexCharacteristicOfTheProductIsOneInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByDataIndexCharacteristicOfTheProductIsOne
        this.resetAllSortingFields()
        const fieldValue = this.sortByDataIndexCharacteristicOfTheProductIsOne = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByDataIndexCharacteristicOfTheProductIsTwoInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByDataIndexCharacteristicOfTheProductIsTwo
        this.resetAllSortingFields()
        const fieldValue = this.sortByDataIndexCharacteristicOfTheProductIsTwo = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    sortByCompetitorDateInCompetitorsTable(sortFieldName: string) {
        const tmpVariable = this.sortByCompetitorDate
        this.resetAllSortingFields()
        const fieldValue = this.sortByCompetitorDate = tmpVariable === 0 ? 1 : 0;
        this.sortingField = {fieldName: sortFieldName, sortValue: fieldValue}
    }

    onSearch(callback: any) {
        this.isFiltersChanged = 1
        callback(1)
    }

    handleFilter(callback: any) {
        this.isFiltersChanged = 1;
        callback()
    }

    handleTableChange(pagination: any, filters: any, sorter: any) {
        //   getTableFields
        this.isFiltersChanged = 1;
        this.fetchSkuList(pagination.current);
    }

    handleNewTableChange(pagination: any, filters: any, sorter: any) {
        // getNewProductsTableFields
        this.fetchNewProductsList(pagination.current);
    }

    handleCTMTableChange(pagination: any, filters: any, sorter: any) {
        // getTableSkuFields
        this.isFiltersChanged = 1;
        this.fetchCtmList(pagination.current);
    }

    getFilterInfoForRoundingRules() {
        if (this.$roundingRules.selectMarket.id !== -1) {
            const self = this;
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(true);
            // (this.$refs.roundingRulesUpdateBuyerSegmentsRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(true);
            this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesProductSegmentsRef as any).toggleLoading(true);
            this.getCategoryInfoForRoundingRules();
            self.getRegionInfoForRoundingRules();
            self.getFormatInfoForRoundingRules();
            // self.getBuyerSegmentForRoundingRules();
            self.getClusterInfoForRoundingRules();
            self.loadProductsGroupForRoundingRules();
            self.loadProductsSubcategoriesForRoundingRules();
            self.loadProductSegmentsForRoundingRules();
        }
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    disableCalcPurchasePriceByClustersCheckbox() {
        if (!this.$calc.countByAvgPurchasePrice) {
            this.$calc.calcPurchasePriceByClusters = false;
            this.$calc.useArrivalDate = false;
        }
        if (this.$calc.countByAvgPurchasePrice) {
            this.$calc.countAtFuturePurchasePrice = false;
        }
    }

    disableCalcPurchasePriceByClustersCheckboxForSetupMaster() {
        if (!this.$setupMasterCalc.countByAvgPurchasePrice) {
            this.$setupMasterCalc.calcPurchasePriceByClusters = false;
            this.$setupMasterCalc.useArrivalDate = false;
        }
        if (this.$setupMasterCalc.countByAvgPurchasePrice) {
            this.$setupMasterCalc.countAtFuturePurchasePrice = false;
        }
    }

    disableCountByAvgPurchasePriceAndCalcPurchasePriceByClustersCheckboxes(eventCheckBox: boolean) {
        if (eventCheckBox) {
            this.$calc.calcPurchasePriceByClusters = false;
        }
    }

    disableCalcPurchasePriceByClustersCheckboxesForSetupMaster(eventCheckBox: boolean) {
        if (eventCheckBox) {
            this.$calc.calcPurchasePriceByClusters = false;
        }
    }

    destroyed() {
        if (this.viz != null) {
            this.viz.dispose();
        }

    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('tradingNetChanged', this.updateSelectMarket);
    }

    created() {
        // this.httpLoadModuleHints('Calc').then((r) => {
        //     this.$calc.currentModuleHints = r.data
        //     this.$calc.hintsLoaded = true
        // }).catch((e) => {
        // });
        // const self = this;
        // this.debounceMinRetailPrice = _.debounce(() => {
        //     self.checkPriceCorridorMinVal()
        // }, 500);
    }

    onTabsChanged(evt: number) {
        if (evt === 6) {
            (this.$refs.competitorsListRef as any).activate();
        } else {
            (this.$refs.competitorsListRef as any).deactivate();
        }
    }

    resetTables() {
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
    }

    resetActualProfitability() {
        this.actualProfitability = null;
    }

    resetActualProfitabilityForSetupMaster() {
        this.setupMasterActualProfitability = null;
    }

    resetRegularPricesProfitability() {
        this.regularPricesProfitability = null;
    }

    resetRegularPricesProfitabilityForSetupMaster() {
        this.regularPricesProfitabilityForSetupMaster = null;
    }

    resetData(type: TaskInfoFilterType) {
        this.skuListWithCalculating = false;
        switch (type) {
            case TaskInfoFilterType.group:
                this.$calc.categoryOfProduct = null;
                this.$calc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getCategoryInfo(null);
                this.loadProductsSubcategories();
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.category:
                this.$calc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.subcategories = [];
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductsSubcategories();
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.subcategory:
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfo.psegemnts = [];
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegments();
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$calc.formatSelected = null;
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.taskInfo.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getFormatInfo();
                this.getRegionInfo();
                this.getClusterInfo();
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.format:
                this.$calc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$calc.clusterSelected = null;
                this.taskInfo.storeRegionOptions = [];
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegments();
                this.getRegionInfo();
                this.getClusterInfo();
                this.viewCompetitors = []
                this.competitors = []
                break;
            case TaskInfoFilterType.region:
                this.$calc.clusterSelected = null;
                this.taskInfo.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegments();
                this.getClusterInfo();
                this.viewCompetitors = []
                this.competitors = []
                break;
        }
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.updateDataRange();
        this.hideSkuPanel();
        this.sortBySKU = -1;
        this.resetActualProfitability();
        this.resetRegularPricesProfitability();
        this.isFiltersChanged = 1;
        this.resetCompetitors();
        this.needLoadSkuList = false;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.needLoadNewProductList = false;
        this.taskId = 0;
        this.fileResult = '';
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.productCodesForAddCtmPurpose = [];
        this.productCodesForDeleteCtmPurpose = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.keyCharacteristicOneOptions = [];
        this.keyCharacteristicTwoOptions = [];
        this.keyCharacteristicThreeOptions = [];
        this.keyCharacteristicFourOptions = [];
        this.keyCharacteristicFiveOptions = [];
        this.recipeAttributesOptions = [];
        this.treatmentAttributesOptions = [];
        this.keyCharacteristicOneForNewProductOptions = [];
        this.keyCharacteristicTwoForNewProductOptions = [];
        this.keyCharacteristicThreeForNewProductOptions = [];
        this.keyCharacteristicFourForNewProductOptions = [];
        this.keyCharacteristicFiveForNewProductOptions = [];
        this.recipeAttributesForNewProductOptions = [];
        this.treatmentAttributesForNewProductOptions = [];
        this.newProductSegmentIdAndNameOptions = [];
        this.clearFiltersInNewProductsTable();
    }

    resetDataForSetupMaster(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$setupMasterCalc.categoryOfProduct = null;
                this.$setupMasterCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForSetupMaster.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                this.taskInfoForSetupMaster.subcategories = [];
                this.taskInfoForSetupMaster.psegemnts = [];
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getCategoryInfoForSetupMaster(null);
                this.loadProductsSubcategoriesForSetupMaster();
                this.loadProductSegmentsForSetupMaster();
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.category:
                this.$setupMasterCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForSetupMaster.subcategories = [];
                this.taskInfoForSetupMaster.psegemnts = [];
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductsSubcategoriesForSetupMaster();
                this.loadProductSegmentsForSetupMaster();
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.subcategory:
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForSetupMaster.psegemnts = [];
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForSetupMaster();
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$setupMasterCalc.formatSelected = null;
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.taskInfoForSetupMaster.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getFormatInfoForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.format:
                this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$setupMasterCalc.clusterSelected = null;
                this.taskInfoForSetupMaster.storeRegionOptions = [];
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForSetupMaster();
                this.getRegionInfoForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
            case TaskInfoFilterType.region:
                this.$setupMasterCalc.clusterSelected = null;
                this.taskInfoForSetupMaster.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForSetupMaster();
                this.getClusterInfoForSetupMaster();
                break;
        }
        this.updateDataRangeForSetupMaster();
        this.resetActualProfitabilityForSetupMaster();
        this.resetRegularPricesProfitabilityForSetupMaster();
    }

    resetDataForRoundingRules(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$roundingRules.categoryOfProduct = null;
                this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForRoundingRules.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                this.taskInfoForRoundingRules.subcategories = [];
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getCategoryInfoForRoundingRules(null);
                this.loadProductsSubcategoriesForRoundingRules();
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.category:
                this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForRoundingRules.subcategories = [];
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductsSubcategoriesForRoundingRules();
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.subcategory:
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoForRoundingRules.psegemnts = [];
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$roundingRules.formatSelected = null;
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.storeFormatOptions = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.getFormatInfoForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.format:
                this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.storeRegionOptions = [];
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getRegionInfoForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
            case TaskInfoFilterType.region:
                this.$roundingRules.clusterSelected = null;
                this.taskInfoForRoundingRules.clusterOptions = [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}];
                this.loadProductSegmentsForRoundingRules();
                this.getClusterInfoForRoundingRules();
                break;
        }
    }

    resetCompetitors() {
        this.selectedSkuNameFilter = [];
        this.selectedCompetitorsNameFilter = [];
        this.selectedCompetitorsPriorityFilter = [];
        this.selectedLastPriceFilter = [];
        this.selectedPromoPriceFilter = [];
        this.selectedCompetitorsPriceFilter = [];
        this.selectedDeltaFilter = [];
        this.selectedCompetitorsKviFilter = this.defaultFilterValue;
        this.selectedCompetitorsCtmFilter = this.defaultCtmFilterValue;
        this.selectKeyCharacteristicOneForCompetitors = [];
        this.selectKeyCharacteristicTwoForCompetitors = [];
        this.selectedMonitoringDateFilter = [];
    }

    onStepChange(current: number) {
        this.setupMasterStep = current;
    }

    setSetupMasterStepNext(stepNumber: number) {
        this.setupMasterStep = stepNumber + 1;
    }

    setSetupMasterStepPrevios(stepNumber: number) {
        this.setupMasterStep = stepNumber - 1;
    }

    updateProductGroup(groupOfProduct: number | null, key: string) {
        this.setItemsSuperset(groupOfProduct, key)
        if (groupOfProduct !== this.$calc.groupOfProduct) {
            this.resetPriceCorridor();
            this.resetDataRange();
            this.$calc.groupOfProduct = groupOfProduct;
            this.saveCalc();
            this.resetData(TaskInfoFilterType.group);
            this.updatePriceCorridorAndSkuList();
        }
    }

    updateProductGroupForRoundingRules(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$roundingRules.groupOfProduct) {
            this.$roundingRules.groupOfProduct = groupOfProduct;

            this.resetDataForRoundingRules(TaskInfoFilterType.group)
            this.saveRoundingRules();
            // this.resetData(TaskInfoFilterType.group);
            // this.updatePriceCorridorAndSkuList();
        }
    }

    updateProductGroupForSetupMaster(groupOfProduct: number | null) {
        if (groupOfProduct !== this.$setupMasterCalc.groupOfProduct) {
            this.resetPriceCorridorForSetupMaster();
            this.resetDataRangeForSetupMaster();
            this.$setupMasterCalc.groupOfProduct = groupOfProduct;
            const group = this.taskInfoForSetupMaster.groupsOfProduct.find((item) => {
                return item.value === groupOfProduct
            });
            if (group !== undefined) {
                this.setupMasterGroupName = group.label
            }
            this.saveSetupMasterCalc();
            this.resetDataForSetupMaster(TaskInfoFilterType.group);
            this.updatePriceCorridorForSetupMaster();
        }
    }

    updateProductCategory(category: number | null, key: string) {
        this.setItemsSuperset(category, key)
        if (category !== this.$calc.categoryOfProduct) {
            this.resetPriceCorridor();
            this.$calc.categoryOfProduct = category;
            this.updatePriceCorridorAndSkuList();
            this.resetIndividualConfigs();
            this.resetData(TaskInfoFilterType.category);
            this.saveCalc();
        }
    }

    updateProductCategoryForSetupMaster(category: number | null) {
        if (category !== this.$setupMasterCalc.categoryOfProduct) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.categoryOfProduct = category;
            const obj = this.taskInfoForSetupMaster.categoryOptions.find((item) => {
                return item.value === category
            });
            if (obj !== undefined) {
                this.setupMasterCategoryName = obj.label
            }
            this.updatePriceCorridorForSetupMaster();
            this.resetDataForSetupMaster(TaskInfoFilterType.category);
            this.saveSetupMasterCalc();
        }
    }

    updateProductCategoryForRoundingRules(category: number | null) {
        if (category !== this.$roundingRules.categoryOfProduct) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.categoryOfProduct = category;
            this.updatePriceCorridorForSetupMaster();
            this.resetDataForRoundingRules(TaskInfoFilterType.category);
            this.saveRoundingRules();
        }
    }

    updateFormat(format: number | null) {
        this.setItemsSuperset(format, 'FORMAT')
        if (format !== this.$calc.formatSelected) {
            this.resetPriceCorridor();
            this.$calc.formatSelected = format;
            this.updatePriceCorridorAndSkuList();
            this.resetData(TaskInfoFilterType.format);
            this.saveCalc();
        }
    }

    updateFormatForSetupMaster(format: number | null) {
        if (format !== this.$setupMasterCalc.formatSelected) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.formatSelected = format;
            const obj = this.taskInfoForSetupMaster.storeFormatOptions.find((item) => {
                return item.value === format
            });
            if (obj !== undefined) {
                this.setupMasterFormatName = obj.label
            }
            this.updatePriceCorridorForSetupMaster();
            this.resetDataForSetupMaster(TaskInfoFilterType.format);
            this.saveSetupMasterCalc();
        }
    }

    updateFormatForRoundingRules(format: number | null) {
        if (format !== this.$roundingRules.formatSelected) {
            this.$roundingRules.formatSelected = format;
            this.resetDataForRoundingRules(TaskInfoFilterType.format);
            this.saveRoundingRules();
        }
    }

    resetIndividualConfigs() {
        this.$calc.individualCommonParams = {};
    }

    updateRegions(list: number[]) {
        this.setItemsSuperset(list, 'REGION')
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.comptetitorsTabData.regionSelected)) {
            this.resetPriceCorridor();
            this.comptetitorsTabData.regionSelected = list;
            // this.onDropdownClosed = () => {
            //     this.saveCalc();
            //     this.updatePriceCorridorAndSkuList();
            //     this.resetData(TaskInfoFilterType.region);
            // };
            // if (!this.dropDownOpen) {
            //     this.onDropdownClosed.apply(this.dropDownOpen);
            //     this.onDropdownClosed = null;
            // }
        } else if (this.comptetitorsTabData.regionSelected[0] === 0) {
            this.comptetitorsTabData.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegionsForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.regionSelected)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.regionSelected = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForSetupMaster.storeRegionOptions.filter((region) => list.includes(region.value!!))
                .forEach((region) => {
                    this.setupMasterRegionNames = region.label
                });
            this.onDropdownClosedForSetupMaster = () => {
                this.saveSetupMasterCalc();
                this.updatePriceCorridorForSetupMaster();
                this.resetDataForSetupMaster(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.regionSelected[0] === 0) {
            this.$setupMasterCalc.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegionsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.regionSelected)) {
            this.$roundingRules.regionSelected = list;
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.region);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.regionSelected[0] === 0) {
            this.$roundingRules.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateBuyerSegments(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.buyerSegmentsList)) {
            this.resetPriceCorridor();
            this.updatePriceCorridorAndSkuList();
            this.$calc.buyerSegmentsList = list;
            this.saveCalc();
        } else if (this.$calc.buyerSegmentsList[0] === 0) {
            this.$calc.buyerSegmentsList = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategories(list: number[], key: string) {
        this.setItemsSuperset(list, key)
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.subcategories)) {
            this.resetPriceCorridor();
            this.$calc.subcategories = list;
            this.onDropdownClosed = () => {
                this.updatePriceCorridorAndSkuList();
                this.saveCalc();
                this.resetData(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.subcategories[0] === 0) {
            this.$calc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }


    updateSubcategoriesForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.subcategories)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.subcategories = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForSetupMaster.subcategories.filter((subcat) => list.includes(subcat.value!!))
                .forEach((subcat) => {
                    this.setupMasterSubcategoryNames = subcat.label
                });
            this.onDropdownClosedForSetupMaster = () => {
                this.updatePriceCorridorForSetupMaster();
                this.saveSetupMasterCalc();
                this.resetDataForSetupMaster(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.subcategories[0] === 0) {
            this.$setupMasterCalc.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSubcategoriesForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.subcategories)) {
            this.$roundingRules.subcategories = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForRoundingRules.subcategories.filter((subcat) => list.includes(subcat.value!!))
                .forEach((subcat) => {
                    this.setupMasterSubcategoryNames = subcat.label
                });
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.subcategory);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.subcategories[0] === 0) {
            this.$roundingRules.subcategories = this.defaultIntSelectBox.map((i) => i.value);
        }
    }


    updateProductSegment(list: number[], key: string) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.productSegments)) {
            this.resetPriceCorridor();
            this.$calc.productSegments = list;
            this.onDropdownClosed = () => {
                this.updatePriceCorridorAndSkuList();
                this.saveCalc();
                this.resetData(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.productSegments[0] === 0) {
            this.$calc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }


    updateProductSegmentsForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.productSegments)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.productSegments = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForSetupMaster.psegemnts.filter((subcat) => list.includes(subcat.value!!))
                .forEach((subcat) => {
                    this.setupMasterSubcategoryNames = subcat.label
                });
            this.onDropdownClosedForSetupMaster = () => {
                this.updatePriceCorridorForSetupMaster();
                this.saveSetupMasterCalc();
                this.resetDataForSetupMaster(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.productSegments[0] === 0) {
            this.$setupMasterCalc.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateProductSegmentsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.productSegments)) {
            this.$roundingRules.productSegments = list;
// tslint:disable-next-line: no-non-null-assertion
            this.taskInfoForRoundingRules.psegemnts.filter((segmentProduct) => list.includes(segmentProduct.value!!))
                .forEach((segmentProduct) => {
                    this.setupMasterSubcategoryNames = segmentProduct.label
                });
            this.onDropdownClosedForRoundingRules = () => {
                this.saveRoundingRules();
                this.resetDataForRoundingRules(TaskInfoFilterType.p_segemnt);
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.productSegments[0] === 0) {
            this.$roundingRules.productSegments = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updatePriceSegments(list: Segment[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item.name === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item.name === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentPrice = [];
                } else {
                    this.selectSegmentPrice = list;
                }
            } else {
                this.selectSegmentPrice = list;
            }
        }
    }

    updateKeyCharacteristicOne(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicOne = [];
                } else {
                    this.selectKeyCharacteristicOne = list;
                }
            } else {
                this.selectKeyCharacteristicOne = list;
            }
        }
    }

    updateNewProductKeyCharacteristicOne(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicOneForNewProduct = [];
                } else {
                    this.selectKeyCharacteristicOneForNewProduct = list;
                }
            } else {
                this.selectKeyCharacteristicOneForNewProduct = list;
            }
        }
    }

    updateKeyCharacteristicTwo(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicTwo = [];
                } else {
                    this.selectKeyCharacteristicTwo = list;
                }
            } else {
                this.selectKeyCharacteristicTwo = list;
            }
        }
    }

    updateNewProductKeyCharacteristicTwo(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectKeyCharacteristicTwoForNewProduct = [];
                } else {
                    this.selectKeyCharacteristicTwoForNewProduct = list;
                }
            } else {
                this.selectKeyCharacteristicTwoForNewProduct = list;
            }
        }
    }

    updateRecipeAttributes(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRecipeAttributes = [];
                } else {
                    this.selectRecipeAttributes = list;
                }
            } else {
                this.selectRecipeAttributes = list;
            }
        }
    }

    updateNewProductRecipeAttributes(list: string[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === 'All'
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === 'All'
                });
                if (index2 !== -1) {
                    this.selectRecipeAttributesForNewProduct = [];
                } else {
                    this.selectRecipeAttributesForNewProduct = list;
                }
            } else {
                this.selectRecipeAttributesForNewProduct = list;
            }
        }
    }

    updateTreatmentAttributes(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTreatmentAttributes = [];
                } else {
                    this.selectTreatmentAttributes = list;
                }
            } else {
                this.selectTreatmentAttributes = list;
            }
        }
    }

    updateNewProductTreatmentAttributes(list: number[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item === -1
            });
            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item === -1
                });
                if (index2 !== -1) {
                    this.selectTreatmentAttributesForNewProduct = [];
                } else {
                    this.selectTreatmentAttributesForNewProduct = list;
                }
            } else {
                this.selectTreatmentAttributesForNewProduct = list;
            }
        }
    }

    updateProductSegmentIdAndName(list: ProductSegmentIdAndName[]) {
        // Костыль. {{ $t("shared.reportsSchedule.filter") }}ую потому что пришлось сделать :default_value="[{value: -1, label: this.$t('shared.selectBox.all') as string}]", т.к. класс Multiselect некорректно обрабатывает массив с 2-мя значениями
        // и вариант :default_value="[{value: {segmentId: -1, segmentName: 'All'}, label: this.$t('shared.selectBox.all') as string}]" не срабатывает
        list = list.filter((s) => {
            return typeof s.segmentName !== 'undefined' && typeof s.segmentId !== 'undefined'
        });
        if (list.length > 0) {
            this.selectProductSegmentIdAndName = list;
        } else {
            this.selectProductSegmentIdAndName = [];
        }
    }

    updateSegmentIdAndNameForNewProducts(list: ProductSegmentIdAndName[]) {
        // Костыль. {{ $t("shared.reportsSchedule.filter") }}ую потому что пришлось сделать :default_value="[{value: -1, label: this.$t('shared.selectBox.all') as string}]", т.к. класс Multiselect некорректно обрабатывает массив с 2-мя значениями
        // и вариант :default_value="[{value: {segmentId: -1, segmentName: 'All'}, label: this.$t('shared.selectBox.all') as string}]" не срабатывает
        list = list.filter((s) => {
            return typeof s.segmentName !== 'undefined' && typeof s.segmentId !== 'undefined'
        });
        if (list.length > 0) {
            this.selectNewProductSegmentIdAndName = list;
        } else {
            this.selectNewProductSegmentIdAndName = [];
        }
    }

    updatePriceSegmentsForNewProducts(list: Segment[]) {
        if (list.length > 0) {
            const index = list.findIndex((item) => {
                return item.name === 'All'
            });

            if (index !== -1) {
                list.shift()
                const index2 = list.findIndex((item) => {
                    return item.name === 'All'
                });
                if (index2 !== -1) {
                    this.selectSegmentPriceForNewProducts = [];
                } else {
                    this.selectSegmentPriceForNewProducts = list;
                }
            } else {
                this.selectSegmentPriceForNewProducts = list;
            }
        }
    }

    updateSeasons(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$calc.seasonSelected)) {
            this.resetPriceCorridor();
            this.$calc.seasonSelected = list;
            this.onDropdownClosed = () => {
                this.priceCorridorInfo();
                this.refreshSkuList();
                this.saveCalc();
            };
            if (!this.dropDownOpen) {
                this.onDropdownClosed.apply(this.dropDownOpen);
                this.onDropdownClosed = null;
            }
        } else if (this.$calc.seasonSelected[0] === 0) {
            this.$calc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasonsForSetupMaster(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$setupMasterCalc.seasonSelected)) {
            this.resetPriceCorridorForSetupMaster();
            this.$setupMasterCalc.seasonSelected = list;
            this.onDropdownClosedForSetupMaster = () => {
                this.priceCorridorInfoForSetupMaster();
                this.saveSetupMasterCalc();
            };
            if (!this.dropDownOpenForSetupMaster) {
                this.onDropdownClosedForSetupMaster.apply(this.dropDownOpenForSetupMaster);
                this.onDropdownClosedForSetupMaster = null;
            }
        } else if (this.$setupMasterCalc.seasonSelected[0] === 0) {
            this.$setupMasterCalc.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateSeasonsForRoundingRules(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$roundingRules.seasonSelected)) {
            // this.resetPriceCorridorForSetupMaster();
            this.$roundingRules.seasonSelected = list;
            this.onDropdownClosedForRoundingRules = () => {
                // this.priceCorridorInfoForSetupMaster();
                this.saveRoundingRules();
            };
            if (!this.dropDownOpenForRoundingRules) {
                this.onDropdownClosedForRoundingRules.apply(this.dropDownOpenForRoundingRules);
                this.onDropdownClosedForRoundingRules = null;
            }
        } else if (this.$roundingRules.seasonSelected[0] === 0) {
            this.$roundingRules.seasonSelected = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    resetPriceCorridor() {
        this.comptetitorsTabData.changePriceCorridor = false;
    }

    resetPriceCorridorForSetupMaster() {
        this.$setupMasterCalc.changePriceCorridor = false;
    }

    updateDataRange() {
        this.dataRangeInfo()
    }

    updateDataRangeForSetupMaster() {
        this.dataRangeInfoForSetupMaster()
    }

    resetDataRange() {
        this.firstDate = 0;
        this.lastDate = 0;
    }

    resetDataRangeForSetupMaster() {
        this.setupMasterFirstDate = 0;
        this.setupMasterLastDate = 0;
    }

    resetKVIparams() {
        this.useFindKviRecommendsParam = false;
        this.$calc.percentageOfRecommendsKviCount = 10;
        this.$calc.useSegmentsPriceInSearchKVIRecParam = false;
        this.$calc.saveKviSign = false;
    }

    updateSelectMarket(market: SelectMarket) {
        this.setItemsSuperset(market.tradingName, this.COMPANY);

        const getFilters = localStorage.getItem('FILTERS_SUPERSET');

        const filters = {
            GROUP: '',
            CATEGORY: '',
            SUB_CATEGORY: '',
            FORMAT: '',
            REGION: '',
            CLASTER: '',
            COMPANY: JSON.parse(getFilters === null ? '' : getFilters).COMPANY,
        };
        localStorage.setItem('FILTERS_SUPERSET', JSON.stringify(filters));

        this.refreshDetailTable()

        if (this.$calc.selectMarket == null || this.$calc.selectMarket.id !== market.id) {
            this.skuListWithCalculating = false;
            this.resetCalcData();
            this.$calc.selectMarket = market;
            this.skuList = [];
            this.newProductsList = [];
            this.initTask();
            this.saveCalc();
            this.tableKey = Math.random();
            this.competitorTableKey = Math.random();
            this.resetDataRange();
            this.hideSkuPanel();
            this.resetActualProfitability();
            this.resetRegularPricesProfitability();
            this.isFiltersChanged = 1;
            this.findAutomaticallyPriceSegments = false;
            this.resetCompetitors();
            this.needLoadSkuList = false;
            this.needCalculateSkuLastPricesOnly = false;
            this.needCalculateSkuActualProfitabilityOnly = false;
            this.calcSkuLastPricesButtonDisabled = false;
            this.calcSkuActualProfitButtonDisabled = false;
            this.needLoadNewProductList = false;
            this.resetKVIparams();
            this.taskId = 0;
            this.fileResult = '';
            this.productCodesForAddKvi = [];
            this.productCodesForDeleteKvi = [];
            this.productCodesForAddCtmPurpose = [];
            this.productCodesForDeleteCtmPurpose = [];
            this.segmentPriceOptions = [];
            this.productSegmentIdAndNameOptions = [];
            this.keyCharacteristicOneOptions = [];
            this.keyCharacteristicTwoOptions = [];
            this.keyCharacteristicThreeOptions = [];
            this.keyCharacteristicFourOptions = [];
            this.keyCharacteristicFiveOptions = [];
            this.recipeAttributesOptions = [];
            this.treatmentAttributesOptions = [];
            this.keyCharacteristicOneForNewProductOptions = [];
            this.keyCharacteristicTwoForNewProductOptions = [];
            this.keyCharacteristicThreeForNewProductOptions = [];
            this.keyCharacteristicFourForNewProductOptions = [];
            this.keyCharacteristicFiveForNewProductOptions = [];
            this.recipeAttributesForNewProductOptions = [];
            this.treatmentAttributesForNewProductOptions = [];
            this.newProductSegmentIdAndNameOptions = [];
            this.clearFiltersInNewProductsTable();
            this.paramsRulesKey += 1;
            this.$calc.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('shared.parametersTab.maxGrossMargin') as string}
        }
    }

    updateSelectMarketForSetupMaster(market: SelectMarket) {
        if (this.$setupMasterCalc.selectMarket == null || this.$setupMasterCalc.selectMarket.id !== market.id) {
            this.resetSetupMasterCalcData();
            this.$setupMasterCalc.selectMarket = market;
            this.initTaskForSetupMaster();
            this.saveSetupMasterCalc();
            this.resetDataRangeForSetupMaster();
            this.resetActualProfitabilityForSetupMaster();
            this.resetRegularPricesProfitabilityForSetupMaster();
            this.findAutomaticallyPriceSegmentsForSetupMaster = false;
        }
    }

    updateSelectMarketForRoundingRules(market: SelectMarket) {
        if (this.$roundingRules.selectMarket == null || this.$roundingRules.selectMarket.id !== market.id) {
            this.resetRoundingRulesData()
            this.$roundingRules.selectMarket = market;
            this.initTaskForRoundingRules()
            this.refreshRoundingRulesList()
            this.saveRoundingRules();
        }
    }

    hideTableau(): boolean {
        return this.$disallowedModules.includes('calc-tableau');
    }

    hideNewProductPricingPanel(): boolean {
        return this.$disallowedModules.includes('newProduct-pricing');
    }

    showRoundPricesWithEqualCompStrategy(): boolean {
        return this.$calc.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    showRoundPricesWithEqualCompStrategyForSetupMaster(): boolean {
        return this.$setupMasterCalc.competitorsPriceStrategy.value === CompetitorsPriceStrategies.EQUALS;
    }

    updatedTableau() {
        const indexCategory = this.taskInfo.categoryOptions.findIndex((item) => {
            return item.value === this.$calc.categoryOfProduct
        });
        // const sheet = this.viz.getWorkbook().getActiveSheet() - не срабатывает на этой версии Табло, добавил getWorksheets();
        const sheet = this.viz.getWorkbook().getActiveSheet().getWorksheets();

        if (this.$calc.selectMarket.id !== -1) {
            sheet[0].applyFilterAsync('Компания', this.$calc.selectMarket.tradingName, (window as any).tableau.FilterUpdateType.REPLACE);
        } else {
            sheet[0].clearFilterAsync('Компания')
        }
        if (indexCategory !== -1) {
            sheet[0].applyFilterAsync('Категория товаров', this.taskInfo.categoryOptions[indexCategory].label, (window as any).tableau.FilterUpdateType.REPLACE)
        } else {
            sheet[0].clearFilterAsync('Категория товаров')
        }
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
            || status === 'EmptyData'
            || status === 'ExecutionException'
            || status.includes('Error'));
    }

    clearFilterDisabled() {
        return !this.skuFilter;
    }

    clearNewProductsFilterDisabled() {
        return !this.newProductsFilter;
    }

    clearFilter() {
        this.skuFilter = '';
        this.refreshSkuList()
    }

    clearFilterInUpperPanel() {
        this.skuFilter = '';
        this.refreshSkuTableInPanel()
    }

    clearNewProductsSearchFilter() {
        this.newProductsFilter = '';
        this.refreshNewProductsTable()
    }

    selectData(): [number[], number[], number[], string | null, Segment[] | null] {
        const selectSeasons: number[] = (this.$calc.seasonSelected.length === 0 || (this.$calc.seasonSelected.length === 1 && this.$calc.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$calc.seasonSelected)!!;
        const selectRegions: number[] = (this.$calc.regionSelected.length === 0 || (this.$calc.regionSelected.length && this.$calc.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$calc.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$calc.buyerSegmentsList.length === 0 || (this.$calc.buyerSegmentsList.length && this.$calc.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$calc.buyerSegmentsList)!!;
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });

        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        return [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments];
    }

    selectDataForSetupMaster(): [number[], number[], number[], string | null, Segment[] | null] {
        const selectSeasons: number[] = (this.$setupMasterCalc.seasonSelected.length === 0 || (this.$setupMasterCalc.seasonSelected.length === 1 && this.$setupMasterCalc.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$setupMasterCalc.seasonSelected)!!;
        const selectRegions: number[] = (this.$setupMasterCalc.regionSelected.length === 0 || (this.$setupMasterCalc.regionSelected.length && this.$setupMasterCalc.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$setupMasterCalc.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$setupMasterCalc.buyerSegmentsList.length === 0 || (this.$setupMasterCalc.buyerSegmentsList.length && this.$setupMasterCalc.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$setupMasterCalc.buyerSegmentsList)!!;
        const ctm: string | null = this.selectCTM === 'all' ? null : this.selectCTM;
        this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
            return item.name !== 'All'
        });

        const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });
        return [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments];
    }

    selectDataForRoundingRulesSeasonsRegions(): [number[], number[], number[]] {
        const selectSeasons: number[] = (this.$roundingRules.seasonSelected.length === 0 || (this.$roundingRules.seasonSelected.length === 1 && this.$roundingRules.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.seasonSelected)!!;
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$roundingRules.buyerSegmentsList.length === 0 || (this.$roundingRules.buyerSegmentsList.length === 1 && this.$roundingRules.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.buyerSegmentsList)!!;
        // const ctm: string | null = this.selectCTM.value === 'all' ? null : this.selectCTM.value;

        this.$log.log(selectRegions)
        return [selectSeasons, selectRegions, selectBuyerSegment];
    }

    priceCorridorInfo() {
        if (!this.$calc.changePriceCorridor) {
            this.hideSkuPanel();
            return;
        }
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        this.isPriceCorridorCalculated = true;

        const filters = this.getCalcFilter();
        this.httpPostPriceCorridor(filters)
            .then((r) => {
                    this.$calc.priceCorridor = r.data;
                    this.isPriceCorridorCalculated = false;
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorLoadPriceCorridor') as string);
                this.$log.error('Error occurred [load price corridor]', e);
                this.isPriceCorridorCalculated = false;
            });
    }

    priceCorridorInfoForSetupMaster() {
        if (!this.$setupMasterCalc.changePriceCorridor) {
            return;
        }
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null) {
            return;
        }
        this.isPriceCorridorCalculatedForSetupMaster = true;

        const filters = this.getCalcFilterForSetupMaster();
        this.httpPostPriceCorridor(filters)
            .then((r) => {
                    this.$setupMasterCalc.priceCorridor = r.data;
                    this.isPriceCorridorCalculatedForSetupMaster = false;
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorLoadPriceCorridor') as string);
                this.$log.error('Error occurred [load price corridor]', e);
                this.isPriceCorridorCalculatedForSetupMaster = false;
            });
    }

    dataRangeInfo() {
        if (!this.showDataRange) {
            return;
        }
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.firstDate = 0;
            this.lastDate = 0;
            return;
        }
        this.isDataRangeCalculated = true;

        const filters = this.getCalcFilter()
        this.httpPostDataRange(filters)
            .then((r) => {
                    if (r.data.firstDate == null && r.data.lastDate == null) {
                        this.firstDate = 0;
                        this.lastDate = 0;
                        this.showInfo(this.$t('shared.parametersTab.noDateRangeData') as string);
                        this.isDataRangeCalculated = false;
                    } else {
                        this.firstDate = r.data.firstDate;
                        this.lastDate = r.data.lastDate;
                        this.isDataRangeCalculated = false;
                    }
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorGetDateRange') as string);
                this.$log.error('Error occurred [load data range]', e);
                this.isDataRangeCalculated = false;
            });
    }

    dataRangeInfoForSetupMaster() {
        if (!this.showDataRangeForSetupMaster) {
            return;
        }
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null) {
            this.setupMasterFirstDate = 0;
            this.setupMasterLastDate = 0;
            return;
        }
        this.isDataRangeCalculatedForSetupMaster = true;

        const filters = this.getCalcFilterForSetupMaster()
        this.httpPostDataRange(filters)
            .then((r) => {
                    if (r.data.firstDate == null && r.data.lastDate == null) {
                        this.setupMasterFirstDate = 0;
                        this.setupMasterLastDate = 0;
                        this.showInfo(this.$t('shared.parametersTab.noDateRangeData') as string);
                        this.isDataRangeCalculatedForSetupMaster = false;
                    } else {
                        this.setupMasterFirstDate = r.data.firstDate;
                        this.setupMasterLastDate = r.data.lastDate;
                        this.isDataRangeCalculatedForSetupMaster = false;
                    }
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorGetDateRange') as string);
                this.$log.error('Error occurred [load data range]', e);
                this.isDataRangeCalculatedForSetupMaster = false;
            });
    }

    checkPriceCorridorMinVal() {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filters: BaseFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: +this.$calc.calculationDepth,
            calculationDay: +this.$calc.calculationDay,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
        };

        this.httpPostMinRetailPrice(filters)
            .then((r) => {
                    const data = r.data;
                    this.$log.debug('Min retail price', data);
                    if (data.minRetailPrice !== null && this.$calc.priceCorridor.min < data.minRetailPrice) {
                        this.showInfo(this.$t('shared.competitorsPricesList.lowerBoundLessThanMinRetail') as string + data.minRetailPrice)
                    }
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.competitorsPricesList.errorLoadMinRetailPrice') as string)
            });
    }

    tryAutomaticallyFindParams() {
        if (this.$calc.categoryStrategy.value !== CategoryStrategies.EMPTY) {
            this.tryFindParams()
        }
    }

    tryFindRulesParams() {
        this.serverConfigTimeout = null;
        const [selectSeasons, selectRegions] = this.selectDataForRoundingRulesSeasonsRegions();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$roundingRules.selectMarket.id;
        findParams.groupOfProduct = this.$roundingRules.groupOfProduct;
        findParams.category = this.$roundingRules.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$roundingRules.subcategories)!!;
        findParams.storeCluster = this.$roundingRules.clusterSelected == null ? null : this.$roundingRules.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$roundingRules.formatSelected;
        findParams.categoryStrategy = this.$roundingRules.categoryStrategy.value

        if (findParams.canLoadRoundingRules()) {
            this.loadingConfigs = true;
            this.httpFindRulesParams(findParams, 'BASE')
                .then((r) => {
                    const params = r.data;
                    this.$roundingRules.pennies = params.pennies
                    this.$roundingRules.allNewPricesWithoutPennies = params.allNewPricesWithoutPennies
                    this.$roundingRules.roundKviCompetitorPrice = params.roundKviCompetitorPrice
                    this.$roundingRules.roundPricesWithEqualCompStrategy = params.roundPricesWithEqualCompStrategy
                    this.$roundingRules.randomPennies = params.randomPennies
                    this.$roundingRules.bigDigit = params.bigDigit
                    this.$roundingRules.manualPennies = params.manualPennies

                    this.loadingConfigs = false
                })
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('shared.parametersTab.errorLoadParams') as string);
                })
        }
    }

    tryFindParams() {
        this.serverConfigTimeout = null;
        const [selectSeasons, selectRegions] = this.selectData();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$calc.selectMarket.id;
        findParams.groupOfProduct = this.$calc.groupOfProduct;
        findParams.category = this.$calc.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$calc.subcategories)!!;
        findParams.storeCluster = this.$calc.clusterSelected == null ? null : this.$calc.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$calc.formatSelected;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = LocalData.filterNumberArrays(this.$calc.productSegments)!!
        findParams.categoryStrategy = this.$calc.categoryStrategy.value
        if (findParams.canLoad()) {
            this.loadingConfigs = true;
            this.loadCommonParams(findParams)
                .then((r) => this.loadCommonIndividual(findParams))
                .finally(() => {
                    this.saveCalc();
                    this.loadingConfigs = false
                    this.refreshSkuList()
                    this.refreshSkuTableInPanel()
                })
                .catch((e) => {
                    this.loadingConfigs = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('shared.roundingPrices.errorLoadCalcParams') as string);
                })
        }
    }

    tryFindParamsForSetupMaster() {
        const [selectSeasons, selectRegions] = this.selectDataForSetupMaster();
        const findParams = new FindFiltersParams();
        findParams.tradingId = this.$setupMasterCalc.selectMarket.id;
        findParams.groupOfProduct = this.$setupMasterCalc.groupOfProduct;
        findParams.category = this.$setupMasterCalc.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        findParams.subcategories = LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories)!!;
        findParams.storeCluster = this.$setupMasterCalc.clusterSelected == null ? null : this.$setupMasterCalc.clusterSelected;
        findParams.seasonValues = selectSeasons;
        findParams.storeRegionValues = selectRegions;
        findParams.storeFormat = this.$setupMasterCalc.formatSelected;
        findParams.categoryStrategy = this.$setupMasterCalc.categoryStrategy.value
        // tslint:disable-next-line: no-non-null-assertion
        findParams.productSegments = LocalData.filterNumberArrays(this.$setupMasterCalc.productSegments)!!
        if (findParams.canLoad()) {
            this.loadingConfigsForSetupMaster = true;
            this.loadCommonParamsForSetupMaster(findParams)
                .finally(() => {
                    this.saveSetupMasterCalc();
                    this.loadingConfigsForSetupMaster = false
                })
                .catch((e) => {
                    this.loadingConfigsForSetupMaster = false;
                    this.$log.error('Error occurred while loading configs', e);
                    this.showError(this.$t('shared.roundingPrices.errorLoadCalcParams') as string);
                })
        }
    }

    getCalcIndividualFilters(): IndividualConfigCmd<CalcIndividualConfigMap> {
        const [selectSeasons, selectRegions] = this.selectData();
        const saveParams = new IndividualConfigCmd<CalcIndividualConfigMap>();
        saveParams.tradingId = this.$calc.selectMarket.id;
        saveParams.groupOfProduct = this.$calc.groupOfProduct;
        saveParams.category = this.$calc.categoryOfProduct;
        // tslint:disable-next-line: no-non-null-assertion
        saveParams.subcategories = LocalData.filterNumberArrays(this.$calc.subcategories)!!;
        saveParams.storeCluster = this.$calc.clusterSelected == null || this.$calc.clusterSelected === 0 ? null : this.$calc.clusterSelected;
        saveParams.seasonValues = selectSeasons;
        saveParams.storeRegionValues = selectRegions;
        saveParams.storeFormat = this.$calc.formatSelected;
        // tslint:disable-next-line: no-non-null-assertion
        saveParams.productSegments = LocalData.filterNumberArrays(this.$calc.productSegments)!!
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.$calc.individualCommonParams) {
            const value = this.$calc.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        saveParams.individualConfigs = individualConfigsObj;
        saveParams.productRangesAndInternalCodes = this.productRangesArray;
        return saveParams
    }

    saveIndividualConfigs() {
        const saveParams = this.getCalcIndividualFilters()
        this.httpSaveBaseIndividualConfig(saveParams)
            .then((r) => {
                this.showInfo(this.$t('shared.productsList.successSaveIndParams') as string);
                EventBus.$emit('onCalcParamsSaved')
                this.refreshSkuList();
            })
            .catch((e) => {
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
            })
    }

    saveIndividualConfigsInSkuPanel() {
        const saveParams = this.getCalcIndividualFilters()
        this.httpSaveBaseIndividualConfig(saveParams)
            .then((r) => {
                this.showInfo(this.$t('shared.productsList.successSaveIndParams') as string);
                EventBus.$emit('onCalcParamsSaved')
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
            })
    }

    initTaskModuleItem() {
        if (this.itemFromList.id === -1) {
            return;
        }
        this.$refs.updateRegionsRef && (this.$refs.updateRegionsRef as any).toggleLoading(true);
        this.$refs.updateSeasonsRef && (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        this.$refs.updateBuyerSegmentsRef && (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        this.$refs.formatSelectedRef && (this.$refs.formatSelectedRef as any).toggleLoading(true);
        this.$refs.groupSelectedRef && (this.$refs.groupSelectedRef as any).toggleLoading(true);
        this.$refs.clasterSelectedRef && (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        this.$refs.groupOfProductRef && (this.$refs.groupOfProductRef as any).toggleLoading(true);
        this.$refs.subcategoriesRef && (this.$refs.subcategoriesRef as any).toggleLoading(true);
        this.$refs.productSegmentsRef && (this.$refs.productSegmentsRef as any).toggleLoading(true);

        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];

        this.getRegionInfo();

        this.getCategoryInfo(() => {});

        this.loadProductsGroup();
        this.getRegionInfo();
        this.getFormatInfo();
        this.getBuyerSegment();
        this.getClusterInfo();
        this.loadProductsSubcategories();
        this.loadProductSegments();
    }

    initTask() {
        if (this.$calc.selectMarket.id === -1) {
            return;
        }
        this.$refs.updateRegionsRef && (this.$refs.updateRegionsRef as any).toggleLoading(true);
        this.$refs.updateSeasonsRef && (this.$refs.updateSeasonsRef as any).toggleLoading(true);
        this.$refs.updateBuyerSegmentsRef && (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(true);
        this.$refs.formatSelectedRef && (this.$refs.formatSelectedRef as any).toggleLoading(true);
        this.$refs.groupSelectedRef && (this.$refs.groupSelectedRef as any).toggleLoading(true);
        this.$refs.clasterSelectedRef && (this.$refs.clasterSelectedRef as any).toggleLoading(true);
        this.$refs.groupOfProductRef && (this.$refs.groupOfProductRef as any).toggleLoading(true);
        this.$refs.subcategoriesRef && (this.$refs.subcategoriesRef as any).toggleLoading(true);
        this.$refs.productSegmentsRef && (this.$refs.productSegmentsRef as any).toggleLoading(true);

        this.$calc.categoryOfProduct = null;
        this.$calc.clusterSelected = null;
        this.$calc.formatSelected = null;
        this.$calc.groupOfProduct = null;
        this.$calc.subcategories = [];
        this.$calc.productSegments = [];
        this.taskInfo.storeFormatOptions = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.buyerSegmentOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.clusterOptions = [];
        this.taskInfo.psegemnts = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
        const self = this;
        this.getCategoryInfo(() => {
            self.loadProductsGroup();
            self.getRegionInfo();
            self.getFormatInfo();
            self.getBuyerSegment();
            self.getClusterInfo();
            self.loadProductsSubcategories();
            self.loadProductSegments();
        });
    }

    initTaskForSetupMaster() {
        if (this.$setupMasterCalc.selectMarket.id === -1) {
            return;
        }
        this.$refs.setupMasterUpdateRegionsRef && (this.$refs.setupMasterUpdateRegionsRef as any).toggleLoading(true);
        this.$refs.setupMasterUpdateSeasonsRef && (this.$refs.setupMasterUpdateSeasonsRef as any).toggleLoading(true);
        this.$refs.setupMasterFormatSelectedRef && (this.$refs.setupMasterFormatSelectedRef as any).toggleLoading(true);
        this.$refs.setupMasterGroupSelectedRef && (this.$refs.setupMasterGroupSelectedRef as any).toggleLoading(true);
        this.$refs.setupMasterClasterSelectedRef && (this.$refs.setupMasterClasterSelectedRef as any).toggleLoading(true);
        this.$refs.setupMasterGroupOfProductRef && (this.$refs.setupMasterGroupOfProductRef as any).toggleLoading(true);
        this.$refs.setupMasterSubcategoriesRef && (this.$refs.setupMasterSubcategoriesRef as any).toggleLoading(true);
        this.$refs.setupMasterProductSegmentsRef && (this.$refs.setupMasterProductSegmentsRef as any).toggleLoading(true);

        this.$setupMasterCalc.categoryOfProduct = null;
        this.$setupMasterCalc.clusterSelected = null;
        this.$setupMasterCalc.formatSelected = null;
        this.$setupMasterCalc.groupOfProduct = null;
        this.$setupMasterCalc.subcategories = [];
        this.taskInfoForSetupMaster.storeFormatOptions = [];
        this.taskInfoForSetupMaster.storeRegionOptions = [];
        this.taskInfoForSetupMaster.categoryOptions = [];
        this.taskInfoForSetupMaster.clusterOptions = [];
        this.taskInfoForSetupMaster.psegemnts = [];
        this.taskInfoForSetupMaster.subcategories = [];
        this.taskInfoForSetupMaster.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
        const self = this;
        this.getCategoryInfoForSetupMaster(() => {
            self.loadProductsGroupForSetupMaster();
            self.getRegionInfoForSetupMaster();
            self.getFormatInfoForSetupMaster();
            self.getClusterInfoForSetupMaster();
            self.loadProductsSubcategoriesForSetupMaster();
            self.loadProductSegmentsForSetupMaster();
        });
    }

    initTaskForRoundingRules() {
        if (this.$roundingRules.selectMarket.id === -1) {
            return;
        }
        this.$refs.roundingRulesUpdateRegionsRef && (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(true);
        this.$refs.roundingRulesUpdateSeasonsRef && (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(true);
        this.$refs.roundingRulesFormatSelectedRef && (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(true);
        this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(true);
        this.$refs.roundingRulesClasterSelectedRef && (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(true);
        this.$refs.roundingRulesGroupOfProductRef && (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(true);
        this.$refs.roundingRulesSubcategoriesRef && (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(true);

        this.$roundingRules.categoryOfProduct = null;
        this.$roundingRules.clusterSelected = null;
        this.$roundingRules.formatSelected = null;
        this.$roundingRules.groupOfProduct = null;
        this.$roundingRules.subcategories = [];
        this.taskInfoForRoundingRules.storeFormatOptions = [];
        this.taskInfoForRoundingRules.storeRegionOptions = [];
        this.taskInfoForRoundingRules.categoryOptions = [];
        this.taskInfoForRoundingRules.clusterOptions = [];
        this.taskInfoForRoundingRules.psegemnts = [];
        this.taskInfoForRoundingRules.subcategories = [];
        this.taskInfoForRoundingRules.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
        const self = this;
        this.getCategoryInfoForRoundingRules(() => {
            self.loadProductsGroupForRoundingRules();
            self.getRegionInfoForRoundingRules();
            self.getFormatInfoForRoundingRules();
            self.getClusterInfoForRoundingRules();
            self.loadProductsSubcategoriesForRoundingRules();
            self.loadProductSegmentsForRoundingRules();
        });
    }

    loadProductsGroup() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.groupOfProductRef && (this.$refs.groupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.groupsOfProduct.unshift({value: null, label: this.$t('shared.selectBox.all') as string});
                } else {
                    this.$calc.groupOfProduct = null;
                    this.taskInfo.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                }
            })
            .catch((e) => {
            })
    }

    loadProductsGroupForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterGroupOfProductRef && (this.$refs.setupMasterGroupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfoForSetupMaster.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForSetupMaster.groupsOfProduct.unshift({value: null, label: this.$t('shared.selectBox.all') as string});
                } else {
                    this.$setupMasterCalc.groupOfProduct = null;
                    this.taskInfoForSetupMaster.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                }
            })
            .catch((e) => {
            })
    }

    loadProductsGroupForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesGroupOfProductRef && (this.$refs.roundingRulesGroupOfProductRef as any).toggleLoading(false);
                }, 250);
                if (filterData.groups.length > 0) {
                    this.taskInfoForRoundingRules.groupsOfProduct = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForRoundingRules.groupsOfProduct.unshift({value: null, label: this.$t('shared.selectBox.all') as string});
                } else {
                    this.$roundingRules.groupOfProduct = null;
                    this.taskInfoForRoundingRules.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
                }
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategories() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.subcategoriesRef && (this.$refs.subcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfo.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategoriesForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterSubcategoriesRef && (this.$refs.setupMasterSubcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForSetupMaster.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoForSetupMaster.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategoriesForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesSubcategoriesRef && (this.$refs.roundingRulesSubcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForRoundingRules.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoForRoundingRules.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductSegments() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.productSegmentsRef && (this.$refs.productSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfo.psegemnts = filterData.psegments.map((i) => {
                    return {
                        label: i.name,
                        value: i.id,
                    }
                });
                this.taskInfo.psegemnts.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            });
    }

    loadProductSegmentsForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterProductSegmentsRef && (this.$refs.setupMasterProductSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForSetupMaster.psegemnts = filterData.psegments.map((i) => {
                    return {
                        label: i.name,
                        value: i.id,
                    }
                });
                this.taskInfoForSetupMaster.psegemnts.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            });
    }

    loadProductSegmentsForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.p_segemnt))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesProductSegmentsRef && (this.$refs.roundingRulesProductSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoForRoundingRules.psegemnts = filterData.psegments.map((i) => {
                    return {
                        label: i.name,
                        value: i.id,
                    }
                });
                this.taskInfoForRoundingRules.psegemnts.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            });
    }

    getCategoryInfo(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.groupSelectedRef && (this.$refs.groupSelectedRef as any).toggleLoading(false);
                    this.$refs.updateSeasonsRef && (this.$refs.updateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfo.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfo.categoryOptions.unshift({value: null, label: this.$t('shared.selectBox.selectCategory') as string});
                } else {
                    this.$calc.categoryOfProduct = null;
                    this.taskInfo.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                    this.resetData(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    getCategoryInfoForSetupMaster(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterGroupSelectedRef && (this.$refs.setupMasterGroupSelectedRef as any).toggleLoading(false);
                    this.$refs.setupMasterUpdateSeasonsRef && (this.$refs.setupMasterUpdateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfoForSetupMaster.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForSetupMaster.categoryOptions.unshift({value: null, label: this.$t('shared.selectBox.selectCategory') as string});
                } else {
                    this.$calc.categoryOfProduct = null;
                    this.taskInfoForSetupMaster.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                    this.resetDataForSetupMaster(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    getCategoryInfoForRoundingRules(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesGroupSelectedRef && (this.$refs.roundingRulesGroupSelectedRef as any).toggleLoading(false);
                    this.$refs.roundingRulesUpdateSeasonsRef && (this.$refs.roundingRulesUpdateSeasonsRef as any).toggleLoading(false);
                }, 250);
                if (filterData.categories.length > 0) {
                    this.taskInfoForRoundingRules.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.taskInfoForRoundingRules.categoryOptions.unshift({
                        value: null,
                        label: this.$t('shared.selectBox.selectCategory') as string,
                    });
                } else {
                    this.$roundingRules.categoryOfProduct = null;
                    this.taskInfoForRoundingRules.categoryOptions = [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}];
                    this.resetDataForRoundingRules(TaskInfoFilterType.category);
                }
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    getRegionInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.updateRegionsRef && (this.$refs.updateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getRegionInfoForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterUpdateRegionsRef && (this.$refs.setupMasterUpdateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoForSetupMaster.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getRegionInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesUpdateRegionsRef && (this.$refs.roundingRulesUpdateRegionsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoForRoundingRules.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getSegmentPriceInfo() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetMinMaxPriceSegment(filter)
            .then((data) => {
                const filterData = data.data;
                this.segmentPriceOptions = filterData.map((i) => {
                    return {value: i, label: i.name}
                });
            })
            .catch((e) => {
            })
    }

    getProductSegmentIdAndName() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetProductSegmentIdAndName(filter)
            .then((data) => {
                const filterData = data.data;
                this.productSegmentIdAndNameOptions = filterData.map((i) => {
                    return {value: i, label: i.segmentName}
                });
            })
            .catch((e) => {
            })
    }

    getSkuKeysAndAttributes() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getSkuFilter()
        this.httpGetSkuKeysAndAttributes(filter)
            .then((result) => {
                this.keyCharacteristicOneOptions = result.data.keyProducts1.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicTwoOptions = result.data.keyProducts2.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicThreeOptions = result.data.keyProducts3.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFourOptions = result.data.keyProducts4.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFiveOptions = result.data.keyProducts5.map((item) => {
                    return {value: item, label: item};
                });
                this.recipeAttributesOptions = result.data.recipeAttributes.map((item) => {
                    return {value: item, label: item};
                });
                this.treatmentAttributesOptions = result.data.treatmentAttributes.map((item) => {
                    return {value: item, label: item.toString()};
                });
            })
            .catch((e) => {
            })
    }

    getNewProductsSkuKeysAndAttributes() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const filter = this.getNewProductsSkuFilter()
        this.httpGetNewProductSkuKeysAndAttributes(filter)
            .then((result) => {
                this.keyCharacteristicOneForNewProductOptions = result.data.keyProducts1.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicTwoForNewProductOptions = result.data.keyProducts2.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicThreeForNewProductOptions = result.data.keyProducts3.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFourForNewProductOptions = result.data.keyProducts4.map((item) => {
                    return {value: item, label: item};
                });
                this.keyCharacteristicFiveForNewProductOptions = result.data.keyProducts5.map((item) => {
                    return {value: item, label: item};
                });
                this.recipeAttributesForNewProductOptions = result.data.recipeAttributes.map((item) => {
                    return {value: item, label: item};
                });
                this.treatmentAttributesForNewProductOptions = result.data.treatmentAttributes.map((item) => {
                    return {value: item, label: item.toString()};
                });
            })
            .catch((e) => {
            })
    }

    getNewProductSegmentIdAndName() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments),
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
        };
        this.httpGetNewProductSegmentIdAndName(filter)
            .then((data) => {
                const filterData = data.data;
                this.newProductSegmentIdAndNameOptions = filterData.map((i) => {
                    return {value: i, label: i.segmentName}
                });
            })
            .catch((e) => {
            })
    }

    getRoundingListFilter(): RoundingRulesFilter {
        const filter: RoundingRulesFilter = {tradingId: this.$roundingRules.selectMarket.id};

        if (this.rulesDateRange.length > 0) {
            filter.dateBefore = this.rulesDateRange[0]
            filter.dateAfter = this.rulesDateRange[1]
        }

        const userValue = this.selectUserFio
        if (userValue !== 'All') {
            filter.userFio = userValue
        }

        const storeFormatValue = this.selectFormatFilter
        if (storeFormatValue !== -1) {
            filter.storeFormat = storeFormatValue
        }

        const categoryValue = this.selectCategoryFilter
        if (categoryValue !== -1) {
            filter.category = categoryValue
        }

        const subcategory = this.selectSubcategoryFilter
        if (subcategory !== -1) {
            filter.subcategories = subcategory
        }

        const group = this.selectGroupFilter
        if (group !== -1) {
            filter.group = group
        }

        const cluster = this.selectClusterFilter
        if (cluster !== -1) {
            filter.storeCluster = cluster
        }

        const region = this.selectRegionFilter
        if (region !== -1) {
            filter.storeRegions = region
        }

        return filter;
    }

    getSegmentPriceInfoForNewProducts() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
        };
        this.httpGetMinMaxPriceSegmentForNewProducts(filter)
            .then((data) => {
                const filterData = data.data;
                this.segmentPriceOptionsForNewProducts = filterData.map((i) => {
                    return {value: i, label: i.name}
                });
            })
            .catch((e) => {
            })
    }

    getFormatInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.formatSelectedRef && (this.$refs.formatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfo.storeFormatOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfo.storeFormatOptions];

            })
            .catch((e) => {
            });
    }

    getFormatInfoForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterFormatSelectedRef && (this.$refs.setupMasterFormatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForSetupMaster.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForSetupMaster.storeFormatOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoForSetupMaster.storeFormatOptions];

            })
            .catch((e) => {
            });
    }

    getFormatInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesFormatSelectedRef && (this.$refs.roundingRulesFormatSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForRoundingRules.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.storeFormatOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoForRoundingRules.storeFormatOptions];

            })
            .catch((e) => {
            });
    }

    getBuyerSegment() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.buyer))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.updateBuyerSegmentsRef && (this.$refs.updateBuyerSegmentsRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            })

    }

    getClusterInfo() {
        this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.clasterSelectedRef && (this.$refs.clasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfo.clusterOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfo.clusterOptions];

            })
            .catch((e) => {
            });
    }

    getClusterInfoForSetupMaster() {
        this.httpGetProductInfo(this.getTaskInfoForSetupMaster(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.setupMasterClasterSelectedRef && (this.$refs.setupMasterClasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForSetupMaster.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForSetupMaster.clusterOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoForSetupMaster.clusterOptions];

            })
            .catch((e) => {
            });
    }

    getClusterInfoForRoundingRules() {
        this.httpGetProductInfo(this.getTaskInfoForRoundingRules(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    this.$refs.roundingRulesClasterSelectedRef && (this.$refs.roundingRulesClasterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoForRoundingRules.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoForRoundingRules.clusterOptions = [{
                    value: null,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoForRoundingRules.clusterOptions];

            })
            .catch((e) => {
            });
    }

    prepareIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
        const prepared: CalcIndividualConfig = {};

        if ('kviStrategy' in config && typeof config.kviStrategy !== 'undefined' && config.kviStrategy !== null) {
            prepared.kviStrategy = config.kviStrategy.value
        }

        if ('marginalProfit' in config && typeof config.marginalProfit !== 'undefined' && config.marginalProfit !== null) {
            prepared.marginalProfit = config.marginalProfit;
        }

        if ('priceChangeLimit' in config && typeof config.priceChangeLimit !== 'undefined' && config.priceChangeLimit !== null) {
            prepared.priceChangeLimit = config.priceChangeLimit;
        }

        if ('selectCoefficent' in config && typeof config.selectCoefficent !== 'undefined' && config.selectCoefficent !== null) {
            const coef = config.selectCoefficent;
            prepared.coefficientK1 = coef.value.k1;
            prepared.coefficientK2 = coef.value.k2;
            prepared.priceOpt = coef.value.enum;
        }

        if ('priceIncreaseLimit' in config && typeof config.priceIncreaseLimit !== 'undefined' && config.priceIncreaseLimit !== null) {
            prepared.priceIncreaseLimit = config.priceIncreaseLimit;
        }

        if ('competitorsPricesParams' in config && typeof config.competitorsPricesParams !== 'undefined' && config.competitorsPricesParams !== null) {
            prepared.competitorsPricesParams = config.competitorsPricesParams;
        }

        if ('percentageOfCompetitorsPrice' in config) {
            prepared.percentageOfCompetitorsPrice = config.percentageOfCompetitorsPrice;
        }

        if ('periodPriceIncreaseLimit' in config && typeof config.periodPriceIncreaseLimit !== 'undefined' && config.periodPriceIncreaseLimit !== null) {
            prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
        }

        if ('period' in config && typeof config.period !== 'undefined' && config.period !== null) {
            prepared.period = config.period.value;
        }

        if ('newProductPriceStrategy' in config && typeof config.newProductPriceStrategy !== 'undefined' && config.newProductPriceStrategy !== null) {
            prepared.newProductPriceStrategy = config.newProductPriceStrategy.value;
        }

        if ('newProductLifespanInDays' in config && typeof config.newProductLifespanInDays !== 'undefined' && config.newProductLifespanInDays !== null) {
            prepared.newProductLifespanInDays = config.newProductLifespanInDays;
        }

        if ('priceGap' in config && typeof config.priceGap !== 'undefined' && config.priceGap !== null) {
            prepared.priceGap = config.priceGap;
        }

        if ('ctmBrandPurpose' in config && typeof config.ctmBrandPurpose !== 'undefined' && config.ctmBrandPurpose !== null) {
            prepared.ctmBrandPurpose = config.ctmBrandPurpose;
        }

        if ('ctmPriceGap' in config && typeof config.ctmPriceGap !== 'undefined' && config.ctmPriceGap !== null) {
            prepared.ctmPriceGap = config.ctmPriceGap;
        }

        return prepared;
    }

    async calc() {
        if (!this.isGroupSelected) {
            this.showError(this.$t('shared.recommendations.groupNotSelected') as string);
            return;
        }
        if (this.$calc.categoryOfProduct === null) {
            this.showError(this.$t('shared.recommendations.categoryNotSelected') as string);
            return;
        }
        if (this.$calc.kviStrategy.value === null) {
            this.showError(this.$t('shared.recommendations.kviStrategyNotSelected') as string);
            return;
        }
        if (this.$calc.depthToPurchasePrice <= 0) {
            this.showError(this.$t('shared.recommendations.purchasePriceDepthMustBeGtZero') as string);
            return;
        }

        if (this.useBrutForcingParams && this.optimizationDiff < 0.0) {
            this.showError(this.$t('shared.recommendations.incrementMustBePositive') as string);
            return;
        }
        if (this.useBrutForcingParams) {
            this.showInfo(this.$t('shared.recommendations.optimalParamsStarted') as string);
        } else {
            this.showInfo(this.$t('shared.parametersTab.calcStarted') as string);
        }
        // Подгружаем конкурентов перед расчетом, на случай если забыли подгрузить через открытие списка SKU
        if (this.$calc.competitorsCodes.length === 0 && this.$calc.useCompetitorsPrices) {
            const offset = 0;
            const competitorFilter = this.getCompetitorsFilter();
            await this.httpLoadCompetitorsPrice(competitorFilter, this.competitorsPagination.pageSize, offset)
                .then((data) => {
                    this.competitors = data.data.content.flatMap(this.toRow);
                    this.$calc.competitorsCodes = this.competitors.map((i) => {
                        return i.internalCode;
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorLoadCompetitorPrices') as string);
                });
        }
        const filters = this.getCalcFilter();
        this.saveCalc();
        this.httpPostAddTask(filters)
            .then((r) => {
                    this.$log.debug('Create task', r.data);
                    EventBus.$emit('onCalcParamsSaved')
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
                this.$log.error('Error occurred on creating calc', e)
            });
    }

    searchKviRecommends() {
        if (!this.isGroupSelected) {
            this.showError(this.$t('shared.recommendations.groupNotSelected') as string);
            return;
        }
        if (this.$calc.categoryOfProduct === null) {
            this.showError(this.$t('shared.recommendations.categoryNotSelected') as string);
            return;
        }
        const filters = this.getCalcFilter();
        filters.calcWithBatchNumber = false;
        this.saveCalc();
        this.httpPostSearchKviRecommends(filters)
            .then((r) => {
                    this.$log.debug('Create task', r.data);
                    this.showInfo(this.$t('shared.recommendations.kviSearchStarted') as string);
                },
            )
            .catch((e) => {
                this.showError(this.$t('shared.recommendations.errorSearchKvi') as string);
                this.$log.error('Error occurred on creating search kvi recommends', e)
            });
    }

    hideSkuPanel() {
        this.showSku = false;
        this.clearFilters();
    }

    downloadDefaultMasterSetupParams() {
        this.$setupMasterCalc.selectCoefficent = {value: {k1: 1, k2: 0}, label: this.$t('shared.parametersTab.maxGrossMargin') as string};
        this.$setupMasterCalc.marginalProfit = 5;
        this.$setupMasterCalc.priceDecreaseLimit = 15;
        this.$setupMasterCalc.priceIncreaseLimit = 15;
        this.$setupMasterCalc.priceChangeLimit = 1;
        this.$setupMasterCalc.periodPriceIncreaseLimit = 100;
        this.$setupMasterCalc.period = {value: 7, label: this.$t('shared.periods.week') as string};
        this.$setupMasterCalc.xyzChecked = true;
        this.$setupMasterCalc.competitorsPrices = 25;
        this.$setupMasterCalc.percentageOfCompetitorsPrice = '5';
        this.$setupMasterCalc.kviStrategy = kviStrategiesSet.EQUALS;
        this.$setupMasterCalc.minProfitKVI = 0;
        this.$setupMasterCalc.kviPriceDecreaseLimit = 15;
        this.$setupMasterCalc.useCompetitorsPrices = false;
        this.$setupMasterCalc.byPromoPrices = false;
        this.$setupMasterCalc.useCompElasticity = false;
        this.$setupMasterCalc.calculateCompAllowedDeviation = true;
        this.$setupMasterCalc.competitorPriceControlParameterPc = 25;
        this.$setupMasterCalc.competitorsPricePeriod = 28;
        this.$setupMasterCalc.competitorsInfluencesCoef = 1;
        this.$setupMasterCalc.percentileType = {value: PercentileTypes.Q5, label: '0-100'};
        this.$setupMasterCalc.competitorsPriceAdjustment = '10';
        this.$setupMasterCalc.competitorsControlParam = 10;
        this.$setupMasterCalc.competitorsPriceMethod = competitorsPriceMethodsSb.MIN_PRICE;
        this.$setupMasterCalc.competitorsMinimumProfit = 0;
        this.$setupMasterCalc.competitorsPriceStrategy = competitorsPriceStrategiesSb.EQUALS;
        this.$setupMasterCalc.compPriceDecreaseLimit = 15;
        this.$setupMasterCalc.calculationDepth = 4;
        this.$setupMasterCalc.calculationDay = 28;
        this.$setupMasterCalc.depthToPurchasePrice = 4;
        this.$setupMasterCalc.countAtMaxPurchasePrice = true;
        this.$setupMasterCalc.countAtFuturePurchasePrice = false;
        this.$setupMasterCalc.countPriceBySkuWithoutBatches = false;
        this.$setupMasterCalc.countByAvgPurchasePrice = false;
        this.$setupMasterCalc.calcPurchasePriceByClusters = false;
        this.$setupMasterCalc.useEmptyRemains = false;
        this.$setupMasterCalc.useArrivalDate = false;
        this.$setupMasterCalc.changePriceCorridor = false;
        this.$setupMasterCalc.priceCorridor = {
            min: 1.0,
            max: 100.0,
        };
        this.$setupMasterCalc.fixLowerBorder = false;
        this.$setupMasterCalc.priceFamilies = true;
        this.$setupMasterCalc.hardPriceFamilies = false;
        this.$setupMasterCalc.calculatePYR = false;
    }

    async save() {
        this.competitors = []
        this.viewCompetitors = []
        // Подгружаем конкурентов перед сохранением, на случай если забыли подгрузить через открытие списка SKU
        if (this.$calc.competitorsCodes.length === 0) {
            const offset = 0;
            const competitorFilter = this.getCompetitorsFilter();
            await this.httpLoadCompetitorsPrice(competitorFilter, this.competitorsPagination.pageSize, offset)
                .then((data) => {
                    this.competitors = data.data.content.map(this.toRow)
                    this.viewCompetitors = this.competitors;
                    this.$calc.competitorsCodes = this.competitors.map((i) => {
                        return i.internalCode;
                    });
                })
                .catch((e) => {
                    this.showError(this.$t('shared.parametersTab.errorLoadCompetitorPrices') as string);
                });
        }
        const filters = this.getCalcFilter();
        this.httpSaveBaseFilter(filters)
            .then((r) => {
                this.$log.debug('Параметры сохранены', r.data);
                this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);
                EventBus.$emit('onCalcParamsSaved')
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string);
            });
        localStorage.setItem('isSaveStateAvailable', 'false')
    }

    async saveRulesParams() {
        const filters = this.getRulesFilters();

        this.httpSaveRulesParams(filters)
            .then((r) => {
                this.$log.debug('Параметры сохранены', r.data);
                this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string + e);
            })
    }

    getRulesFilters(): BaseFilterRoundingRules {
        return {
            filterType: 'BASE',
            tradingId: this.$roundingRules.selectMarket.id,
            category: this.$roundingRules.categoryOfProduct,
            groupOfProduct: this.$roundingRules.groupOfProduct,
            seasonValues: this.$roundingRules.seasonSelected,
            buyerSegments: this.$roundingRules.buyerSegmentsList,
            storeRegionValues: this.$roundingRules.regionSelected,
            categoryStrategy: this.$roundingRules.categoryStrategy.value,
            storeFormat: this.$roundingRules.formatSelected,
            subcategories: this.$roundingRules.subcategories,
            productSegments: this.$roundingRules.productSegments,
            allNewPricesWithoutPennies: this.$roundingRules.allNewPricesWithoutPennies,
            storeCluster: this.$roundingRules.clusterSelected,
            pennies: this.$roundingRules.pennies,
            randomPennies: this.$roundingRules.randomPennies,
            roundKviCompetitorPrice: this.$roundingRules.roundKviCompetitorPrice,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            bigDigit: this.$roundingRules.bigDigit,
            manualPennies: this.$roundingRules.manualPennies,
        }
    }

    saveSetupMasterParams() {
        const filters = this.getCalcFilterForSetupMaster();
        this.httpSaveBaseFilter(filters)
            .then((r) => {
                this.$log.debug('Параметры сохранены', r.data);
                this.showInfo(this.$t('shared.parametersTab.saveParamsSuccess') as string);
                EventBus.$emit('onCalcParamsSaved');
                this.moveToCalcParamsTab('innerRulesTab');
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorSaveCalcParams') as string);
            });
    }

    updatePriceCorridorAndSkuList() {
        this.priceCorridorInfo();
        this.refreshSkuList();
        this.saveCalc();
    }

    updatePriceCorridorForSetupMaster() {
        this.priceCorridorInfoForSetupMaster();
        this.saveSetupMasterCalc();
    }

    checkSkuButtonWithCalc() {
        if (!this.skuListWithCalculating && this.isFiltersChanged === 0) {
            this.isFiltersChanged = 1;
        }
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
    }

    checkSkuButtonWithoutCalc() {
        if (this.skuListWithCalculating && this.isFiltersChanged === 0) {
            this.isFiltersChanged = 1;
        }
        this.skuListWithCalculating = false;
    }

    loadSkuWithoutCalc() {
        this.skuListWithCalculating = false;
        this.needLoadSkuList = true;
    }

    reloadSkuList() {
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
    }

    loadSkuWithCalc() {
        this.skuListWithCalculating = true;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = true;
        this.calcSkuActualProfitButtonDisabled = true;
        this.refreshSkuTableInPanel();
    }

    loadNewProductsWithoutCalc() {
        this.newProductsWithCalculating = false;
        this.needLoadNewProductList = true;
    }

    loadNewProductsWithCalc() {
        this.newProductsWithCalculating = true;
        this.refreshNewProductsTable();
    }

    loadTask() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.taskData = null;
            return;
        }
        const data = this.getCalcFilter()
        // fixme: (╯°□°）╯︵ ┻━┻ wtf? Why do you use here full object?
        this.httpFindTaskByParams(data)
            .then((resp) => {
                if (resp.status === 200) {
                    this.$log.debug('Task was found', resp.data)
                    const task = resp.data;

                    let subCategories = ' - ';
                    if (task.subcategories.length > 0) {
                        subCategories = task.subcategories + ' / '
                    }

                    let formatName = ' - ';
                    if (task.format !== '') {
                        formatName = task.format + ' / '
                    }

                    let regionName = ' - ';
                    if (task.region !== '') {
                        regionName = task.region + ' / '
                    }

                    let clusterName = ' - ';
                    if (task.cluster !== '') {
                        clusterName = task.cluster + ' / '
                    }
                    const filterNames = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName

                    this.taskData = {
                        id: task.id,
                        status: task.status,
                        type: task.typeMachine,
                        fileResult: task.fileResult,
                        editable: task.editable,
                        filterNames,
                    };
                } else {
                    this.$log.debug('Task was not found')
                    this.taskData = null;
                }
            });
    }

    loadMoreSku() {
        this.skuListCurrentPage += 1;
        this.skuListLimit *= (this.skuListCurrentPage)
        this.isFiltersChanged = 1

        this.fetchSkuList(1)
    }

    loadMoreNewProducts() {
        this.newProductsListCurrentPage += 1;
        this.newProductsListLimit *= (this.newProductsListCurrentPage)
        this.isFiltersChanged = 1

        this.fetchNewProductsList(1)
    }

    loadMoreCtm() {
        this.skuListCurrentPage += 1;
        this.skuListLimit *= (this.skuListCurrentPage)
        this.isFiltersChanged = 1

        this.fetchCtmList(1)
    }

    loadMoreCompetitorsSku() {
        this.competitorsPagination.current += 1;
        this.isFiltersChanged = 1

        this.listCompetitors({currentPage: this.competitorsPagination.current, pageSize: 50, loadMore: true}, () => {
        })
    }

    fetchSkuList(currentPage: number = 1) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataSkuList = []
            return;
        }
        if (this.isFiltersChanged === 0 && this.lastPage === currentPage) {
            this.tableDataSkuList = this.skuList
            return;
        }
        const filter = this.getSkuFilter()
        const offset = (currentPage - 1) * this.skuListLimit;
        this.skuListLimit = this.skuListLimit * currentPage
        this.isFetchSkuListDownload = true;
        this.httpGetSkuList(filter, this.skuListLimit, offset)
            .then((r) => {
                    this.skuList = r.data.content;
                    this.skuListTotalRows = r.data.totalElements;
                    this.tableDataSkuList = r.data.content

                    this.isFetchSkuListDownload = false;
                    this.isFiltersChanged = 0;
                    this.skuListLimit = 50;
                    this.lastPage = currentPage;
                },
            )
            .catch((e) => {
                this.tableDataSkuList = []
                this.isFetchSkuListDownload = false;
                this.isFiltersChanged = 0;
                this.lastPage = currentPage;
            });
        if (this.skuListWithCalculating && this.segmentPriceOptions.length === 0) {
            this.getSegmentPriceInfo();
        }
        if (this.productSegmentIdAndNameOptions.length === 0) {
            this.getProductSegmentIdAndName();
        }
        this.getSkuKeysAndAttributes();
        this.httpGetProductRangeListByFilters(filter)
            .then((r) => {
                    this.productLineOptions = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptionsForFilter = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptions.unshift({value: '', label: this.$t('shared.selectBox.empty') as string});
                    this.productLineOptionsForFilter.unshift({value: 'all', label: this.$t('shared.selectBox.all') as string}, {value: '', label: this.$t('shared.selectBox.empty') as string});
                },
            );
    }

    fetchCtmList(currentPage: any = 1) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataCtmList = []
            return;
        }
        const filter = this.getSkuFilter()
        filter.ctm = '1'
        const offset = (currentPage - 1) * this.skuListLimit;
        this.skuListLimit = this.skuListLimit * currentPage
        this.isFetchCtmProductsListDownload = false;
        this.httpGetSkuList(filter, this.skuListLimit, offset)
            .then((r) => {
                    this.skuList = r.data.content;
                    this.skuCtmListTotalRows = r.data.totalElements;
                    this.tableDataCtmList = r.data.content;

                    this.isFetchCtmProductsListDownload = false;
                    this.isFiltersChanged = 0;
                    this.skuListLimit = 50;
                    this.lastPage = currentPage;
                },
            )
            .catch((e) => {
                this.tableDataCtmList = []
                this.isFetchCtmProductsListDownload = false;
                this.isFiltersChanged = 0;
                this.lastPage = currentPage;
            });
        if (this.skuListWithCalculating && this.segmentPriceOptions.length === 0) {
            this.getSegmentPriceInfo();
        }
        if (this.productSegmentIdAndNameOptions.length === 0) {
            this.getProductSegmentIdAndName();
        }
        this.getSkuKeysAndAttributes();

        this.httpGetProductRangeListByFilters(filter)
            .then((r) => {
                    this.productLineOptions = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptionsForFilter = r.data.map((i) => {
                        return {value: i, label: i}
                    });
                    this.productLineOptions.unshift({value: '', label: this.$t('shared.selectBox.empty') as string});
                    this.productLineOptionsForFilter.unshift({value: 'all', label: this.$t('shared.selectBox.all') as string}, {value: '', label: this.$t('shared.selectBox.empty') as string});
                },
            );
    }

    fetchNewProductsList(currentPage: any = 1) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataNewProductsList = []
            return;
        }
        const filter = this.getNewProductsSkuFilter();
        const offset = (currentPage - 1) * this.newProductsListLimit;
        this.newProductsListLimit = this.newProductsListLimit * currentPage
        this.isFetchNewProductsListDownload = true;
        this.httpGetNewProductsList(filter, this.newProductsListLimit, offset)
            .then((r) => {
                    this.newProductsList = r.data.content;
                    this.newProductsListTotalRows = r.data.totalElements;
                    this.tableDataNewProductsList = r.data.content;

                    this.isFetchNewProductsListDownload = false;
                    this.isFiltersChanged = 0;
                    this.newProductsListLimit = 50;
                    this.newProductsLastPage = currentPage;
                },
            )
            .catch((e) => {
                this.tableDataNewProductsList = []
                this.isFetchNewProductsListDownload = false;
                this.isFiltersChanged = 0;
                this.newProductsLastPage = currentPage;
            });
        this.getSegmentPriceInfoForNewProducts();
        if (this.newProductSegmentIdAndNameOptions.length === 0) {
            this.getNewProductSegmentIdAndName();
        }
        this.getNewProductsSkuKeysAndAttributes();
    }

    async downloadAllSku() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const filter = this.getSkuFilter()
        await this.httpGetAllSku(filter)
            .then((r) => {
                    this.skuListWithAllProducts = r.data;
                },
            )
            .catch((e) => {
            });
    }

    async downloadAllNewProducts() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = this.selectCTMForNewProducts === 'all' ? null : this.selectCTMForNewProducts;
        this.selectSegmentPriceForNewProducts = this.selectSegmentPriceForNewProducts.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPriceForNewProducts.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        const newProductSegments = this.selectNewProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            kvi: this.selectKVIForNewProducts,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.newProductsWithCalculating,
            productSegments: LocalData.filterNumberArrays(newProductSegments),
        };
        await this.httpGetAllNewProducts(filter)
            .then((r) => {
                    this.newProductsListWithAllProducts = r.data;
                },
            )
            .catch((e) => {
            });
    }

    async downloadAllCtmProducts() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            return;
        }

        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = '1';
        this.selectSegmentPriceForNewProducts = this.selectSegmentPriceForNewProducts.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPriceForNewProducts.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        const newProductSegments = this.selectNewProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

        const filter: SkuFilter = {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            kvi: this.selectKVIForNewProducts,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.newProductsWithCalculating,
            productSegments: LocalData.filterNumberArrays(newProductSegments),
        };
        await this.httpGetAllNewProducts(filter)
            .then((r) => {
                    this.newProductsListWithAllProducts = r.data;
                },
            )
            .catch((e) => {
            });
    }

    fetchCtmProductsList(currentPage: any) {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null) {
            this.tableDataCtmList = []
            return;
        }
        const filter = this.getNewProductsSkuFilter();
        const offset = (currentPage - 1) * this.newProductsListLimit;
        this.isFetchCtmProductsListDownload = true;
        this.httpGetNewProductsList(filter, this.newProductsListLimit, offset)
            .then((r) => {
                    this.newProductsList = r.data.content;
                    this.newProductsListTotalRows = r.data.totalElements;
                    this.tableDataCtmList = r.data.content
                    console.log(r.data.content, "tableDataCtmProductsList")
                    this.isFetchCtmProductsListDownload = false;
                    this.newProductsLastPage = currentPage;
                },
            )
            .catch((e) => {
                this.tableDataCtmList = []
                this.isFetchCtmProductsListDownload = false;
                this.newProductsLastPage = currentPage;
            });
        this.getSegmentPriceInfoForNewProducts();
        if (this.newProductSegmentIdAndNameOptions.length === 0) {
            this.getNewProductSegmentIdAndName();
        }
        this.getNewProductsSkuKeysAndAttributes();
    }

    sortSkuListBySKU() {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuList();
    }

    sortSkuListBySKUInTablePanel(callback: any) {
        if (this.sortBySKU === -1 || this.sortBySKU === 1) {
            this.sortBySKU = 0;
        } else {
            this.sortBySKU = 1;
        }
        this.refreshSkuTableInPanel();
        callback(1)
    }

    sortNewProductsBySKU(callback: any) {
        if (this.sortingNewProductsBySKU === -1 || this.sortingNewProductsBySKU === 1) {
            this.sortingNewProductsBySKU = 0;
        } else {
            this.sortingNewProductsBySKU = 1;
        }
        this.refreshNewProductsTable();
        callback(1)
    }

    isPriceCategoryRecommends(sku: Sku): boolean {
        return sku.priceCategoryRecommendation;
    }

    isCartGeneratorRecommends(sku: Sku): boolean {
        return sku.cartGeneratorRecommendation;
    }

    isSelectedKvi(sku: Sku): boolean {
        return sku.kvi === 1;
    }

    isSelectedCtmBrandPurpose(sku: Sku): boolean {
        return sku.ctmBrandPurpose === '1';
    }

    isActiveSaveKviButton(): boolean {
        return this.productCodesForAddKvi.length === 0 && this.productCodesForDeleteKvi.length === 0;
    }

    setSelectedKvi(sku: Sku, selected: boolean) {
        if (selected) {
            if (sku.kvi !== 1) {
                this.productCodesForAddKvi.push(sku.internalCode);
            }
            const index = this.productCodesForDeleteKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForDeleteKvi.splice(index, 1);
            }
        } else {
            if (sku.kvi === 1) {
                this.productCodesForDeleteKvi.push(sku.internalCode);
            }
            const index = this.productCodesForAddKvi.findIndex((item) => {
                return item === sku.internalCode
            });
            if (index !== -1) {
                this.productCodesForAddKvi.splice(index, 1);
            }
        }
    }

    saveKviParams() {
        const filters = this.getCalcFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParam(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('shared.messages.savingKvi') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.productCodesForAddCtmPurpose = [];
                this.productCodesForDeleteCtmPurpose = [];
                this.refreshSkuList();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    getProductRange(productLine: string): string {
        const index = this.productLineOptions.findIndex((item) => {
            return item.value === productLine
        });

        if (index !== -1) {
            return this.productLineOptions[index].value
        } else {
            return ""
        }
    }

    inputOrDeleteProductRange(row: Sku, value: SelectBox<string>) {
        const index = this.productRangesArray.findIndex((item) => {
            return item.internalCode === row.internalCode
        });

        const rangeAndCode: InternalCodeAndProductRange = {
            internalCode: row.internalCode,
            productRange: value.value,
        };

        if (index === -1) {
            this.productRangesArray.push(rangeAndCode)
        } else {
            this.productRangesArray.splice(index, 1)
            this.productRangesArray.push(rangeAndCode)
        }
    }

    saveKviParamsForSkuInPanel() {
        const filters = this.getCalcFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParam(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('shared.messages.savingKvi') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.refreshSkuTableInPanel();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    saveKviParamsForNewProducts() {
        const filters = this.getCalcFilter();
        this.kviSaveProcess = true;
        this.httpSaveOrDeleteKviParamForNewProducts(filters)
            .then((r) => {
                this.kviSaveProcess = false;
                this.showInfo(this.$t('shared.messages.savingKvi') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
                this.refreshNewProductsTable();
            })
            .catch((e) => {
                this.kviSaveProcess = false;
                this.showError(this.$t('shared.productsList.errorSaveIndParams') as string);
                this.productCodesForAddKvi = [];
                this.productCodesForDeleteKvi = [];
            });
    }

    clearFilters() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = 'all';
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectKeyCharacteristicThree = [];
        this.selectKeyCharacteristicFour = [];
        this.selectKeyCharacteristicFive = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = 'all';
        this.refreshSkuList()
    }

    clearFiltersInSkuTablePanel() {
        this.sortBySKU = -1;
        this.selectKVI = this.defaultFilterValue.value;
        this.selectKVIRecommends = this.defaultFilterValue.value;
        this.selectCTM = 'all';
        this.selectSegmentPrice = [];
        this.selectProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOne = [];
        this.selectKeyCharacteristicTwo = [];
        this.selectKeyCharacteristicThree = [];
        this.selectKeyCharacteristicFour = [];
        this.selectKeyCharacteristicFive = [];
        this.selectRecipeAttributes = [];
        this.selectTreatmentAttributes = [];
        this.selectProductLine = 'all';
        this.refreshSkuTableInPanel()
    }

    clearFiltersInNewProductsTable() {
        this.sortingNewProductsBySKU = -1;
        this.selectKVIForNewProducts = this.defaultFilterValue.value;
        this.selectCTMForNewProducts = 'all';
        this.selectSegmentPriceForNewProducts = [];
        this.segmentPriceOptionsForNewProducts = [];
        this.selectNewProductSegmentIdAndName = [];
        this.selectKeyCharacteristicOneForNewProduct = [];
        this.selectKeyCharacteristicTwoForNewProduct = [];
        this.selectKeyCharacteristicThreeForNewProduct = [];
        this.selectKeyCharacteristicFourForNewProduct = [];
        this.selectKeyCharacteristicFiveForNewProduct = [];
        this.selectRecipeAttributesForNewProduct = [];
        this.selectTreatmentAttributesForNewProduct = [];
        this.refreshNewProductsTable()
    }

    selectOrClearAllCompetitors() {
        if (this.$calc.competitorsCodes.length !== 0) {
            this.$calc.competitorsCodes = []
        } else {
            this.$calc.competitorsCodes = this.competitors.map((i) => {
                return i.internalCode;
            });
        }
    }

    calcButtonState(): boolean {

        if (this.$calc.selectMarket != null) {
            const state = this.paramsSum && this.paramsSumXYZ && this.calculationDepthValidate
                && this.calculationDayValidate && this.priceIncreaseLimitValidate && this.competitorsPricesValidate
                && this.marginalPriceDifferenceValidate
                && this.marginalProfitabilityValidate && this.marginalProfitValidate && this.inputInterval && this.inputIntervalP
                && this.correlationCheck && this.highElasticityCheck && this.competitorPriceControlParameterPcValidate && this.marginalProfitDeclinePcValidate;

            return !state;

        }
        return true;
    }

    listCompetitors(ctx: any, callback: (items: any[]) => void) {
        if (this.itemFromList.id === null || this.itemFromList.id === -1) {
            callback([]);
            return;
        }

        const competitorFilter = this.getCompetitorsFilter();
        this.isLoadCompetitorPrices = true;
        this.httpLoadCompetitorsPrice(competitorFilter, ctx.pageSize, ctx.pageSize * (ctx.currentPage - 1))
            .then((response) => {
                this.onLoadCompetitors(ctx.loadMore, response.data.content);
                this.isLoadCompetitorPrices = false;
                const pagination = {...this.competitorsPagination};
                pagination.total = response.data.totalElements;
                this.competitorsPagination = pagination;
                this.competitorsPagination.pageSize = 50;
            })
            .catch((e) => {
                console.error(e)
                this.showError(this.$t('shared.parametersTab.errorLoadCompetitorPrices') as string);
                this.isLoadCompetitorPrices = false;
                callback([]);
            })
    }

    filterAll(): void {
        this.viewCompetitors = this.applyFilterByKey(this.selectedSkuNameFilter, 'skuName', this.competitors);
        this.viewCompetitors = this.applyFilterByKey(this.selectedCompetitorsNameFilter, 'competitorName');
        this.viewCompetitors = this.applyFilterByKey(this.selectedCompetitorsCodeFilter, 'competitorCode');
        this.viewCompetitors = this.applyFilterByKey(this.selectedCompetitorsPriorityFilter, 'competitorPriority');
        this.viewCompetitors = this.applyFilter(this.selectedLastPriceFilter, (competitor, searchLastPrice) => {
            return competitor.lastPrice.toString() == searchLastPrice;
        });
        this.viewCompetitors = this.applyFilter(this.selectedPromoPriceFilter, (competitor, searchPromoPrice) => {
            return (competitor.promoPrice && competitor.promoPrice.toString()) == searchPromoPrice;
        });
        this.viewCompetitors = this.applyFilter(this.selectedCompetitorsPriceFilter, (competitor, searchPrice) => {
            return competitor.competitorPrice.toString() == searchPrice;
        });
        this.viewCompetitors = this.applyFilter(this.selectedDeltaFilter, (competitor, searchDelta) => {
            return competitor.delta!!.toFixed(2) == searchDelta;
        });
        this.viewCompetitors = this.applyFilterByKey(this.selectKeyCharacteristicOneForCompetitors, 'keyCharacteristicOfTheProductIsOne');
        this.viewCompetitors = this.applyFilterByKey(this.selectKeyCharacteristicTwoForCompetitors, 'keyCharacteristicOfTheProductIsTwo');
        this.viewCompetitors = this.applyFilter(this.selectedMonitoringDateFilter, (competitor, searchDate) => {
            return new Date(competitor.competitorDate).toLocaleDateString() == searchDate;
        });
    }

    applyFilterByKey(searchValues: string[], field: keyof CompetitorsPriceRow, sourceValues: CompetitorsPriceRow[] = this.viewCompetitors) {
        return this.filterIfNotEmpty(sourceValues, searchValues, (v, s) => `${v[field]}` == s)
    }

    applyFilter(searchValues: string[], equals: (v: CompetitorsPriceRow, s: string) => boolean) {
        return this.filterIfNotEmpty(this.viewCompetitors, searchValues, equals)
    }

    filterIfNotEmpty<V, S>(values: V[], searchValues: S[], equals: (v: V, s: S) => boolean) {
        return searchValues.length ? values.filter((value) => {
            return searchValues.filter((searchValue) => equals(value, searchValue)).length
        }) : values;
    }


    filterBySkuName(skuNames: string[]): void {
        this.selectedSkuNameFilter = skuNames.includes(this.$t('shared.selectBox.all') as string) ? [] : skuNames;
        this.filterAll()
        this.setSelectAll("SkuName");
    }

    filterByCompetitorName(competitorNames: string[]): void {
        this.selectedCompetitorsNameFilter = competitorNames.includes(this.$t('shared.selectBox.all') as string) ? [] : competitorNames;
        this.filterAll();
        this.setSelectAll("CompetitorsName");
    }

    filterByCompetitorCode(competitorCodes: string[]): void {
        this.selectedCompetitorsCodeFilter = competitorCodes.includes(this.$t('shared.selectBox.all') as string) ? [] : competitorCodes;
        this.filterAll();
        this.setSelectAll("CompetitorsCode");
    }

    filterByCompetitorPriority(competitorPriorities: number[]): void {
        const priority = competitorPriorities.map((v) => v.toString());
        this.selectedCompetitorsPriorityFilter = priority.includes(this.$t('shared.selectBox.all') as string) ? [] : priority;
        this.filterAll();
        this.setSelectAll("CompetitorPriority");
    }

    filterByLastPrice(lastPrices: number[]): void {
        this.selectedLastPriceFilter = lastPrices.map((v) => v.toString()).includes(this.$t('shared.selectBox.all') as string) ? [] : lastPrices.map((v) => v.toString());
        this.filterAll();
        this.setSelectAll("LastPrice");
    }

    filterByPromoPrice(promoPrices: number[]): void {
        this.selectedPromoPriceFilter = promoPrices.map((v) => v.toString()).includes(this.$t('shared.selectBox.all') as string) ? [] : promoPrices.map((v) => v.toString());
        this.filterAll();
        this.setSelectAll("PromoPrice");
    }

    filterByCompetitorPrice(competitorPrices: number[]): void {
        this.selectedCompetitorsPriceFilter = competitorPrices.map((v) => v.toString()).includes(this.$t('shared.selectBox.all') as string) ? [] : competitorPrices.map((v) => v.toString());
        this.filterAll();
        this.setSelectAll("CompetitorPrices");
    }

    filterByDelta(deltas: string[]): void {
        this.selectedDeltaFilter = deltas.includes(this.$t('shared.selectBox.all') as string) ? [] : deltas;
        this.filterAll();
        this.setSelectAll("Delta");
    }

    filterByKvi(kvi: any): void {
        this.viewCompetitors = kvi === -1 ? this.competitors : this.viewCompetitors.filter((value) => kvi == value.kvi)
    }

    filterByCtm(cmts: { value: string }): void {
        this.viewCompetitors = cmts.value === 'all' ? this.competitors : this.viewCompetitors.filter((value) => cmts.value == value.ctm)
    }

    filterByKxtOne(kxtsOne: string[]): void {
        this.selectKeyCharacteristicOneForCompetitors = kxtsOne.includes(this.$t('shared.selectBox.all') as string) ? [] : kxtsOne;
        this.filterAll();
        this.setSelectAll("Kxt1");
    }

    filterByKxtTwo(kxysTwo: string[]): void {
        this.selectKeyCharacteristicTwoForCompetitors = kxysTwo.includes(this.$t('shared.selectBox.all') as string) ? [] : kxysTwo;
        this.filterAll();
        this.setSelectAll("Kxt2");
    }

    filterByMonitorDate(monitorDates: string[]): void {
        this.selectedMonitoringDateFilter = monitorDates.includes(this.$t('shared.selectBox.all') as string) ? [] : monitorDates;
        this.filterAll();
        this.setSelectAll("MonitorDates");
    }

    toRow(competitor: RegularCompetitorsPricesView): CompetitorsPriceRow {
        return {
            ...competitor,
            competitorDate: new Date(competitor.priceDate),
            ctm: competitor.ctm == null ? this.$t('shared.labels.no') as string : competitor.ctm
        }
    }

    onLoadCompetitors(loadMore: boolean, response: RegularCompetitorsPricesView[]): void {
        this.resetCompetitors();
        if (loadMore) {
            this.competitors = this.competitors.concat(response.map(this.toRow))
        } else {
            this.competitors = response.map(this.toRow)
        }
        this.viewCompetitors = this.competitors;
        this.$calc.competitorsCodes = this.competitors.map((i) => {
            return i.internalCode;
        });
        this.setSelectAll(null);
    }

    setSelectAll(exclude: 'SkuName' | 'CompetitorsName' | 'CompetitorsCode' | 'CompetitorPriority' | 'Delta' | 'LastPrice' | 'PromoPrice' | 'CompetitorPrices' | 'Kxt1' | 'Kxt2' | 'MonitorDates' | null): void {
        exclude != 'SkuName' && this.setSelectSkuName(this.viewCompetitors);
        exclude != 'CompetitorsName' && this.setSelectCompetitorsName(this.viewCompetitors);
        exclude != 'CompetitorsCode' && this.setSelectCompetitorsCode(this.viewCompetitors);
        exclude != 'CompetitorPriority' && this.setSelectCompetitorsPriority(this.viewCompetitors);
        exclude != 'LastPrice' && this.setSelectLastPrice(this.viewCompetitors);
        exclude != 'PromoPrice' && this.setSelectPromoPrice(this.viewCompetitors);
        exclude != 'CompetitorPrices' && this.setSelectCompetitorsPrice(this.viewCompetitors);
        exclude != 'Delta' && this.setSelectDelta(this.viewCompetitors);
        exclude != 'MonitorDates' && this.setSelectMonitorDate(this.viewCompetitors);
        exclude != 'Kxt1' && this.setSelectCompetitorsKxtOne(this.viewCompetitors);
        exclude != 'Kxt2' && this.setSelectCompetitorsKxtTwo(this.viewCompetitors);
    }

    setSelectSkuName(response: CompetitorsPriceRow[]) {
        const skuNameOptions = response.map((value) => value.skuName)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.skuNameFilterOptions = Array.from(new Set(skuNameOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsName(response: CompetitorsPriceRow[]) {
        const competitorsNameOptions = response.map((value) => value.competitorName)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.competitorsNameFilterOptions = Array.from(new Set(competitorsNameOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsCode(response: CompetitorsPriceRow[]) {
        const competitorsCodeOptions = response.map((value) => value.competitorCode)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.competitorsCodeFilterOptions = Array.from(new Set(competitorsCodeOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsPriority(response: CompetitorsPriceRow[]) {
        const competitorsPriorityOptions = response.map((value) => value.competitorPriority).sort(compareNumber)
        this.competitorsPriorityFilterOptions = Array.from(new Set(competitorsPriorityOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectLastPrice(response: CompetitorsPriceRow[]) {
        const lastPriceOptions = response.map((value) => value.lastPrice).sort(compareNumber)
        this.lastPriceFilterOptions = Array.from(new Set(lastPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectPromoPrice(response: CompetitorsPriceRow[]) {
        const promoPriceOptions = response.map((value) => value.promoPrice).sort(compareNumber)
        this.promoPriceFilterOptions = Array.from(new Set(promoPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectCompetitorsPrice(response: CompetitorsPriceRow[]) {
        const competitorsPriceOptions = response.map((value) => value.competitorPrice).sort(compareNumber)
        this.competitorsPriceFilterOptions = Array.from(new Set(competitorsPriceOptions)).map((option) => ({
            value: option ? option.toString() : '',
            label: option ? option.toString() : '',
        }))
    }

    setSelectDelta(response: CompetitorsPriceRow[]) {
        const deltaOptions = response.map((value) => value.delta)
            .sort(compareNumber)
            .filter((it) => it !== null)
            .map((delta) => delta ? delta.toFixed(2) : '0')
        this.deltaFilterOptions = Array.from(new Set(deltaOptions)).map((deltaOption) => ({
            value: deltaOption,
            label: deltaOption,
        }))
    }

    setSelectCompetitorsKxtOne(response: CompetitorsPriceRow[]) {
        const competitorsKxtOneOptions = response.map((value) => value.keyCharacteristicOfTheProductIsOne)
            .filter((it) => it !== null)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.keyCharacteristicOneForCompetitorsOptions = Array.from(new Set(competitorsKxtOneOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectCompetitorsKxtTwo(response: CompetitorsPriceRow[]) {
        const competitorsKxtTwoOptions = response.map((value) => value.keyCharacteristicOfTheProductIsTwo)
            .filter((it) => it !== null)
            .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
        this.keyCharacteristicTwoForCompetitorsOptions = Array.from(new Set(competitorsKxtTwoOptions)).map((option) => ({
            value: option,
            label: option,
        }))
    }

    setSelectMonitorDate(response: CompetitorsPriceRow[]) {
        const formattedDates = response.map((value) => new Date(value.competitorDate))
            .sort((a: Date, b: Date) => (a.getTime() - b.getTime()))
            .map((value) => value.toLocaleDateString())
        this.monitoringDateFilterOptions = Array.from(new Set(formattedDates)).map((formattedDate) => ({
            value: formattedDate,
            label: formattedDate,
        }))
    }

    sortCompetitorPrice(a: CompetitorsPriceRow, b: CompetitorsPriceRow, key: string) {
        if (key === 'competitorPrice') {
            return a.competitorPrice - b.competitorPrice;
        }
        return false
    }

    computedDelta = (item: { lastPrice: number, competitorPrice: number }): number => {
        return ((item.lastPrice / item.competitorPrice - 1) * 100);
    }

    getColor = (delta: number) => {
        if (delta > 0) {
            return 'green';
        } else if (delta < 0) {
            return 'red';
        }
        return 'black';
    }

    isSelectedCompetitorCode(internalCode: string) {
        const index = this.$calc.competitorsCodes.findIndex((item) => {
            return item === internalCode
        });
        return index !== -1;
    }

    setSelectedCompetitorCode(internalCode: string, selected: boolean) {
        const index = this.$calc.competitorsCodes.findIndex((item) => {
            return item === internalCode
        });
        if (selected) {
            if (index === -1) {
                this.$calc.competitorsCodes.push(internalCode);
            }
        } else {
            if (index !== -1) {
                this.$calc.competitorsCodes.splice(index, 1);
            }
        }
        this.saveCalc();
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
                this.onDropdownClosed = null
            }
        }
    }

    onMultiSelectToggleForSetupMaster(open: boolean) {
        this.dropDownOpenForSetupMaster = open;
        if (!open) {
            if (this.onDropdownClosedForSetupMaster != null) {
                this.onDropdownClosedForSetupMaster.apply(open);
                this.onDropdownClosedForSetupMaster = null
            }
        }
    }

    refreshPriceSegments() {
        if (!this.findAutomaticallyPriceSegments) {
            this.countPriceSegments = 1;
        }
    }

    refreshPriceSegmentsForSetupMaster() {
        if (!this.findAutomaticallyPriceSegmentsForSetupMaster) {
            this.countPriceSegmentsForSetupMaster = 1;
        }
    }

    insertGlobalIndividualParamsForSkuPanel() {
        this.insertGlobalIndividualParams();
        this.refreshSkuTableInPanel();
    }

    insertGlobalIndividualParamsForSkuTable() {
        this.insertGlobalIndividualParams();
        this.refreshSkuList();
    }

    moveToCalcParamsTab(tabName: string) {
        this.setMasterSetupParamsToCalc();
        this.settingsMasterIsOpen = false
        this.currentMainTab = "mainParameters"
        // const secTab = this.$refs.paramsTabsInMainTabs as BTabs;
        // const row = secTab.tabs.find((myTab: BTab) => myTab.$el.id === tabName);
        // if (row !== undefined) {
        //     row.activate();
        // }
    }

    async insertGlobalIndividualParamsForNewProducts() {
        await this.downloadAllNewProducts();
        await this.newProductsListWithAllProducts.forEach((sku) => {
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'selectCoefficent', this.globalIndividualNewProductStrategyOpt!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfit', this.globalIndividualNewProductMarginalProfitability!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'kviStrategy', this.globalIndividualNewProductKviStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'percentageOfCompetitorsPrice', this.globalIndividualNewProductPercentageOfCompetitorsPrice!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'newProductPriceStrategy', this.globalIndividualNewProductPriceStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'priceGap', this.globalIndividualNewProductPriceGap!!)
        });
        this.refreshNewProductsTable();
    }

    async insertGlobalIndividualParams() {
        await this.downloadAllSku();
        await this.skuListWithAllProducts.forEach((sku) => {
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'selectCoefficent', this.globalIndividualPriceStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'priceIncreaseLimit', this.globalIndividualPriceIncreaseLimit!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'periodPriceIncreaseLimit', this.globalIndividualPeriodPriceIncreaseLimit!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'period', this.globalIndividualPeriod!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'marginalProfit', this.globalIndividualMarginalProfitability!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'kviStrategy', this.globalIndividualKviStrategy!!)
            // tslint:disable-next-line: no-non-null-assertion
            this.setCalcIndividConfig(this.$calc.individualCommonParams, sku.internalCode, 'percentageOfCompetitorsPrice', this.globalIndividualPercentageOfCompetitorsPrice!!)
        });
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string | boolean) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        if (typeof value === 'number' && Number.isNaN(value)) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    getSelectIndividConfig(internalCode: any, key: any) {
       const value = this.getCalcIndividConfig(this.$calc.individualCommonParams, internalCode,key) as {label: string, value: any}
       if(value && value.value){
        return value.value.enum
       }
       return value
    }

    clearAllGlobalIndividualParams() {
        this.globalIndividualPriceStrategy = null;
        this.globalIndividualPriceIncreaseLimit = null;
        this.globalIndividualPeriodPriceIncreaseLimit = null;
        this.globalIndividualPeriod = null;
        this.globalIndividualMarginalProfitability = null;
        this.globalIndividualKviStrategy = null;
        this.globalIndividualPercentageOfCompetitorsPrice = null;
        this.globalIndividualNewProductLifespanInDays = null;
        this.globalIndividualMarginalBlockButton = false;
        this.globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
        this.globalIndividualPriceIncreaseLimitBlockButton = false;
        this.globalIndividualMarginalErrorText = '';
    }

    clearNewProductsGlobalIndividualParams() {
        this.globalIndividualNewProductStrategyOpt = null;
        this.globalIndividualNewProductMarginalProfitability = null;
        this.globalIndividualNewProductKviStrategy = null;
        this.globalIndividualNewProductPercentageOfCompetitorsPrice = null;
        this.globalIndividualNewProductPriceStrategy = null;
        this.globalIndividualNewProductPriceGap = null;
        this.globalNewProductIndividualMarginalBlockButton = false;
        this.globalNewProductIndividualMarginalErrorText = '';
    }

    calcRegularPricesProfitability() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null || this.regularPricesProfitability != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }
        const filter = this.getSkuFilter()
        this.httpGetRegularPricesProfitability(filter)
            .then((number) => {
                this.regularPricesProfitability = number.data;
                this.isRegularPricesProfitabilityCalculated = false;
            })
            .catch((e) => {
                this.showError(this.$t('shared.recommendations.errorCalcRegularProfitability') as string);
                this.isRegularPricesProfitabilityCalculated = false;
            })
    }

    calcRegularPricesProfitabilityForSetupMaster() {
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null || this.regularPricesProfitabilityForSetupMaster != null) {
            return;
        }
        this.isRegularPricesProfitabilityCalculatedForSetupMaster = true;
        const filter = this.getSkuFilterForSetupMaster()
        this.httpGetRegularPricesProfitability(filter)
            .then((number) => {
                this.regularPricesProfitabilityForSetupMaster = number.data;
                this.isRegularPricesProfitabilityCalculatedForSetupMaster = false;
            })
            .catch((e) => {
                this.showError(this.$t('shared.recommendations.errorCalcRegularProfitability') as string);
                this.isRegularPricesProfitabilityCalculatedForSetupMaster = false;
            })
    }

    calcActualProfitability() {
        if (this.$calc.selectMarket.id === -1 || this.$calc.categoryOfProduct == null || this.actualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculated = true;
        if (this.showSku) {
            this.showSku = false
        }
        const filter = this.getSkuFilter()
        this.httpGetActualProfitability(filter)
            .then((number) => {
                this.actualProfitability = number.data;
                this.isActualProfitabilityCalculated = false;
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorCalcActualProfitability') as string);
                this.isActualProfitabilityCalculated = false;
            })
    }

    calcActualProfitabilityForSetupMaster() {
        if (this.$setupMasterCalc.selectMarket.id === -1 || this.$setupMasterCalc.categoryOfProduct == null || this.setupMasterActualProfitability != null) {
            return;
        }
        this.isActualProfitabilityCalculatedForSetupMaster = true;
        const filter = this.getSkuFilterForSetupMaster()
        this.httpGetActualProfitability(filter)
            .then((number) => {
                this.setupMasterActualProfitability = number.data;
                this.isActualProfitabilityCalculatedForSetupMaster = false;
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorCalcActualProfitability') as string);
                this.isActualProfitabilityCalculatedForSetupMaster = false;
            })
    }

    calculateOnlyLastPricesInSku() {
        this.needCalculateSkuLastPricesOnly = true;
        this.refreshSkuList();
        this.calcSkuLastPricesButtonDisabled = true;
    }

    calculateOnlyLastPricesInSkuInPanel() {
        this.needCalculateSkuLastPricesOnly = true;
        this.refreshSkuTableInPanel();
        this.calcSkuLastPricesButtonDisabled = true;
    }

    calculateOnlyActualProfitInSku() {
        this.needCalculateSkuActualProfitabilityOnly = true;
        this.refreshSkuList();
        this.calcSkuActualProfitButtonDisabled = true;
    }

    calculateOnlyActualProfitInSkuInPanel() {
        this.needCalculateSkuActualProfitabilityOnly = true;
        this.refreshSkuTableInPanel();
        this.calcSkuActualProfitButtonDisabled = true;
    }

    onMainTabsChanged(key: string) {
        if (key === 'listOfResults') {
            const rv = this.$refs.resultView as ResultView;
            if (rv.existsUnsavedPrices()) {
                this.$bvModal.msgBoxConfirm(' ' + this.$t('shared.competitorsPricesList.resultsNotRecalculated') as string, {
                    headerBgVariant: 'warning',
                    title: this.$t('shared.competitorsPricesList.attention') as string,
                    size: 'sm',
                    buttonSize: 'sm',
                    okTitle: '{{ $t("shared.labels.yes") }}',
                    cancelTitle: '{{ $t("shared.labels.no") }}',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    noCloseOnEsc: true,
                    noCloseOnBackdrop: true,
                    centered: true,
                })
                    .then((value) => {
                        if (value) {
                            rv.saveCorrectedPrices();
                        } else {
                            rv.clearCalcAllData();
                            this.currentMainTab = key
                        }
                    })
                    .catch((err) => {
                    })

                // evt.preventDefault();
            }
        } else if (key === 'keyMetrics') {
            if (!this.hideTableau()) {
                const script = document.createElement('script');
                script.setAttribute('src', 'https://eu-west-1a.online.tableau.com/javascripts/api/tableau-2.3.0.min.js');
                document.head.appendChild(script);
                const component = this;
                script.addEventListener('load', () => {
                    const container = document.getElementById('tableauContainer');
                    const tableau = (window as any).tableau;
                    const marketName = this.$calc.selectMarket.tradingName
                    const marketId = this.$calc.selectMarket.id
                    const category = this.$calc.categoryOfProduct
                    const categoryOptions = this.taskInfo.categoryOptions
                    const indexCategory = this.taskInfo.categoryOptions.findIndex((item) => {
                        return item.value === category
                    });
                    const options = {
                        device: 'desktop',
                        hideTabs: true,
                        hideToolbar: true,
                        width: '1200px',
                        height: '827px',
                        onFirstInteractive: () => {
                            const sheet = component.viz.getWorkbook().getActiveSheet().getWorksheets();
                            if (marketId !== -1) {
                                sheet[0].applyFilterAsync('Компания', marketName, tableau.FilterUpdateType.REPLACE)
                            } else {
                                sheet[0].clearFilterAsync('Компания')
                            }
                            if (indexCategory !== -1) {
                                sheet[0].applyFilterAsync('Категория товаров', categoryOptions[indexCategory].label, tableau.FilterUpdateType.REPLACE)
                            } else {
                                sheet[0].clearFilterAsync('Категория товаров')
                            }
                        },
                    };
                    component.viz = new tableau.Viz(container, 'https://eu-west-1a.online.tableau.com/t/pbcmanagement/views/SmartPricingPublic/Smartpricing/ivan.snitsky@myretailstrategy.com/835dec7d-26a2-4db1-bdca-0338208a4e40', options);
                    (window as any).vizInstance = component.viz;
                });
            }
        }
    }

    onProductListClicked(key: string) {
        switch (key) {
            case "productList":
                this.ProductsListCurrentTab = key
                this.clearFilters()
                break;
            case "news":
                this.ProductsListCurrentTab = key
                this.loadNewProductsWithoutCalc()
                this.fetchNewProductsList(1)
                break;
            case "productListCTM":
                this.ProductsListCurrentTab = key
                this.clearFiltersInSkuTablePanel()
                this.fetchCtmList(1)
                break;
            default:
                return
        }
    }

    goToParams() {
        this.currentMainTab = "mainParameters"
    }

    goToSkuList(internalCode: string) {
        this.skuFilter = internalCode;
        this.loadSkuWithoutCalc();
        this.tableKey = Math.random();
        this.currentMainTab = "listOfProducts"
        this.refreshSkuTableInPanel();
    }

    private loadCommonParams(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindBaseParams, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const filter = resp.data.filters;
                            this.applyCalcFilters(this.$calc, filter);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => {
                    reject(e)
                })
        });
    }

    private setMasterSetupParamsToCalc() {
        this.updateSelectMarket(this.$setupMasterCalc.selectMarket);
        this.$calc = this.$setupMasterCalc;
    }

    private loadCommonParamsForSetupMaster(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpFindBaseParams, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const filter = resp.data.filters;
                            this.applyCalcFilters(this.$setupMasterCalc, filter);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => {
                    reject(e)
                })
        });
    }

    private loadCommonIndividual(findFilterParams: FindFiltersParams): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.httpExecutor.executeHttp(this.httpLoadBaseIndividual, findFilterParams)
                .then((r) => {
                    if (!r.ignore) {
                        const resp = r.response;
                        if (resp.status === 200) {
                            const params = resp.data;
                            this.applyBaseIndividualConfig(this.$calc, params);
                        }
                    }
                    resolve(!r.ignore);
                })
                .catch((e) => reject(e))
        });
    }

    private refreshSkuList() {
        const oldRefreshId = this.refreshSkuListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshSkuListId === timeoutId) {
                this.skuListCurrentPage = 1;
                const skuTableRef = this.$refs.skuTableRef as BTable;
                if (typeof skuTableRef !== 'undefined') {
                    skuTableRef.$forceUpdate();
                }
                this.refreshSkuListId = -1;
            }
        }, 250);
        this.refreshSkuListId = timeoutId;
        this.isFiltersChanged = 1;
    }

    private refreshSkuTableInPanel() {
        const oldRefreshId = this.refreshSkuListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshSkuListId === timeoutId) {
                this.skuListCurrentPage = 1;
                const skuTableInPanel = this.$refs.skuTableInPanel as BTable;
                if (typeof skuTableInPanel !== 'undefined') {
                    this.ProductsListCurrentTab === "productList" ? this.fetchSkuList() : this.fetchCtmList()
                    skuTableInPanel.$forceUpdate();
                }
                this.refreshSkuListId = -1;
            }
        }, 250);
        this.refreshSkuListId = timeoutId;
        this.isFiltersChanged = 1;
    }

    private refreshNewProductsTable() {
        const oldRefreshId = this.refreshNewProductsListId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshNewProductsListId === timeoutId) {
                this.newProductsListCurrentPage = 1;
                const newProductsTableInPanel = this.$refs.newProductsTableRef as BTable;
                if (typeof newProductsTableInPanel !== 'undefined') {
                    this.fetchNewProductsList()
                    newProductsTableInPanel.$forceUpdate();
                }
                this.refreshNewProductsListId = -1;
            }
        }, 250);
        this.refreshNewProductsListId = timeoutId;
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        // const [, selectRegions] = this.selectData();
        return {
            type: taskType,
            tradingId: this.itemFromList.tradingId as number,
            categories: this.itemFromList.categories.map((el: IidAndName) => el.id),
            groups: this.itemFromList.groups.map((el: IidAndName) => el.id),
            subcategory: !this.itemFromList.subcategory || this.itemFromList.subcategory.id == null || this.itemFromList.subcategory.id <= 0 ? null : [this.itemFromList.subcategory.id],
            segments: null,
            storeFormat: this.itemFromList.format.id || this.itemFromList.format.id <= 0 ? null : [this.itemFromList.format.id],
            storeCluster: this.itemFromList.clusters.map((el: IidAndName) => el.id),
            storeRegion: this.itemFromList.regions.map((el: IidAndName) => el.id),
            byReports: false,
        }
    }

    private getTaskInfoForSetupMaster(taskType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions] = this.selectDataForSetupMaster();
        return {
            type: taskType,
            tradingId: this.$setupMasterCalc.selectMarket.id,
            categories: this.$setupMasterCalc.categoryOfProduct == null || this.$setupMasterCalc.categoryOfProduct <= 0 ? null : [this.$setupMasterCalc.categoryOfProduct],
            groups: this.$setupMasterCalc.groupOfProduct == null || this.$setupMasterCalc.groupOfProduct <= 0 ? null : [this.$setupMasterCalc.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories, true),
            segments: null,
            storeFormat: this.$setupMasterCalc.formatSelected == null || this.$setupMasterCalc.formatSelected <= 0 ? null : [this.$setupMasterCalc.formatSelected],
            storeCluster: this.$setupMasterCalc.clusterSelected == null || this.$setupMasterCalc.clusterSelected <= 0 ? null : [this.$setupMasterCalc.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getTaskInfoForRoundingRules(taskType: TaskInfoFilterType): GetTaskInfo {
        const selectRegions: number[] = (this.$roundingRules.regionSelected.length === 0 || (this.$roundingRules.regionSelected.length && this.$roundingRules.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$roundingRules.regionSelected)!!;
        return {
            type: taskType,
            tradingId: this.$roundingRules.selectMarket.id,
            categories: this.$roundingRules.categoryOfProduct == null || this.$roundingRules.categoryOfProduct <= 0 ? null : [this.$roundingRules.categoryOfProduct],
            groups: this.$roundingRules.groupOfProduct == null || this.$roundingRules.groupOfProduct <= 0 ? null : [this.$roundingRules.groupOfProduct],
            subcategory: LocalData.filterNumberArrays(this.$roundingRules.subcategories, true),
            segments: null,
            storeFormat: this.$roundingRules.formatSelected == null || this.$roundingRules.formatSelected <= 0 ? null : [this.$roundingRules.formatSelected],
            storeCluster: this.$roundingRules.clusterSelected == null || this.$roundingRules.clusterSelected <= 0 ? null : [this.$roundingRules.clusterSelected],
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    private getCalcFilter(): CalcFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const allCheck = this.$calc.allCheck;
        const discountPrice = this.$calc.discountPrice;
        // const pennies = this.$calc.pennies;
        const countAtMaxPurchasePrice = this.$calc.countAtMaxPurchasePrice;
        const countAtFuturePurchasePrice = this.$calc.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.$calc.allNewPricesWithoutPennies;
        const allClaster = this.$calc.allClaster;
        const xyzChecked = this.$calc.xyzChecked;
        const uvwChecked = this.$calc.uvwChecked;
        const individualConfigsObj = Object.create(null);
        // tslint:disable-next-line: forin
        for (const key in this.$calc.individualCommonParams) {
            const value = this.$calc.individualCommonParams[key];
            if (typeof value !== 'undefined' && value !== null) {
                individualConfigsObj[key] = this.prepareIndividualConfig(value);
            }
        }
        return {
            allCheck,
            discountPrise: discountPrice,
            countAtLastPurchasePrice: false,
            countAtFuturePurchasePrice,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: this.$calc.selectCoefficent.value.k1,
            coefficientK2: this.$calc.selectCoefficent.value.k2,
            category: this.$calc.categoryOfProduct,
            productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.$calc.uvwParams,
            spreadXYZParams: this.$calc.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: +this.$calc.calculationDepth,
            correlation: this.$calc.correlation ? this.$calc.correlation : 0.7,
            highElasticity: this.$calc.highElasticity ? this.$calc.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$calc.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$calc.competitorsPrices,
            kviStrategy: this.$calc.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$calc.percentageOfCompetitorsPrice,
            marginalProfitability: this.$calc.marginalProfitability,
            marginalProfit: this.$calc.marginalProfit,
            maxMarginalProfit: this.$calc.maxMarginalProfit != null ? this.$calc.maxMarginalProfit : 100,
            marginalPriceDifference: this.$calc.marginalPriceDifference,
            newProductLifespanInDays: this.$calc.newProductLifespanInDays,
            calculationDay: +this.$calc.calculationDay,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            priceIncreaseLimit: this.$calc.priceIncreaseLimit,
            fixLowerBorder: this.$calc.fixLowerBorder,
            individualCommonParams: individualConfigsObj,
            depthToPurchasePrice: this.$calc.depthToPurchasePrice,
            priceFamilies: this.$calc.priceFamilies,
            hardPriceFamilies: this.$calc.hardPriceFamilies,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$calc.selectCoefficent.value.enum!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            useCompetitorsPrices: this.$calc.useCompetitorsPrices,
            byPromoPrices: this.$calc.byPromoPrices,
            competitorsPricePeriod: this.$calc.competitorsPricePeriod,
            competitorsCodes: this.$calc.competitorsCodes,
            competitorsPriceMethod: this.$calc.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$calc.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$calc.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$calc.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$calc.competitorsMaximumProfit != null ? this.$calc.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$calc.competitorsControlParam,
            competitorsPriceStrategy: this.$calc.competitorsPriceStrategy.value,
            calculateByRegression: !this.$calc.calculateByElasticity,
            recalculateCtm: this.$calc.recalculateCtm,
            priceChangeLimit: this.$calc.priceChangeLimit,
            priceChangeLimitKvi: this.$calc.priceChangeLimitKvi,
            priceChangeLimitComp: this.$calc.priceChangeLimitComp,
            useBrutForcingParams: this.useBrutForcingParams,
            saveAfterOptimize: this.saveAfterOptimize,
            optimizationDiff: this.optimizationDiff,
            calculatePYR: this.$calc.calculatePYR,
            periodPriceIncreaseLimit: this.$calc.periodPriceIncreaseLimit,
            period: this.$calc.period.value,
            decreaseSalesCount: this.$calc.decreaseSalesCount,
            newProductPriceStrategy: this.$calc.newProductPriceStrategy.value,
            priceGap: this.$calc.priceGap,
            priceGapCtmPc: this.$calc.priceGapCtmPc,
            findAutomaticallyPriceSegments: this.findAutomaticallyPriceSegments,
            countPriceSegments: this.countPriceSegments,
            promoCalc: false,
            percentageOfRecommendsKviCount: this.$calc.percentageOfRecommendsKviCount,
            saveKviSign: this.$calc.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$calc.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$calc.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$calc.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$calc.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteCtmPurpose,
            calculateCompAllowedDeviation: this.$calc.calculateCompAllowedDeviation,
            useCompElasticity: this.$calc.useCompElasticity,
            minProfitKVI: this.$calc.minProfitKVI,
            maxProfitKVI: this.$calc.maxProfitKVI != null ? this.$calc.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            forecastAccuracy: this.$calc.forecastAccuracy,
            countAtMaxPurchasePrice,
            percentileType: this.$calc.percentileType.value,
            useAllProductBatchNumbers: this.$calc.useAllProductBatchNumbers,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: this.$calc.competitorPriceControlParameterPc,
            countPriceBySkuWithoutBatches: this.$calc.countPriceBySkuWithoutBatches,
            countByAvgPurchasePrice: this.$calc.countByAvgPurchasePrice,
            calcPurchasePriceByClusters: this.$calc.calcPurchasePriceByClusters,
            useEmptyRemains: this.$calc.useEmptyRemains,
            useArrivalDate: this.$calc.useArrivalDate,
            thompsonSampling: this.$calc.thompsonSampling,
            priceDecreaseLimit: this.$calc.priceDecreaseLimit,
            kviPriceDecreaseLimit: this.$calc.kviPriceDecreaseLimit,
            compPriceDecreaseLimit: this.$calc.compPriceDecreaseLimit,
            backBasketPart: this.$calc.backBasketPart,
            revaluationCalculateParams: this.$calc.revaluationCalculateParams,
            checkMarginDeclineProfit: this.$calc.checkMarginDeclineProfit,
            declineProfitabilityPc: this.$calc.declineProfitabilityPc,
            searchPreviousPricesDepth: this.$calc.searchPreviousPricesDepth,
            compensateLowerTargets: this.$calc.compensateLowerTargets,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            inflation: this.$calc.inflation,
            calculateBySpeedSale: this.$calc.calculateBySpeedSale,
            applyOmnichannel: this.$calc.applyOmnichannel,
            purchasePriceSuppliers: this.$calc.purchasePriceSuppliers,
            purchasePriceSuppliersWithRemains: this.$calc.purchasePriceSuppliersWithRemains,
            categoryOfSuppliers: this.$calc.categoryOfSuppliers!!.value,
            purchasePriceSuppliersMinProfit: this.$calc.purchasePriceSuppliersMinProfit,
            purchasePriceSuppliersMinProfitForKVI: this.$calc.purchasePriceSuppliersMinProfitForKVI,
            purchasePriceSuppliersMinProfitForCompetitors: this.$calc.purchasePriceSuppliersMinProfitForCompetitors,
            sendGeneratedReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.$calc.isFixPricePromo,
            spreadByPriceSegments: this.$calc.spreadByPriceSegments,
        };
    }

    private getCalcFilterForSetupMaster(): CalcFilters {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForSetupMaster();
        const allCheck = this.$setupMasterCalc.allCheck;
        const discountPrice = this.$setupMasterCalc.discountPrice;
        // const pennies = this.$setupMasterCalc.pennies;
        const countAtMaxPurchasePrice = this.$setupMasterCalc.countAtMaxPurchasePrice;
        const countAtFuturePurchasePrice = this.$setupMasterCalc.countAtFuturePurchasePrice;
        // const allNewPricesWithoutPennies = this.$setupMasterCalc.allNewPricesWithoutPennies;
        const allClaster = this.$setupMasterCalc.allClaster;
        const xyzChecked = this.$setupMasterCalc.xyzChecked;
        const uvwChecked = this.$setupMasterCalc.uvwChecked;
        const individualConfigsObj = Object.create(null);
        return {
            allCheck,
            discountPrise: discountPrice,
            // pennies,
            countAtLastPurchasePrice: false,
            countAtFuturePurchasePrice,
            // allNewPricesWithoutPennies,
            xyzChecked,
            uvwChecked,
            allClaster,
            coefficientK1: this.$setupMasterCalc.selectCoefficent.value.k1,
            coefficientK2: this.$setupMasterCalc.selectCoefficent.value.k2,
            category: this.$setupMasterCalc.categoryOfProduct,
            storeCluster: this.$setupMasterCalc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            spreadUVWParams: this.$setupMasterCalc.uvwParams,
            spreadXYZParams: this.$setupMasterCalc.xyzParams,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$setupMasterCalc.formatSelected,
            tradingId: this.$setupMasterCalc.selectMarket.id,
            calculationDepth: +this.$setupMasterCalc.calculationDepth,
            correlation: this.$setupMasterCalc.correlation ? this.$setupMasterCalc.correlation : 0.7,
            highElasticity: this.$setupMasterCalc.highElasticity ? this.$setupMasterCalc.highElasticity : -0.5,
            intervalOfUltimateElasticity: this.$setupMasterCalc.intervalOfUltimateElasticity,
            competitorsPricesParams: this.$setupMasterCalc.competitorsPrices,
            kviStrategy: this.$setupMasterCalc.kviStrategy.value,
            percentageOfCompetitorsPrice: this.$setupMasterCalc.percentageOfCompetitorsPrice,
            marginalProfitability: this.$setupMasterCalc.marginalProfitability,
            marginalProfit: this.$setupMasterCalc.marginalProfit,
            maxMarginalProfit: this.$setupMasterCalc.maxMarginalProfit != null ? this.$setupMasterCalc.maxMarginalProfit : 100,
            marginalPriceDifference: this.$setupMasterCalc.marginalPriceDifference,
            newProductLifespanInDays: this.$setupMasterCalc.newProductLifespanInDays,
            calculationDay: +this.$setupMasterCalc.calculationDay,
            priceCorridor: this.$setupMasterCalc.priceCorridor,
            changePriceCorridor: this.$setupMasterCalc.changePriceCorridor,
            priceIncreaseLimit: this.$setupMasterCalc.priceIncreaseLimit,
            fixLowerBorder: this.$setupMasterCalc.fixLowerBorder,
            individualCommonParams: individualConfigsObj,
            depthToPurchasePrice: this.$setupMasterCalc.depthToPurchasePrice,
            priceFamilies: this.$setupMasterCalc.priceFamilies,
            hardPriceFamilies: this.$setupMasterCalc.hardPriceFamilies,
            groupOfProduct: this.$setupMasterCalc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            priceOpt: this.$setupMasterCalc.selectCoefficent.value.enum!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories)!!,

            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$setupMasterCalc.productSegments)!!,
            useCompetitorsPrices: this.$setupMasterCalc.useCompetitorsPrices,
            byPromoPrices: this.$setupMasterCalc.byPromoPrices,
            competitorsPricePeriod: this.$setupMasterCalc.competitorsPricePeriod,
            competitorsCodes: this.$setupMasterCalc.competitorsCodes,
            competitorsPriceMethod: this.$setupMasterCalc.competitorsPriceMethod.value,
            competitorsPriceAdjustment: this.$setupMasterCalc.competitorsPriceAdjustment,
            competitorsInfluencesCoef: this.$setupMasterCalc.competitorsInfluencesCoef,
            competitorsMinimumProfit: this.$setupMasterCalc.competitorsMinimumProfit,
            competitorsMaximumProfit: this.$setupMasterCalc.competitorsMaximumProfit != null ? this.$setupMasterCalc.competitorsMaximumProfit : 100,
            competitorsControlParam: this.$setupMasterCalc.competitorsControlParam,
            competitorsPriceStrategy: this.$setupMasterCalc.competitorsPriceStrategy.value,
            calculateByRegression: !this.$setupMasterCalc.calculateByElasticity,
            recalculateCtm: this.$setupMasterCalc.recalculateCtm,
            priceChangeLimit: this.$setupMasterCalc.priceChangeLimit,
            priceChangeLimitKvi: this.$setupMasterCalc.priceChangeLimitKvi,
            priceChangeLimitComp: this.$setupMasterCalc.priceChangeLimitComp,
            useBrutForcingParams: false,
            saveAfterOptimize: this.saveAfterOptimizeForSetupMaster,
            optimizationDiff: this.optimizationDiffForSetupMaster,
            calculatePYR: this.$setupMasterCalc.calculatePYR,
            periodPriceIncreaseLimit: this.$setupMasterCalc.periodPriceIncreaseLimit,
            period: this.$setupMasterCalc.period.value,
            decreaseSalesCount: this.$setupMasterCalc.decreaseSalesCount,
            newProductPriceStrategy: this.$setupMasterCalc.newProductPriceStrategy.value,
            priceGap: this.$setupMasterCalc.priceGap,
            priceGapCtmPc: this.$setupMasterCalc.priceGapCtmPc,
            findAutomaticallyPriceSegments: this.findAutomaticallyPriceSegmentsForSetupMaster,
            countPriceSegments: this.countPriceSegmentsForSetupMaster,
            promoCalc: false,
            percentageOfRecommendsKviCount: this.$setupMasterCalc.percentageOfRecommendsKviCount,
            saveKviSign: this.$setupMasterCalc.saveKviSign,
            useSegmentsPriceInSearchKVIRecParam: this.$setupMasterCalc.useSegmentsPriceInSearchKVIRecParam,
            categoryStrategy: this.$setupMasterCalc.categoryStrategy.value,
            useCompetitorsForKviRecommends: this.$setupMasterCalc.useCompetitorsForKviRecommends,
            competitorsPeriodForKviRecommends: this.$setupMasterCalc.competitorsPeriodForKviRecommends,
            productCodesForAddKvi: this.productCodesForAddKvi,
            productCodesForDeleteKvi: this.productCodesForDeleteKvi,
            productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
            productCodesForDeleteCtmPurpose: this.productCodesForDeleteCtmPurpose,
            // roundPricesWithEqualCompStrategy: this.$setupMasterCalc.roundPricesWithEqualCompStrategy,
            calculateCompAllowedDeviation: this.$setupMasterCalc.calculateCompAllowedDeviation,
            useCompElasticity: this.$setupMasterCalc.useCompElasticity,
            minProfitKVI: this.$setupMasterCalc.minProfitKVI,
            maxProfitKVI: this.$setupMasterCalc.maxProfitKVI != null ? this.$setupMasterCalc.maxProfitKVI : 100,
            productRangesAndInternalCodes: this.productRangesArray,
            forecastAccuracy: this.$setupMasterCalc.forecastAccuracy,
            countAtMaxPurchasePrice,
            percentileType: this.$setupMasterCalc.percentileType.value,
            useAllProductBatchNumbers: this.$setupMasterCalc.useAllProductBatchNumbers,
            calcWithBatchNumber: true,
            competitorPriceControlParameterPc: this.$setupMasterCalc.competitorPriceControlParameterPc,
            countPriceBySkuWithoutBatches: this.$setupMasterCalc.countPriceBySkuWithoutBatches,
            countByAvgPurchasePrice: this.$setupMasterCalc.countByAvgPurchasePrice,
            calcPurchasePriceByClusters: this.$setupMasterCalc.calcPurchasePriceByClusters,
            useEmptyRemains: this.$setupMasterCalc.useEmptyRemains,
            useArrivalDate: this.$setupMasterCalc.useArrivalDate,
            thompsonSampling: this.$setupMasterCalc.thompsonSampling,
            priceDecreaseLimit: this.$setupMasterCalc.priceDecreaseLimit,
            kviPriceDecreaseLimit: this.$setupMasterCalc.kviPriceDecreaseLimit,
            compPriceDecreaseLimit: this.$setupMasterCalc.compPriceDecreaseLimit,
            backBasketPart: this.$setupMasterCalc.backBasketPart,
            revaluationCalculateParams: this.$setupMasterCalc.revaluationCalculateParams,
            checkMarginDeclineProfit: this.$setupMasterCalc.checkMarginDeclineProfit,
            declineProfitabilityPc: this.$setupMasterCalc.declineProfitabilityPc,
            searchPreviousPricesDepth: this.$setupMasterCalc.searchPreviousPricesDepth,
            compensateLowerTargets: this.$setupMasterCalc.compensateLowerTargets,
            roundPricesWithEqualCompStrategy: this.$roundingRules.roundPricesWithEqualCompStrategy,
            isFixPricePromo: this.$setupMasterCalc.isFixPricePromo,
            spreadByPriceSegments: this.$setupMasterCalc.spreadByPriceSegments,
        };
    }

    private getSkuFilter(): SkuFilter {
        const productSegments = this.selectProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];
        const [selectSeasons, selectRegions, selectBuyerSegment, ctm, priceSegments] = this.selectData();
        return {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.skuFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm,
            priceSegments,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.skuListWithCalculating,
            needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
            needCalculateSkuActualProfitabilityOnly: this.needCalculateSkuActualProfitabilityOnly,
            kviRecommendation: this.selectKVIRecommends,
            productSegments: LocalData.filterNumberArrays(productSegments),
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
            keyCharacteristicOfTheProductIsThree: this.selectKeyCharacteristicThree,
            keyCharacteristicOfTheProductIsFour: this.selectKeyCharacteristicFour,
            keyCharacteristicOfTheProductIsFive: this.selectKeyCharacteristicFive,
            recipeAttributes: this.selectRecipeAttributes,
            treatmentAttributes: this.selectTreatmentAttributes,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.$calc.countAtLastPurchasePrice,
            productRangeFilter: this.selectProductLine,
            countAtMaxPurchasePrice: this.$calc.countAtMaxPurchasePrice,
        };
    }

    private getSkuFilterForSetupMaster(): SkuFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectDataForSetupMaster();
        return {
            category: this.$setupMasterCalc.categoryOfProduct,
            storeCluster: this.$setupMasterCalc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$setupMasterCalc.formatSelected,
            tradingId: this.$setupMasterCalc.selectMarket.id,
            calculationDepth: this.$setupMasterCalc.calculationDepth,
            calculationDay: this.$setupMasterCalc.calculationDay,
            skuFilter: '',
            groupOfProduct: this.$setupMasterCalc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$setupMasterCalc.subcategories)!!,
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: LocalData.filterNumberArrays(this.$setupMasterCalc.productSegments)!!,
            discountPrise: false,
            promo: false,
            priceCorridor: this.$setupMasterCalc.priceCorridor,
            changePriceCorridor: this.$setupMasterCalc.changePriceCorridor,
            alwaysCalculateProductSegments: true,
            countAtLastPurchasePrice: this.$setupMasterCalc.countAtLastPurchasePrice,
            countAtMaxPurchasePrice: this.$setupMasterCalc.countAtMaxPurchasePrice,
        };
    }

    private getNewProductsSkuFilter(): SkuFilter {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = this.selectCTMForNewProducts === 'all' ? null : this.selectCTMForNewProducts;
        this.selectSegmentPriceForNewProducts = this.selectSegmentPriceForNewProducts.filter((item) => {
            return item.name !== 'All'
        });
        const priceSegments: Segment[] | null = this.selectSegmentPriceForNewProducts.map((i) => {
            return {name: i.name, minSegment: i.minSegment, maxSegment: i.maxSegment};
        });

        const newProductSegments = this.selectNewProductSegmentIdAndName.map((i) => i.segmentId).filter((it) => it !== null) as number[];

        return {
            category: this.$calc.categoryOfProduct,
            storeCluster: this.$calc.clusterSelected,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            groupsOfProduct: [],
            categories: [],
            storeFormat: this.$calc.formatSelected,
            tradingId: this.$calc.selectMarket.id,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.newProductsFilter,
            groupOfProduct: this.$calc.groupOfProduct,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortingNewProductsBySKU,
            kvi: this.selectKVIForNewProducts,
            ctm,
            priceSegments,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOneForNewProduct,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwoForNewProduct,
            keyCharacteristicOfTheProductIsThree: this.selectKeyCharacteristicThreeForNewProduct,
            keyCharacteristicOfTheProductIsFour: this.selectKeyCharacteristicFourForNewProduct,
            keyCharacteristicOfTheProductIsFive: this.selectKeyCharacteristicFiveForNewProduct,
            recipeAttributes: this.selectRecipeAttributesForNewProduct,
            treatmentAttributes: this.selectTreatmentAttributesForNewProduct,
            priceCorridor: this.$calc.priceCorridor,
            changePriceCorridor: this.$calc.changePriceCorridor,
            needCalculateSku: this.newProductsWithCalculating,
            productSegments: LocalData.filterNumberArrays(newProductSegments),
            alwaysCalculateProductSegments: true,
        };
    }

    private getCompetitorsFilter(): CompetitorsPriceFilter & { regionSelected: number | null } {
        const [selectSeasons, selectRegions, selectBuyerSegment] = this.selectData();
        const ctm: string | null = this.selectedCtmFilter === 'all' ? null : this.selectedCtmFilter;
        return {
            discountPrise: true, // this.$calc.discountPrice
            category: null,
            storeCluster: null,
            storeClusters: this.itemFromList.clusters ? this.itemFromList.clusters.map((el: IidAndName) => el.id).realValuesOrEmpty() : [],
            seasonValues: [], //selectSeasons
            buyerSegments: [], // selectBuyerSegment
            storeRegionValues: this.itemFromList.regions ? this.itemFromList.regions.map((el: IidAndName) => el.id).realValuesOrEmpty() : [],
            groupsOfProduct: this.itemFromList.groups.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            categories: this.itemFromList.categories.map((el: IidAndName) => el.id).realValuesOrEmpty(),
            storeFormat: this.itemFromList.format.id,
            regionSelected: null,
            tradingId: this.itemFromList.tradingId as number,
            calculationDepth: 4,
            calculationDay: this.moduleData.calculationDay,
            skuFilter: '',
            groupOfProduct: null,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: !this.itemFromList.subcategory || this.itemFromList.subcategory.id == null || this.itemFromList.subcategory.id <= 0 ? null : [this.itemFromList.subcategory.id],
            // tslint:disable-next-line: no-non-null-assertion
            productSegments: [], // LocalData.filterNumberArrays(this.$calc.productSegments)!!
            competitorsPricePeriod: this.moduleData.competitorsPricePeriod,
            promo: false,
            isKviCartCompetitorsGrid: false,

            // discountPrise: this.$calc.discountPrice,
            // category: this.$calc.categoryOfProduct,
            // storeCluster: this.$calc.clusterSelected,
            // seasonValues: selectSeasons,
            // buyerSegments: selectBuyerSegment,
            // storeRegionValues: selectRegions,
            // groupsOfProduct: [],
            // categories: [],
            // storeFormat: this.$calc.formatSelected,
            // tradingId: this.$calc.selectMarket.id,
            // calculationDepth: +this.$calc.calculationDepth,
            // calculationDay: +this.$calc.calculationDay,
            // skuFilter: this.skuFilter,
            // groupOfProduct: this.$calc.groupOfProduct,
            // // tslint:disable-next-line: no-non-null-assertion
            // subcategories: LocalData.filterNumberArrays(this.$calc.subcategories)!!,
            // // tslint:disable-next-line: no-non-null-assertion
            // productSegments: LocalData.filterNumberArrays(this.$calc.productSegments)!!,
            // competitorsPricePeriod: this.$calc.competitorsPricePeriod,
            // promo: false,

            sortBySKU: this.sortCompetitorsBySKU,
            kvi: this.selectedKviFilter,
            ctm,
            keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOneForCompetitors,
            keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwoForCompetitors,
            needCalculateSku: this.competitorsWithCalculating,
            sortingField: this.sortingField,
        };
    }

    private refreshDetailTable() {
        const oldRefreshId = this.refreshCodeOKRBTableId;
        if (oldRefreshId !== -1) {
            clearTimeout(oldRefreshId);
        }
        const timeoutId = setTimeout(() => {
            if (this.refreshCodeOKRBTableId === timeoutId) {
                const detailTable = this.$refs.codeOKRBTable as any;
                if (typeof detailTable !== 'undefined') {
                    this.loadCodesOKRB()
                    detailTable.refresh();
                }
                this.refreshCodeOKRBTableId = -1;
            }
        }, 250);
        this.refreshCodeOKRBTableId = timeoutId;
    }

}
